import React, { useState, useRef, useEffect, useContext } from "react";
import axios from 'axios';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Icons } from "../../assest/icons";
import Header from './header';
import { logger } from '../../utils/logger';
import SideBarMenu from './sideBarMenu';
import moment from 'moment';
import LoaderSpinner from '../loaderSpinner';
import { SearchContext } from './SearchContext';
import Modal from 'react-modal';
import {
  getUser,
  getIllnesses,
  getInsuranceData,
  getUserSessions,
  getChatSession,
  getAllFollowupRequests,
  getActiveFollowupRequest,
  getMedicalReports,
  getPCPPharmacyDetails,
  getPCPPharmacyByUserId,
  createAdminLog,
  getAdminViewedSessionIds,
  updateChatSession,
  updatePhysicalExam,
  updatePatientStatus,
  updateSessionDuration,
  updateFollowupCD,
  updateFollowupPoC,
  updateFollowupSummary,
  updateFollowupReportIds,
  getAdminsByRole,
  createMedicalReport,
  updateMedicalReportSummary,
  getFollowupReports,
} from '../../services/firestore';
import {
  createZoomMeeting,
  createFollowupZoomMeeting,
  processZoomMeeting,
  deleteZoomMeeting
} from '../../services/zoomService';
import { deleteUser } from '../../services/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase.config';
import { canEditClinical, isMA, isAdmin, isDoctor } from '../../utils/roleHelper';
import { fetchWithAppCheck } from '../../utils/fetchWithAppCheck';
import { sendPatientReport, sendBulkEmails } from '../../services/sendgridService';
import { downloadPatientFHIRBundle, saveFHIRCondition, saveFHIRCarePlan, saveFHIRVitalSignsFromExam } from '../../services/fhirService';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import html2pdf from "html-to-pdf-js";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import generatePDF, { Resolution, Margin, Options } from "react-to-pdf";
// import PDFViewer from './PDFViewer';

import HeightFormatter, { formatHeight } from '../HeightFormatter';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import AbdominalCT from '../../assest/document/AIGICare_PDF_AbdominalCT.pdf';
import AbdominalUS from '../../assest/document/AIGICare_PDF_AbdominalUS.pdf';
import AnemiaLabs from '../../assest/document/AIGICare_PDF_AnemiaLabs.pdf';
import BariumStudies from '../../assest/document/AIGICare_PDF_BariumStudies.pdf';
import BasicGastroLabs from '../../assest/document/AIGICare_PDF_BasicGastroLabs.pdf';
import ColonOrder from '../../assest/document/AIGICare_PDF_Colon_Order.pdf';
import Colonoscopy from '../../assest/document/AIGICare_PDF_Colonoscopy.pdf';
import ColonScreeningGuidelines from '../../assest/document/AIGICare_PDF_ColonScreeningGuidelines.pdf';
import Diverticulosis from '../../assest/document/AIGICare_PDF_Diverticulosis.pdf';
import EGDOrder from '../../assest/document/AIGICare_PDF_EGD_Order.pdf';
import FattyLiver from '../../assest/document/AIGICare_PDF_FattyLiver.pdf';
import FODMAP_Diet from '../../assest/document/AIGICare_PDF_FODMAP_Diet.pdf';
import GERD_Diet_and_Lifestyle from '../../assest/document/AIGICare_PDF_GERD_Diet_and_Lifestyle.pdf';
import HeapticLabs from '../../assest/document/AIGICare_PDF_HeapticLabs.pdf';
import High_Fiber_Diet from '../../assest/document/AIGICare_PDF_High_Fiber_Diet.pdf';
import InflammatoryBowelDisease from '../../assest/document/AIGICare_PDF_InflammatoryBowelDisease.pdf';
import IrritableBowelSyndrome from '../../assest/document/AIGICare_PDF_IrritableBowelSyndrome.pdf';
import ProceduralSedation from '../../assest/document/AIGICare_PDF_ProceduralSedation.pdf';
import StoolStudies from '../../assest/document/AIGICare_PDF_StoolStudies.pdf';
import StressManagement from '../../assest/document/AIGICare_PDF_StressManagement.pdf';
import TelehealthDisclaimer from '../../assest/document/AIGICare_PDF_TelehealthDisclaimer.pdf';
import UpperGIEndoscopy from '../../assest/document/AIGICare_PDF_UpperGIEndoscopy.pdf';
import Weight_Reducing_Diet from '../../assest/document/AIGICare_PDF_Weight_Reducing_Diet.pdf';





// Set the app element for accessibility (react-modal requirement)
Modal.setAppElement('#root');

// Extracts a section from the chatbot AI summary text by keyword(s)
const extractChatbotSection = (summary, ...keywords) => {
  if (!summary) return '';
  const lines = summary.split('\n');
  let capturing = false;
  const result = [];
  // Matches any ALL-CAPS section header (e.g. "ALLERGIES:", "CURRENT MEDICATIONS: text")
  const anySectionHeader = /^[A-Z][A-Z\s,/&()+\-]{3,}:/;
  for (const line of lines) {
    const trimmed = line.trim();
    // Check if this line matches one of our target keyword headers
    if (keywords.some(kw => new RegExp('^' + kw + '\\s*:', 'i').test(trimmed))) {
      capturing = true;
      // Also capture any content that appears after the colon on the same line
      const colonIdx = trimmed.indexOf(':');
      if (colonIdx !== -1) {
        const afterColon = trimmed.slice(colonIdx + 1).trim();
        if (afterColon) result.push(afterColon);
      }
      continue;
    }
    // Stop when we hit any other ALL-CAPS section header
    if (capturing && anySectionHeader.test(trimmed)) break;
    if (capturing && trimmed) result.push(line);
  }
  return result.join('\n').trim();
};

const renderAISummary = (text) => {
  if (!text) return null;
  const lines = text.split('\n');
  const elements = [];
  const renderBold = (line) => {
    const parts = line.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, idx) => idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part);
  };
  lines.forEach((line, i) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    if (/^\d+\.\s+/.test(trimmed) || /^[A-Z][A-Z\s,/&]+:/.test(trimmed)) {
      const cleanedTrimmed = trimmed.replace(/^\d+[\.\)]\s*/, '');
      const colonIdx = cleanedTrimmed.indexOf(':');
      const headingPart = colonIdx !== -1 ? cleanedTrimmed.slice(0, colonIdx + 1) : cleanedTrimmed;
      const descPart = colonIdx !== -1 ? cleanedTrimmed.slice(colonIdx + 1).trim() : '';
      elements.push(
        <div key={`h-${i}`} style={{marginTop:'14px', marginBottom:'5px', borderBottom:'1px solid #e3eaf5', paddingBottom:'3px'}}>
          <span style={{fontWeight:'700', color:'#024C9C', fontSize:'14px'}}>{renderBold(headingPart)}</span>
          {descPart && <span style={{fontWeight:'400', color:'#222', fontSize:'14px'}}> {renderBold(descPart)}</span>}
        </div>
      );
    } else if (/^[•\-]\s+/.test(trimmed)) {
      const cleanLine = trimmed.replace(/^[•\-]\s+/, '');
      if (cleanLine) elements.push(
        <div key={`b-${i}`} style={{display:'flex', alignItems:'flex-start', margin:'4px 0 4px 8px', lineHeight:'1.6'}}>
          <span style={{marginRight:'8px', color:'#024C9C', fontWeight:'700'}}>•</span>
          <span>{renderBold(cleanLine)}</span>
        </div>
      );
    } else {
      const cleanLine = trimmed.replace(/^\*+\s*/, '');
      if (cleanLine) elements.push(<p key={`p-${i}`} style={{margin:'3px 0 3px 4px', lineHeight:'1.5'}}>{renderBold(cleanLine)}</p>);
    }
  });
  return <div style={{fontSize:'13.5px'}}>{elements}</div>;
};

const AccordionSection = ({ title, content, onEditClick, onSaveClick, onCancelClick, showLoader, isEditing, value, onChange, EmergencyQuest, Icons, isActive,
  setActiveAccordion }) => {

  // Sanitize the title to make it a valid selector
  const sanitizedTitle = title.replace(/\s+/g, '_'); // Replace spaces with underscores

  const handleAccordionClick = () => {
    // Toggle the accordion: close it if already active, otherwise open it
    if (setActiveAccordion) {
      setActiveAccordion(isActive ? null : sanitizedTitle);
    }
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading-${sanitizedTitle}`}>
        <button
          className={`accordion-button ${isActive ? '' : 'collapsed'}`}
          type="button"
          onClick={(e) => {
            e.preventDefault(); // Prevent default button behavior
            handleAccordionClick(); // Explicitly call the handler
          }}
          aria-expanded={isActive ? 'true' : 'false'}
          aria-controls={`collapse-${sanitizedTitle}`}
        >
          {title}
        </button>
      </h2>
      <div
        id={`collapse-${sanitizedTitle}`}
        className={`accordion-collapse collapse ${isActive ? 'show' : ''}`}
        aria-labelledby={`heading-${sanitizedTitle}`}
        data-bs-parent="#accordionExampleNew"
      >
        <div className="accordion-body">

          {!EmergencyQuest && (
            <a
              onClick={onEditClick}
              style={{ marginLeft: '10px', cursor: 'pointer' }}
              className="editBtnInner"
            >
              Edit <img src={!isEditing ? Icons[0].editIcon : Icons[0].editRed} />
            </a>
          )}

          {!isEditing ? (
            <pre className="innerDivBoxPC h-auto overflow-hidden">
              {content}
            </pre>
          ) : (
            <div className="textareaSummary innerDivBox w-100">
              <textarea
                value={value}
                onChange={onChange}
                style={{ height: '80%', width: '100%' }}
              />
              <hr />
              <div className="editSaveOpt">
                {showLoader ? (
                  <>
                    <button> Loading
                      <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </button>
                  </>
                ) : (
                  <>
                    <button onClick={onSaveClick}>Save Changes</button>
                  </>
                )}
                <button onClick={onCancelClick}>Cancel</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const AccordionSectionPoC = ({ title, content, onEditClick, onSaveClick, onCancelClick, showLoader, isEditing, value, onChange, EmergencyQuest, Icons, isActive,
  setActiveAccordionPoc }) => {
  // Sanitize the title to make it a valid selector
  const sanitizedTitle = title.replace(/\s+/g, '_'); // Replace spaces with underscores

  const handleAccordionClickPoc = () => {
    // Toggle the accordion: close it if already active, otherwise open it
    if (setActiveAccordionPoc) {
      setActiveAccordionPoc(isActive ? null : sanitizedTitle);
    }
  };



  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`headingPoc-${sanitizedTitle}`}>
        <button
          className={`accordion-button ${isActive ? '' : 'collapsed'}`}
          type="button"
          onClick={(e) => {
            e.preventDefault(); // Prevent default button behavior
            handleAccordionClickPoc(); // Explicitly call the handler
          }}
          aria-expanded={isActive ? 'true' : 'false'}
          aria-controls={`collapse-${sanitizedTitle}`}
        >
          {title}
        </button>
      </h2>
      <div
        id={`collapse-${sanitizedTitle}`}
        className={`accordion-collapse collapse ${isActive ? 'show' : ''}`}
        aria-labelledby={`heading-${sanitizedTitle}`}
        data-bs-parent="#accordionExample"

      >
        <div className="accordion-body">

          {!EmergencyQuest && (
            <a
              onClick={onEditClick}
              style={{ marginLeft: '10px', cursor: 'pointer' }}
              className="editBtnInner"
            >
              Edit <img src={!isEditing ? Icons[0].editIcon : Icons[0].editRed} />
            </a>
          )}

          {!isEditing ? (
            <pre className="innerDivBoxPC h-auto overflow-hidden">
              {content}
            </pre>
          ) : (
            <div className="textareaSummary innerDivBox w-100">
              <textarea
                value={value}
                onChange={onChange}
                style={{ height: '80%', width: '100%' }}
              />
              <hr />
              <div className="editSaveOpt">
                {showLoader ? (
                  <>
                    <button> Loading
                      <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </button>
                  </>
                ) : (
                  <>
                    <button onClick={onSaveClick}>Save Changes</button>
                  </>
                )}
                <button onClick={onCancelClick}>Cancel</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


function ViewPatientProfile() {
  let navigate = useNavigate();
  let navigate1 = useNavigate();



  const routeChange = () => {
    localStorage.removeItem('adminCurrentPatientId');
    sessionStorage.removeItem('adminViewPatientId');
    navigate('/admin/dashboard', {
      state: { backCurrentPage: backCurrentPage, searchTxt: searchTxtCheck }
    });
  }
  const location = useLocation();
  const scrollupRef = useRef(null); // Create ref for scroll-up element
  const inflightSummaryRef = useRef({}); // Track in-flight AI summary requests per session_id
  const inflightFinalNoteRef = useRef({}); // Track in-flight Final Consultant Note requests per session_id
  const inflightFollowupProcessRef = useRef({}); // Track in-flight followup meeting processing per followup_id
  const [active, setActive] = useState(''); // Track active accordion section

  const handleAccordionClick = (title) => {
    // Scroll to the top of the page or a specific section
    if (scrollupRef.current) {
      scrollupRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'start', // Align to the top of the viewport
      });
    }
  };
  const handleAccordionClickPoc = (title) => {
    // Scroll to the top of the page or a specific section
    if (scrollupRef.current) {
      scrollupRef.current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'start', // Align to the top of the viewport
      });
    }
  };
  const { id: _stateId, currentPageNo, searchString } = location.state || {};
  // Read patient ID from URL query param first (survives refresh natively)
  const _urlId = new URLSearchParams(location.search).get('pid') || undefined;
  // Resolve patient ID with priority: URL param > location.state > localStorage > sessionStorage
  const id = _urlId || _stateId || localStorage.getItem('adminCurrentPatientId') || sessionStorage.getItem('adminViewPatientId') || undefined;
  // Persist to both storages so subpage back-buttons work too
  if (id) {
    localStorage.setItem('adminCurrentPatientId', id);
    sessionStorage.setItem('adminViewPatientId', id);
  }

  // Redirect to dashboard if no patient ID is available from any source
  useEffect(() => {
    if (!id) {
      toast.error('No patient selected. Redirecting to dashboard...');
      setTimeout(() => {
        navigate('/admin/dashboard');
      }, 2000);
    }
  }, [id, navigate]);

  const [ShowLoaderPage, setShowLoaderPage] = useState(false);
  const [userid, setuserid] = useState(id);
  const [isDownloadingFHIR, setIsDownloadingFHIR] = useState(false);
  const [adminId, setAdminId] = useState(JSON.parse(localStorage.getItem('UserIdAdmin')));
  const adminProfile = JSON.parse(localStorage.getItem('UserProfileAdmin') || '{}');
  const providerName = adminProfile?.fullName || adminProfile?.name || adminProfile?.email || '';
  const providerSpecialty = adminProfile?.specialty || '';
  const providerPhone = adminProfile?.phoneNumber || '';
  const providerSignature = adminProfile?.signatureUrl || '';

  const [searchTxtCheck, setSearchTxtCheck] = useState(searchString);

  const [backCurrentPage, setcurrentPageNo] = useState(currentPageNo);
  const [userProfileData, setUserProfileData] = useState([]);
  const [UserHistoryData, setUserHistoryData] = useState([]);
  const [UserHistoryNumber, setUserHistoryNumber] = useState('');
  const [ChatHistory, setChatHistory] = useState([]);
  const [RecordData, setRecordData] = useState([]);
  const [BackReload, setBackReload] = useState(false);
  const [viewedSessionMap, setViewedSessionMap] = useState({});
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [shareEmail, setShareEmail] = useState([]);
  const [emailList, setEmailList] = useState("");
  const [responseEmail, setResponseEmail] = useState(null);
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [isLoadingEmailP, setIsLoadingEmailP] = useState(false);

  const [isRegeneratingAI, setIsRegeneratingAI] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userProfile, setUserProfile] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [selectedToggle, setSelectedToggle] = useState(true);
  const [DOBTxt, setDOBTxt] = useState('');
  const [InsuranceIdTxt, setInsuranceIdTxt] = useState('');
  const [GenderTxt, setGenderTxt] = useState('');
  const [originalProfile, setOriginalProfile] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingCD, setIsEditingCD] = useState(false);
  const [isEditingFollowCD, setIsEditingFollowCD] = useState(false);
  const [isEditingFollowPoC, setIsEditingFollowPoC] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  var years = moment().diff(DOBTxt);
  const ageCal = moment().diff(DOBTxt, 'years');
  const [BMITxt, setBMITxt] = useState('');

  const [AgeTxt, setAgeTxt] = useState(ageCal);
  const [WeightTxt, setWeightTxt] = useState('');
  const [HeightTxt, setHeightTxt] = useState('');
  const [ShowLoader, setShowLoader] = useState(false);
  const [ShowLoaderSummaryAIChatbot, setShowLoaderSummaryAIChatbot] = useState(false);
  const [ShowLoaderZoomSummary, setShowLoaderZoomSummary] = useState(false);
  const [ShowLoaderSummaryFollowup, setShowLoaderSummaryFollowup] = useState(false);

  const [UserId, setUserId] = useState(userid);
  const [showCalendar, setShowCalendar] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [isSession, setIsSession] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [showSummay, setShowSummary] = useState(false);
  const [doctorsList, setDoctorsList] = useState([]);
  const [assigningSessionId, setAssigningSessionId] = useState(null);
  const totalPages = Math.ceil(UserHistoryData.length / recordsPerPage);
  const totalPageGroups = Math.ceil(totalPages / 3);
  const currentPageGroup = Math.ceil(currentPage / 3);

  const [illnessesList, setIllnessesList] = useState([]);
  const [selectedIllness, setSelectedIllness] = useState(null);
  const [answerLoader, setAnswerLoader] = useState(false);
  const [EmergencyQuest, setEmergencyQuest] = useState(false);
  // Hide clinical edit buttons for MA role only — admin & doctor always have edit access
  // EmergencyQuest shows a warning banner but does NOT block editing for admin/doctor
  const hideClinicEdit = !canEditClinical();
  const ViewOnlyBadge = () => isMA() ? <span style={{fontSize:'11px', color:'#888', marginLeft:'8px', fontWeight:'normal', background:'#f0f0f0', padding:'2px 8px', borderRadius:'4px'}}>View Only</span> : null;

  // Load doctors list for assignment dropdown and provider name resolution
  useEffect(() => {
    getAdminsByRole('doctor').then(setDoctorsList).catch(() => {});
  }, []);

  const [activeTab, setActiveTab] = useState(0);
  const { searchQuery } = useContext(SearchContext);

  const [MainPointsDiscussed, setMainPointsDiscussed] = useState('');
  const [PlanOnCareData, setPlanOnCareData] = useState('');
  const [ConditionalDiagnosis, setConditionalDiagnosis] = useState('');
  const [followConditionalDiagnosis, setFollowConditionalDiagnosis] = useState('');
  const [followPlanOnCareData, setFollowPlanOnCareData] = useState('');
  const [zoomPoC, setZoomPoC] = useState('');
  const [zoomCD, setZoomCD] = useState('');
  const [zoomHPI, setZoomHPI] = useState('');
  const [zoomPMH, setZoomPMH] = useState('');
  const [zoomMedications, setZoomMedications] = useState('');
  const [zoomAllergies, setZoomAllergies] = useState('');
  const [zoomSocialHistory, setZoomSocialHistory] = useState('');
  const [zoomROS, setZoomROS] = useState('');
  const [finalConsultantNote, setFinalConsultantNote] = useState('');
  const [finalConsultantDiagnosis, setFinalConsultantDiagnosis] = useState('');
  const [finalConsultantPlan, setFinalConsultantPlan] = useState('');
  const [finalConsultantHPI, setFinalConsultantHPI] = useState('');
  const [finalConsultantPMH, setFinalConsultantPMH] = useState('');
  const [finalConsultantMedications, setFinalConsultantMedications] = useState('');
  const [finalConsultantPrescribedMedications, setFinalConsultantPrescribedMedications] = useState('');
  const [finalConsultantAllergies, setFinalConsultantAllergies] = useState('');
  const [finalConsultantVisitDate, setFinalConsultantVisitDate] = useState('');
  const [finalConsultantSocialHistory, setFinalConsultantSocialHistory] = useState('');
  const [finalConsultantROS, setFinalConsultantROS] = useState('');
  const [isGeneratingFinalNote, setIsGeneratingFinalNote] = useState(false);
  const [isEditingFinalNote, setIsEditingFinalNote] = useState(false);
  const [editFinalNote, setEditFinalNote] = useState('');
  const [editFinalDiagnosis, setEditFinalDiagnosis] = useState('');
  const [editFinalPlan, setEditFinalPlan] = useState('');
  const [editFinalHPI, setEditFinalHPI] = useState('');
  const [editFinalPMH, setEditFinalPMH] = useState('');
  const [editFinalMedications, setEditFinalMedications] = useState('');
  const [editFinalPrescribedMedications, setEditFinalPrescribedMedications] = useState('');
  const [editFinalAllergies, setEditFinalAllergies] = useState('');
  const [editFinalSocialHistory, setEditFinalSocialHistory] = useState('');
  const [editFinalROS, setEditFinalROS] = useState('');
  // Medication autosuggest state for Final Consultant Note editing
  const [medSearchText, setMedSearchText] = useState('');
  const [medSuggestions, setMedSuggestions] = useState([]);
  const [selectedMedName, setSelectedMedName] = useState('');
  const [selectedMedDose, setSelectedMedDose] = useState('');
  const [selectedMedFrequency, setSelectedMedFrequency] = useState('');
  const [medDoseOptions, setMedDoseOptions] = useState([]);
  const [selectedFinalNoteFiles, setSelectedFinalNoteFiles] = useState([]);
  const [isFinalNoteSubmitted, setIsFinalNoteSubmitted] = useState(false);
  const [isSubmittingFinalNote, setIsSubmittingFinalNote] = useState(false);
  const [doctorRecommendations, setDoctorRecommendations] = useState([]);
  const [newRecommendation, setNewRecommendation] = useState('');
  const [isSavingRecommendation, setIsSavingRecommendation] = useState(false);
  const [editingRecommendationIndex, setEditingRecommendationIndex] = useState(null);
  const [editingRecommendationText, setEditingRecommendationText] = useState('');
  const [showFinalNoteFileModal, setShowFinalNoteFileModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const finalNoteContentRef = useRef();



  const [followSummaryEditFollowup, setFollowSummaryEditFollowup] = useState('');
  const [followSummaryEditAIChatbot, setFollowSummaryEditAIChatbot] = useState('');
  const [editZoomSummary, setEditZoomSummary] = useState('');

  const [summaryEditFollowup, setSummaryEditFollowup] = useState('');

  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

  // Followup file upload state
  const [followupFiles, setFollowupFiles] = useState([]);
  const [followupUploadProgress, setFollowupUploadProgress] = useState(false);
  const followupFileInputRef = useRef(null);
  const [followupReportData, setFollowupReportData] = useState({}); // { [followupId]: [{id, file_name, doc_summary, doc_url}] }
  const [fileUploadStatuses, setFileUploadStatuses] = useState({});  // { [tempKey]: 'uploading'|'summarizing'|'done'|'error' }

  // Followup report generation state
  const [isGeneratingFollowupReport, setIsGeneratingFollowupReport] = useState(null);
  const [isEndingMeeting, setIsEndingMeeting] = useState(false);

  // Report history state
  const [reportHistory, setReportHistory] = useState([]);
  const [selectedReportVersion, setSelectedReportVersion] = useState(null);
  const liveReportData = useRef({
    finalConsultantNote: '',
    finalConsultantDiagnosis: '',
    finalConsultantPlan: '',
    finalConsultantHPI: '',
    finalConsultantPMH: '',
    finalConsultantMedications: '',
    finalConsultantPrescribedMedications: '',
    finalConsultantAllergies: '',
    finalConsultantSocialHistory: '',
    finalConsultantROS: '',
    finalConsultantVisitDate: '',
  });

  const [SessionIDCheck, setSessionIDCheck] = useState('');
  const [reportData, setReportData] = useState(null);
  const [PCP_Pharmacy, setPCP_Pharmacy] = useState(null);

  // Derived submit state: determines if the Submit button should show "Submitted" or "Submit".
  // - When reportHistory hasn't loaded yet (length === 0): fall back to Firestore flag
  // - When only 1 version exists (initial only, no followup): trust Firestore flag
  // - When 2+ versions exist: latest version must have submitted===true, otherwise show "Submit"
  const effectiveSubmitted = isFinalNoteSubmitted && (
    reportHistory.length === 0 ||
    reportHistory[0]?.submitted === true ||
    reportHistory.length === 1
  );

  const [myinsuranceinfo, setMyinsuranceinfo] = useState(() => {
    // Synchronously load cached insurance so it renders immediately on refresh
    try {
      const cached = JSON.parse(localStorage.getItem(`ins_${id}`) || 'null');
      if (cached && (cached.insurance_carrier || cached.group_name || cached.policy_id)) return cached;
    } catch (e) {}
    return [];
  });

  // Dedicated, independent insurance loader.
  // Confirmed from debug logs: Firebase Auth is always null in this app (backend auth,
  // not Firebase Auth). Firestore reads succeed without auth. Fetch immediately.
  useEffect(() => {
    if (!id) return;
    const CACHE_KEY = `ins_${id}`;
    let cancelled = false;

    // Step 1: Show cached data immediately (zero delay)
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && (cached.insurance_carrier || cached.group_name || cached.policy_id)) {
        setMyinsuranceinfo(cached);
        const expiry = moment(cached.expiry_date);
        setCheckExpiry(expiry.isValid() && expiry.isBefore(moment(), 'day'));
      }
    } catch (e) {}

    // Step 2: Fetch fresh from Firestore immediately — no auth gating needed
    (async () => {
      try {
        const sessionData = await getUserSessions(id);
        if (cancelled) return;
        if (sessionData?.insurance_data?.length > 0) {
          const ins = sessionData.insurance_data[0];
          if (cancelled) return;
          setMyinsuranceinfo(ins);
          localStorage.setItem(CACHE_KEY, JSON.stringify(ins));
          const expiry = moment(ins.expiry_date);
          setCheckExpiry(expiry.isValid() && expiry.isBefore(moment(), 'day'));
        }
      } catch (e) { /* ignore — cache from Step 1 is shown */ }
    })();

    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const [documents, setDocuments] = useState([]); // Document list state
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open/close state
  const [isModalPhysicalExamOpen, setIsModalPhysicalExamOpen] = useState(false); // Modal open/close state
  const [selectedDocument, setSelectedDocument] = useState(null); // Track the selected document
  const [isModalOpenViewAll, setIsModalOpenViewAll] = useState(false); // Modal open/close state

  const [SessionID, setSessionID] = useState('');

  const [patientbpMMTxt, setpatientbpMMTxt] = useState('');
  const [bpMMTxt, setbpMMTxt] = useState('');
  const [bpHgTxt, setbpHgTxt] = useState('');
  const [heartrateTxt, setheartrateTxt] = useState('');

  const [Editduration, setEditduration] = useState('');
  const [FCdurationTxt, setFCDurationTxt] = useState('');

  const [EditdurationFollow1, setEditdurationFollow1] = useState('');
  const [FCdurationFollowTxt1, setFCDurationFollowTxt1] = useState('');

  const [EditdurationFollow2, setEditdurationFollow2] = useState('');
  const [FCdurationFollowTxt2, setFCDurationFollowTxt2] = useState('');

  const [EditdurationFollow3, setEditdurationFollow3] = useState('');
  const [FCdurationFollowTxt3, setFCDurationFollowTxt3] = useState('');

  const [saved, setSaved] = useState(false);

  const [editbpMMTxt, seteditbpMMTxt] = useState('');
  const [editbpHgTxt, seteditbpHgTxt] = useState('');
  const [editheartrateTxt, seteditheartrateTxt] = useState('');

  const [errorMessage, setErrorMessage] = useState('');
  const [errorShare, setErrorShare] = useState(""); // To store validation errors
  const [errors, setErrors] = useState({});

  const bpMMRef = useRef(null);
  const bpHgRef = useRef(null);
  const hiddenDivRef = useRef(null);

  const [CheckBpMMTxt, setCheckBpMMTxt] = useState(bpMMTxt);
  const [CheckBpHgTxt, setCheckBpHgTxt] = useState(bpHgTxt);
  const [CheckHeartRateTxt, setCheckHeartRateTxt] = useState(heartrateTxt);

  const [patientstatus, setPatientstatus] = useState('');

  const [isOpen, setIsOpen] = useState(false); // Track if the div is open
  const [selectedItem, setSelectedItem] = useState(null); // Button name
  const [activeItem, setActiveItem] = useState(null); // Track selected list item 
  const [isOpenPhysicalExam, setIsOpenPhysicalExam] = useState(false); // Track if the div is open
  const [checkPhysicalExam, setCheckPhysicalExam] = useState(false); // Track if the div is open
  const [filledCheckPhysicalExam, setfilledCheckPhysicalExam] = useState(false); // Track if the div is open

  const [EditDurationTxt, setEditDurationTxt] = useState('');
  const [EditDurationTxtTemp, setEditDurationTxtTemp] = useState(EditDurationTxt);
  const [isOpenEditDuration, setIsOpenEditDuration] = useState(false); // Track if the div is open
  const [checkEditDuration, setCheckEditDuration] = useState(false); // Track if the div is open
  const [filledCheckEditDuration, setfilledCheckEditDuration] = useState(false); // Track if the div is open

  // const [selectedItemFollowup, setSelectedItemFollowup] = useState(null); // Button name   
  const [isOpenFollowup, setIsOpenFollowup] = useState(false); // Track if the div is open
  const [checkFollowup, setCheckFollowup] = useState(false); // Track if the div is open
  const [filledCheckFollowup, setfilledCheckFollowup] = useState(false); // Track if the div is open
  const [followupDays, setFollowupDays] = useState(new Date()); //useState('');
  const [followupTime, setFollowupTime] = useState(new Date()); //useState('');
  const [followupDate, setFollowupDate] = useState(new Date()); //useState('');
  const [futureDate, setFutureDate] = useState(null);
  const [remainingDays, setRemainingDays] = useState(null);
  const now = new Date();
  const [tempBpMMTxt, setTempBpMMTxt] = useState(''); // Temporary Mm value 
  const [openDiv, setOpenDiv] = useState(null);


  const [followupZoomMeet, setFollowupZoomMeet] = useState(false);
  const [checkFollowupMeet, setCheckFollowupMeet] = useState(false);
  const [checkAllFollowupMeet, setCheckAllFollowupMeet] = useState(false);

  const [selectedItemFollowup, setSelectedItemFollowup] = useState([]); // Followup Date 
  const [FollowupData, setFollowupData] = useState([]); // Followup Date 
  const [MeetingDuration, setMeetingDuration] = useState([]); // Followup Date 

  const [activeOption, setActiveOption] = useState('Routine'); // State to track the active option

  const [meetingStatusZoom, setMeetingStatusZoom] = useState(''); // Button name   
  const [meetingCheckZoomTranscript, setMeetingCheckZoomTranscript] = useState(false); // Button name   
  const [dataProcessingStatus, setDataProcessingStatus] = useState([]); // Button name  



  const [selectedZoomMeet, setSelectedZoomMeet] = useState([]); // zoom_meeting nested object
  const [selectedSession, setSelectedSession] = useState(null); // full chatbot doc (root-level fields)

  // Derived provider info for report/signature:
  // Priority 1: assigned_doctor_* from full session root (formal MA assignment — most authoritative)
  // Priority 2: submitted_by_* from full session root (saved when doctor submitted the final note)
  // Priority 3: lookup from doctorsList by assigned_doctor_id (when name wasn't stored but ID exists)
  // Priority 4: logged-in user's own profile if they are a doctor OR admin (not MA — MAs don't provide care)
  // NOTE: selectedZoomMeet is the zoom_meeting nested object — assigned_doctor_* fields live at root,
  //       so we MUST read from selectedSession (the full chatbot doc), not selectedZoomMeet.
  const assignedDoctorFromList = selectedSession?.assigned_doctor_id
    ? doctorsList.find(d => d.id === selectedSession.assigned_doctor_id || d.id === String(selectedSession.assigned_doctor_id))
    : null;
  const reportProviderName = selectedSession?.assigned_doctor_name || selectedSession?.submitted_by_name || assignedDoctorFromList?.fullName || assignedDoctorFromList?.name || ((isDoctor() || isAdmin()) ? providerName : '');
  const reportProviderSpecialty = selectedSession?.assigned_doctor_specialty || selectedSession?.submitted_by_specialty || assignedDoctorFromList?.specialty || ((isDoctor() || isAdmin()) ? providerSpecialty : '');
  const reportProviderPhone = selectedSession?.assigned_doctor_phone || selectedSession?.submitted_by_phone || assignedDoctorFromList?.phoneNumber || ((isDoctor() || isAdmin()) ? providerPhone : '');
  const reportProviderSignature = selectedSession?.assigned_doctor_signature || selectedSession?.submitted_by_signature || assignedDoctorFromList?.signatureUrl || ((isDoctor() || isAdmin()) ? providerSignature : '');

  const [isOpenZoomMeet, setIsOpenZoomMeet] = useState(false); // Track if the div is open
  const [checkZoomMeet, setCheckZoomMeet] = useState(false); // Track if the div is open 
  const [meetingTitle, setMeetingTitle] = useState('AIGI Online Consultation');
  const [duration, setDuration] = useState(0);
  const [startTime, setStartTime] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());

  const [activeSpeech, setActiveSpeech] = useState(null);
  const [transcripts, setTranscripts] = useState({ medicalcondition: '' });
  const [MedicalConditionsData, setMedicalConditionsData] = useState('');

  const [CheckExpiry, setCheckExpiry] = useState(false);

  const [activeKey, setActiveKey] = useState(null);
  // const [Icons, setIcons] = useState([{ editIcon: 'editIcon', editRed: 'editRed', admin_icon911: 'admin_icon911' }]);

  const [editMode, setEditMode] = useState(null); // Track which follow-up is in edit mode
  const [editText, setEditText] = useState(''); // Track the current text being edited


  const handleOptionClick = (option) => {
    setActiveOption(option); // Update the active option
  };

  const [activeAccordion, setActiveAccordion] = React.useState(null);
  const [editingAccordion, setEditingAccordion] = useState(null);
  const [updatedContent, setUpdatedContent] = useState({}); // Object to track updates for each accordion

  const [CheckZoomMeetStart, setCheckZoomMeetStart] = useState(false);
  const [CheckZoomMeetURL, setCheckZoomMeetURL] = useState('');

  const handleAccordionToggle = (title) => {
    setActiveAccordion((prev) => (prev === title ? null : title));
  };

  const [activeAccordionPoc, setActiveAccordionPoc] = React.useState(null);

  const handleAccordionTogglePoc = (title) => {
    setActiveAccordionPoc((prev) => (prev === title ? null : title));
  };

  useEffect(() => {
    // Determine which tab should be active by default
    const followUpExists = FollowupData?.some((item) => item.followup_CD);
    if (followUpExists) {
      setActiveAccordion('Follow up - Differential Diagnosis'); // Set sanitized title for follow-up
    } else {
      setActiveAccordion('Differential Diagnosis'); // Set sanitized title for default tab
    }

    const followUpExistsPoc = FollowupData?.some((item) => item.followup_PoC);
    if (followUpExistsPoc) {
      setActiveAccordionPoc('Follow up - Plan of Care'); // Set sanitized title for follow-up
    } else {
      setActiveAccordionPoc('Plan of Care'); // Set sanitized title for default tab
    }

  }, [FollowupData]);

  // Load uploaded report details from Firestore for followups that have them
  useEffect(() => {
    if (!FollowupData?.length) return;
    const loadReports = async () => {
      const updates = {};
      for (const item of FollowupData) {
        const fid = item.followup_id || item.id;
        if (fid && item.uploaded_report_ids?.length > 0 && !followupReportData[fid]) {
          try {
            updates[fid] = await getFollowupReports(fid);
          } catch (e) { /* silent — UI shows nothing */ }
        }
      }
      if (Object.keys(updates).length > 0) {
        setFollowupReportData(prev => ({ ...prev, ...updates }));
      }
    };
    loadReports();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FollowupData]);

  // useEffect(() => {
  //   if (FollowupData?.length > 0) {
  //     const durations = FollowupData.map((item) =>
  //       item.followup_summary ? selectedZoomMeet.duration : null
  //     );

  //     logger.info(durations)
  //     // Set values based on index (or default to an empty string if missing) 
  //     setFCDurationFollowTxt1(durations[1] || "");
  //     setFCDurationFollowTxt2(durations[2] || ""); 
  //     setEditdurationFollow1(durations[1] || "");
  //     setEditdurationFollow2(durations[2] || "");
  //   }
  // // }, [FollowupData, selectedZoomMeet]);

  // useEffect(() => {
  //   if (FollowupData?.length > 0) {
  //     const durations = FollowupData.map((item) =>
  //       item.followup_summary ? selectedZoomMeet.duration : null
  //     );
  //     logger.info("Durations:", durations);
  //     setFCDurationFollowTxt1((prev) => durations[1] ?? prev);
  //     setFCDurationFollowTxt2((prev) => durations[2] ?? prev);
  //     setEditdurationFollow1((prev) => durations[1] ?? prev);
  //     setEditdurationFollow2((prev) => durations[2] ?? prev);
  //   }
  // }, [FollowupData, selectedZoomMeet]);

  useEffect(() => {
    if (!saved && FollowupData?.length > 0) {
      const durations = FollowupData.map((item) =>
        item.followup_summary ? item.zoom_meeting.duration : null
      );
      if (FCdurationFollowTxt1 == '') {
        setFCDurationFollowTxt1(durations[1] || "");
      }
      setFCDurationFollowTxt2(durations[2] || "");
      setEditdurationFollow1(durations[1] || "");
      setEditdurationFollow2(durations[2] || "");
    }
  }, [FollowupData, selectedZoomMeet, saved]);

  const checkOrderList = [
    { Name: "Allergies", doc_type: "allergy" },
    { Name: "Medications", doc_type: "medications" },
    { Name: "Medical Conditions", doc_type: "medical_conditions" },
    { Name: "Past Surgical History", doc_type: "past_surgical_history" },
    { Name: "Social History", doc_type: "social_history" },
    { Name: "Upload Reports", doc_type: "other_report" },
    { Name: "Primary Care Physician (PCP)", doc_type: "pcp" },
    { Name: "Pharmacy information", doc_type: "pharmacy" },
  ];
  const options = [
    'Test Results',
    'Refills',
    'Recall Colon',
    'Recall ECD',
    'Routine',
    'Persistant Symptoms',
  ];



  // logger.info(filledCheckPhysicalExam +' '+ checkPhysicalExam )

  // Open modal and set selected document
  const openModalViewAll = () => {
    // navigate1('/admin/fullreport', {
    //   state: {sessionid: SessionIDCheck } 
    // }); 

    setOpenDiv(null)
    setIsModalOpenViewAll(true);
  };

  const closeModalViewAll = () => {
    setIsModalOpenViewAll(false);
  };
  const toggleDivFollowup = () => {
    // Only reset to "new followup" mode when there is no active meeting.
    // When followupZoomMeet=true the panel shows meeting details — don't wipe selectedItemFollowup.
    if (openDiv !== 'Followup' && !followupZoomMeet) {
      setCheckAllFollowupMeet(false);
      setSelectedItemFollowup(null);
      setTranscripts(prev => ({ ...prev, medicalcondition: '' }));
      setFollowupFiles([]);
      setFileUploadStatuses({});
      setActiveOption('Routine');
    }
    setCheckFollowup(false);
    setOpenDiv(openDiv === 'Followup' ? null : 'Followup');
  };

  // Handle cancel button click
  const closeFollowup = () => {
    setCheckFollowup(false); // Close the div without saving  
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
  };
  // Handle cancel button click
  const handleCancelFollowup = () => {
    setActiveOption('Routine')
    setIsOpenFollowup(false); // Close the div without saving 
    // Reset temporary input values 
    setFollowupDays('');
    setFutureDate('');
    setOpenDiv('')
    // Clear any errors
    setErrors({});
    setErrorMessage('');
    setLoading(false);
  };

  const handleDaysChange = (e) => {
    const days = e.target.value;
    // Validate if input is a number
    if (/^\d*$/.test(days)) {
      setFollowupDays(days);
      setErrors({});
      setErrorMessage(''); // Clear error if valid input

      // Calculate future date only if days is a valid number
      if (days && !isNaN(days)) {
        const today = new Date();
        today.setDate(today.getDate() + parseInt(days, 10)); // Use parseInt with radix 10
        setFutureDate(today.toISOString().split('T')[0]); // Format as yyyy-mm-dd
        calculateRemainingDays(today);
      } else {
        setFutureDate(null); // Reset if input is invalid
      }
    } else {
      setErrorMessage('Please enter a valid number of days');
      setFollowupDays(''); // Clear the invalid input
      setFutureDate(null); // Reset future date if input is invalid 
    }
  };

  // Calculate remaining days based on futureDate
  const calculateRemainingDays = (targetDate) => {
    const currentDate = new Date();
    const differenceInTime = targetDate - currentDate;
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
    setRemainingDays(differenceInDays);
  };

  // // Set an interval to check remaining days every 24 hours
  // useEffect(() => {
  //   if (futureDate) {
  //     const interval = setInterval(() => {
  //       calculateRemainingDays(new Date(futureDate));
  //     }, 24 * 60 * 60 * 1000); // 24 hours

  //     // Cleanup interval on unmount or if futureDate changes
  //     return () => clearInterval(interval);
  //   }
  // }, [futureDate]);
  const handleFollowTimeChange = (time) => {
    setFollowupTime(time);
  };

  const handleFollowDateChange = (date) => {
    setFollowupDate(date);

    const now = new Date();

    // Check if the selected date is today
    if (date.toDateString() === now.toDateString()) {
      // Set time to the current time or the next available interval
      setFollowupTime(new Date(date.setHours(now.getHours(), now.getMinutes(), 0, 0)));
    } else {
      // Set time to 9:00 AM for other dates
      setFollowupTime(new Date(date.setHours(9, 0, 0, 0)));
    }

  };


  const handleUserRemove = async () => {
    const userIdRemove = "6763fe9099f425d8470e827b";
    try {
      await deleteUser(userIdRemove);
    } catch (error) {
      logger.error('Error removing user:', error);
    }
  };


  const handleTextChangeMedicalCondition = (e) => {
    setTranscripts({ ...transcripts, medicalcondition: e.target.value });
    const valueTxt = e.target.value;
    setMedicalConditionsData(valueTxt);
  };

  const handleFollowupFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setFollowupFiles(prev => {
      const existing = new Set(prev.map(f => f.name + f.size));
      return [...prev, ...newFiles.filter(f => !existing.has(f.name + f.size))];
    });
    // Reset so same file can be re-added after removal
    e.target.value = '';
  };

  // Handle form submission
  const handleSaveFollowup = async (event) => {
    event.preventDefault();
    setLoading(true);
    const startdatetime = formatDateTimeForAPI(followupDate, followupTime);



    setShowLoader(true);
    const topicTxt = checkAllFollowupMeet ? selectedItemFollowup?.title : activeOption;

    const data = {
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      topic: topicTxt,
      start_time: startdatetime,
      attendee: email,
      description: transcripts.medicalcondition,
    };
    try {
      // Use Firestore service directly - no backend API needed
      const result = await createFollowupZoomMeeting(data);

      setSelectedItemFollowup(result);
      if (result.zoom_meeting && Object.keys(result.zoom_meeting).length > 0) {
        setFollowupZoomMeet(true);
      }

      // Upload followup medical reports if any
      const followupId = result.id;
      let uploadFailed = false;
      if (followupFiles.length > 0 && followupId) {
        setFollowupUploadProgress(true);
        const uploadedReportIds = [];
        const uploadedReportDetails = [];
        const failedFiles = [];
        try {
          for (const file of followupFiles) {
            const tempKey = file.name + '_' + file.size;
            try {
              // Mark as uploading
              setFileUploadStatuses(prev => ({ ...prev, [tempKey]: 'uploading' }));

              const safeFileName = `${Date.now()}_${file.name}`.replace(/\s+/g, '_');
              const fileRef = ref(storage, `medical_reports/${userid}/${SessionIDCheck}/followup_${followupId}/${safeFileName}`);
              await uploadBytes(fileRef, file);
              const downloadUrl = await getDownloadURL(fileRef);

              const reportData = {
                user_id: userid,
                reports_id: SessionIDCheck,
                doc_type: 'followup_report',
                doc_summary: '',
                doc_text: '',
                file_name: file.name,
                doc_url: downloadUrl,
                file_url: downloadUrl,
                followup_id: followupId,
              };
              const reportId = await createMedicalReport(reportData);
              uploadedReportIds.push(reportId);

              // Mark as summarizing
              setFileUploadStatuses(prev => ({ ...prev, [tempKey]: 'summarizing' }));

              let finalSummary = '';
              // Trigger AI summarization for each uploaded document
              try {
                const sumRes = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/summarizeMedicalDocument', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    user_id: userid,
                    doc_type: 'other_report',
                    doc_url: downloadUrl,
                    doc_id: reportId,
                    reports_id: SessionIDCheck,
                  }),
                });
                const sumData = await sumRes.json();
                if (sumData.summary) {
                  finalSummary = sumData.summary;
                  await updateMedicalReportSummary(reportId, sumData.summary);
                }
              } catch (sumErr) {
                logger.error('Error summarizing followup document:', sumErr);
              }

              // Mark as done
              setFileUploadStatuses(prev => ({ ...prev, [tempKey]: 'done' }));
              uploadedReportDetails.push({ id: reportId, file_name: file.name, doc_summary: finalSummary, doc_url: downloadUrl });
            } catch (fileErr) {
              logger.error(`Error uploading file ${file.name}:`, fileErr);
              setFileUploadStatuses(prev => ({ ...prev, [tempKey]: 'error' }));
              failedFiles.push(file.name);
            }
          }

          // Link successfully uploaded report IDs to the followup document
          if (uploadedReportIds.length > 0) {
            await updateFollowupReportIds(followupId, uploadedReportIds);
            // Store results in state so they render immediately without reload
            setFollowupReportData(prev => ({ ...prev, [followupId]: uploadedReportDetails }));
          }

          if (failedFiles.length > 0) {
            uploadFailed = true;
            toast.error(`Failed to upload ${failedFiles.length} file(s): ${failedFiles.join(', ')}. Please try uploading again from the followup section.`, {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 8000,
            });
            if (uploadedReportIds.length > 0) {
              toast.info(`${uploadedReportIds.length} file(s) uploaded successfully.`, {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
          } else {
            toast.success(`${uploadedReportIds.length} report(s) uploaded successfully!`, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        } catch (uploadErr) {
          uploadFailed = true;
          logger.error('Error uploading followup files:', uploadErr);
          toast.error(`Report upload failed: ${uploadErr.message || 'Unknown error'}. Followup was created but reports were not uploaded.`, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          });
        } finally {
          setFollowupUploadProgress(false);
        }
      }

      if (!uploadFailed) {
        toast.success(result.message || 'Followup meeting created successfully!', {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.warning('Followup meeting created, but some reports failed to upload. You can retry uploading from the patient view.', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        });
      }

      // Add new followup to FollowupData state so it appears immediately in the list
      const newFollowupItem = {
        ...result,
        followup_id: result.id,
        followup_summary: '',
        followup_CD: '',
        followup_PoC: '',
      };
      setFollowupData(prev => [newFollowupItem, ...(prev || [])]);

      // Reset form fields but keep popup open to show meeting details immediately
      setActiveOption('Routine');
      setFollowupDays('');
      setFutureDate('');
      setFollowupFiles([]);
      setErrors({});
    } catch (error) {
      logger.error('Error occurred:', error);
      toast.error(error.message || 'An unexpected error occurred. Please try again.', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setLoading(false);
      setShowLoader(false);
    }
  };
  // "data_processing_status": false,
  // "meeting_status": "deactive",


  const handleDateChange = (date) => {
    setStartDate(date);

    const now = new Date();

    // Check if the selected date is today
    if (date.toDateString() === now.toDateString()) {
      // Set time to the current time or the next available interval
      setStartTime(new Date(date.setHours(now.getHours(), now.getMinutes(), 0, 0)));
    } else {
      // Set time to 9:00 AM for other dates
      setStartTime(new Date(date.setHours(9, 0, 0, 0)));
    }
  };


  const handleTimeChange = (time) => {
    setStartTime(time);
  };

  // Ensure `startTime` stays on the same day as `startDate`
  useEffect(() => {
    if (startDate && startTime && startDate.toDateString() !== startTime.toDateString()) {
      setStartTime(new Date(startDate.setHours(startTime.getHours(), startTime.getMinutes())));
    }
  }, [startDate]);


  const validateForm = () => {
    const newErrors = {};
    if (!meetingTitle) newErrors.meetingTitle = 'Meeting title is required';
    if (!startDate) newErrors.startDate = 'Meeting date is required';
    if (!startTime) newErrors.startTime = 'Meeting time is required';

    setErrors(newErrors);
    setLoading(false);
    return Object.keys(newErrors).length === 0;
  };

  const formatDateTimeForAPI = (date, time) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(time.getHours()).padStart(2, '0');
    const minutes = String(time.getMinutes()).padStart(2, '0');
    const seconds = String(time.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
  };

  const formatConsultationDate = (createdOn, createdAt) => {
    const value = createdOn || createdAt;
    if (!value) return '-';
    const parsed = moment(value);
    return parsed.isValid() ? parsed.format('MMM DD, YYYY') : '-';
  };


  const handleSaveZoomInvite = async (event) => {
    event.preventDefault();

    const startdatetime = formatDateTimeForAPI(startDate, startTime);

    if (!validateForm()) return;

    setLoading(true);
    setShowLoader(true);

    const data = {
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      topic: meetingTitle,
      start_time: startdatetime,
      duration: 45,
      attendee: email,
      agenda: meetingTitle,
    };

    try {
      // Use Firestore service directly - no backend API needed
      const result = await createZoomMeeting(data);

      toast.success(result.message || 'Zoom meeting created successfully!', {
        position: toast.POSITION.TOP_RIGHT,
      });

      setSelectedZoomMeet(result.zoom_meeting || {}); // Update state
      setMeetingStatusZoom(result.zoom_meeting?.meeting_status || ''); // Safely access status
      setMeetingCheckZoomTranscript(result.zoom_meeting?.transcript?.length ? true : false)

      // Reset the form
      setOpenDiv(null);
      setErrors({});
      setLoading(false);
      setShowLoader(false);
      setMeetingTitle('');

    } catch (error) {
      // Handles errors
      logger.error('Error:', error);
      toast.error(error.message || 'Failed to create Zoom meeting. Please try again.', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setLoading(false);
      setShowLoader(false);
    }
  };

  const toggleDivZoomMeet = () => {
    setCheckZoomMeet(false);
    setOpenDiv(openDiv === 'ZoomMeet' ? null : 'ZoomMeet');
  };

  // Handle cancel button click
  const closeZoomMeet = () => {
    setCheckFollowup(false); // Close the div without saving  
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
  };
  // Handle cancel button click
  const handleCancelZoomMeet = () => {
    // const now = new Date();
    setIsOpenFollowup(false); // Close the div without saving 
    // Reset temporary input values 
    // setZoomMeet('');  
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
    setLoading(false);
    // setSelectedZoomMeet(['']);
    setMeetingTitle('');
    setStartDate(now); // set current date
    setStartTime(now); // set current time
    // setDuration(0);
    setErrors({});
  };


  const toggleDivPhysicalExam = () => {
    setCheckPhysicalExam(false);
    setOpenDiv(openDiv === 'PhysicalExam' ? null : 'PhysicalExam');
  };

  // Handle cancel button click
  const closePhysicalExam = () => {
    setIsOpenPhysicalExam(false); // Close the div without saving  
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
  };
  // Handle cancel button click
  const handleCancelPhysicalExam = () => {
    setIsOpenPhysicalExam(false); // Close the div without saving 
    // Reset temporary input values
    // setTempBpMMTxt('');
    setbpHgTxt(editbpHgTxt);
    setbpMMTxt(editbpMMTxt);
    setheartrateTxt(editheartrateTxt);
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    // Simple form validation
    let formErrors = {};
    setErrorMessage('');

    if (!(bpHgTxt || '').trim() || !(bpMMTxt || '').trim()) {
      formErrors.bpHgTxt = 'Please enter your blood pressure (Mm - Hg)';
    }
    if (!(heartrateTxt || '').trim()) {
      formErrors.heartrateTxt = 'Please enter your heart rate';
    }
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setShowLoader(true)

    const hasChanged =
      bpMMTxt !== CheckBpMMTxt ||  // Add blood pressure Mm check
      bpHgTxt !== CheckBpHgTxt ||  // Add blood pressure Hg check
      heartrateTxt !== CheckHeartRateTxt;  // Add heart rate check

    if (!hasChanged) {
      // Redirect to another page if no changes
      setShowLoader(false);
      return;
    }

    // If validation passes, send data to API
    const data = {
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      bp_mm: bpMMTxt,
      bp_hg: bpHgTxt,
      heartrate: heartrateTxt,
    };
    // logger.info(data)
    // Here, you would replace 'apiEndpoint' with your actual API endpoint
    try {
      await updatePhysicalExam(SessionIDCheck, {
        bp_mm: bpMMTxt,
        bp_hg: bpHgTxt,
        heartrate: heartrateTxt,
      });
      saveFHIRVitalSignsFromExam(bpMMTxt, bpHgTxt, heartrateTxt, userid, SessionIDCheck).catch(err => logger.error('FHIR vitals save failed:', err));

      toast.success("Physical exam updated successfully!", {
        position: toast.POSITION.TOP_RIGHT,
      });

      setbpMMTxt(bpMMTxt);
      setbpHgTxt(bpHgTxt);
      setheartrateTxt(heartrateTxt);

      seteditbpHgTxt(bpHgTxt);
      seteditbpMMTxt(bpMMTxt);
      seteditheartrateTxt(heartrateTxt);

      setCheckPhysicalExam(true);
      setIsOpenPhysicalExam(false);

      closePhysicalExam();
      setShowLoader(false);
    } catch (error) {
      logger.error('Error updating physical exam:', error);
      toast.error(error.message || 'Failed to update physical exam', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }



  };


  const toggleEditDuration = () => {
    setCheckEditDuration(false);
    setOpenDiv(openDiv === 'EditDuration' ? null : 'EditDuration');
  };

  // Handle cancel button click
  const closeEditDuration = () => {
    setEditDurationTxtTemp(EditDurationTxt)
    setIsOpenEditDuration(false); // Close the div without saving  
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
  };
  // Handle cancel button click
  const handleCancelEditDuration = () => {
    setIsOpenEditDuration(false); // Close the div without saving 
    // Reset temporary input values
    setEditDurationTxtTemp(EditDurationTxt)
    setOpenDiv('')
    setErrors({});
    setErrorMessage('');
  };

  const handleSubmitEditDuration = async (event) => {
    event.preventDefault();
    if (!canEditClinical()) return;
    // Simple form validation
    let formErrors = {};
    setErrorMessage('');

    if (!(EditDurationTxt || '').trim()) {
      formErrors.EditDurationTxt = 'Please enter the duration';
    }
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setShowLoader(true)



    // if (!hasChanged) {
    //   // Redirect to another page if no changes
    //   setShowLoader(false); 
    //   return;
    // } 

    // If validation passes, send data to API
    const data = {
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      actual_duration: EditDurationTxt,
    };
    // logger.info(data)
    // Here, you would replace 'apiEndpoint' with your actual API endpoint
    try {
      await updateSessionDuration(SessionIDCheck, EditDurationTxt);

      toast.success("Session duration updated successfully!", {
        position: toast.POSITION.TOP_RIGHT,
      });

      setEditDurationTxtTemp('');
      setEditDurationTxt(EditDurationTxt);
      setCheckEditDuration(true);
      setIsOpenEditDuration(false);
      closeEditDuration();
      setShowLoader(false);
    } catch (error) {
      logger.error('Error updating session duration:', error);
      toast.error(error.message || 'Failed to update session duration', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }



  };

  const handleInput = (e, nextRef, prevRef) => {
    const value = e.target.value;
    const fieldName = e.target.placeholder;

    // Convert value to an integer for validation
    const intValue = parseInt(value, 10);

    // Clear the error message when user types
    if (fieldName === "Mm" || fieldName === "Hg") {
      setErrors((prevErrors) => ({ ...prevErrors, bpHgTxt: '' }));
    }

    // Forward jump when the max length is reached
    if (value.length === e.target.maxLength) {
      // Blood Pressure Mm Validation (0-200)
      if (fieldName === "Mm") {
        if (intValue < 0 || intValue > 200 || isNaN(intValue)) {
          setErrorMessage("Mm value must be between 0 and 200");
          bpMMRef.current.focus();
          return;
        } else {
          setbpMMTxt(value);  // Set the bpMMTxt state
        }
      }

      // Blood Pressure Hg Validation (0-200)
      if (fieldName === "Hg") {
        if (intValue < 0 || intValue > 200 || isNaN(intValue)) {
          setErrorMessage("Hg value must be between 0 and 200");
          bpHgRef.current.focus();
          return;
        } else {
          setbpHgTxt(value);  // Set the bpHgTxt state
        }
      }

      // Clear error message if validation passes
      setErrorMessage("");
      if (nextRef) {
        nextRef.current.focus();
      }
    }
    // Backward jump when "Backspace" is pressed and the input is empty
    else if (e.nativeEvent.inputType === "deleteContentBackward" && value.length === 0) {
      if (prevRef) {
        prevRef.current.focus();
      }
    }
  };

  const handleKeyDown = (e, nextRef, prevRef) => {
    const value = e.target.value;
    const fieldName = e.target.placeholder;

    // Right Arrow Key
    if (e.key === "ArrowRight") {
      if (value === "") {
        setErrorMessage(`${fieldName} cannot be empty`);
        e.target.focus();
        return;
      } else {
        setErrorMessage(""); // Clear error if field is not empty
      }

      if (nextRef) {
        nextRef.current.focus();
      }
    }

    // Left Arrow Key
    if (e.key === "ArrowLeft") {
      if (value === "") {
        setErrorMessage(`${fieldName} cannot be empty`);
        e.target.focus();
        return;
      } else {
        setErrorMessage(""); // Clear error if field is not empty
      }

      if (prevRef) {
        prevRef.current.focus();
      }
    }
  };


  // Open modal and set selected document
  const openModalPhysicalExam = () => {
    setIsModalPhysicalExamOpen(true);
  };
  // Close modal and reset selected document
  const closeModalPhysicalExam = () => {
    setIsModalPhysicalExamOpen(false);
  };

  // Open modal and set selected document
  const openModal = (doc) => {
    const viewerUrl = `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(doc)}`;
    setSelectedDocument(viewerUrl);
    setIsModalOpen(true);
  };




  // Close modal and reset selected document
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDocument(null);
  };

  // Add document dynamically
  const addDocument = (name, url) => {
    const newDocument = { name, url };
    setDocuments([...documents, newDocument]); // Add to the document list
  };


  // Example list of items
  const items = ['Pending', 'New', 'Progress', 'Completed'];

  // Open or close the dropdown div
  // const toggleDiv = () => setIsOpen((prev) => !prev);
  // const toggleDiv = () => setIsOpen(true);
  const toggleDivStatus = () => {
    setOpenDiv(openDiv === 'Status' ? null : 'Status');
    setActiveItem(selectedItem)
  };
  // Handle item selection and update the button name
  const handleItemClick = (item) => {
    setActiveItem(item);// Update button name 
  };


  // Monitor input changes and set `checkPhysicalExam` when all values are filled
  useEffect(() => {
    if (bpHgTxt && bpMMTxt && heartrateTxt && tempBpMMTxt) {
      setCheckPhysicalExam(true); // All inputs are filled
      setfilledCheckPhysicalExam(true); // All inputs are filled
    }
  }, [bpHgTxt, bpMMTxt, heartrateTxt]); // Runs whenever these values change

  // Save the selected item via API
  const handleSave = async () => {
    setLoading(true);

    try {
      await updatePatientStatus(SessionIDCheck, activeItem);

      toast.success("Patient status saved successfully!", {
        position: toast.POSITION.TOP_RIGHT,
      });

      setSelectedItem(activeItem);
      handleCancel();
    } catch (error) {
      logger.error('Error updating patient status:', error);
      toast.error(error.message || 'Failed to save patient status', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    } finally {
      setLoading(false);
    }
  };

  // Handle cancel button click
  const handleCancel = () => {
    setIsOpen(false); // Close the div without saving  
    let item = selectedItem;
    setOpenDiv('')
    if (item === null) {
      setActiveItem(''); // Reset active item if selectedItem is null
    } else {
      setActiveItem(item); // Update button name otherwise
    }
  };


  useEffect(() => {
    if (searchQuery) {
      localStorage.removeItem('adminCurrentPatientId');
      sessionStorage.removeItem('adminViewPatientId');
      navigate('/admin/dashboard');
    }
  }, [searchQuery, navigate]);

  // Fetch illnesses
  const illnessesArray = async () => {
    try {
      const illnesses = await getIllnesses();
      setIllnessesList(illnesses);
    } catch (error) {
      logger.error('Error fetching illnesses:', error);
      toast.error('Failed to load illnesses');
    }
  };

  const applyInsuranceData = (insuranceData) => {
    setMyinsuranceinfo(insuranceData);
    // Always cache with the stable URL-param-derived patient ID so lazy init and
    // the dedicated insurance useEffect always find it with the same key.
    const cacheKey = id || userid;
    if (cacheKey) localStorage.setItem(`ins_${cacheKey}`, JSON.stringify(insuranceData));
    const expiry = moment(insuranceData.expiry_date);
    setCheckExpiry(expiry.isValid() && expiry.isBefore(moment(), 'day'));
  };

  const handleMyInsurance = async (UserIdNew) => {
    try {
      const idsToTry = [UserIdNew, userid].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i);
      for (const uid of idsToTry) {
        const insuranceList = await getInsuranceData(uid);
        if (insuranceList && insuranceList.length > 0) {
          applyInsuranceData(insuranceList[0]);
          return;
        }
      }
      // Patient-specific localStorage fallback
      const fbKey = id || userid;
      if (fbKey) {
        const cached = JSON.parse(localStorage.getItem(`ins_${fbKey}`) || 'null');
        if (cached && (cached.insurance_carrier || cached.group_name || cached.policy_id)) {
          setMyinsuranceinfo(cached);
        }
      }
    } catch (error) {
      logger.error('Error fetching insurance:', error);
    }
  };

  const handleDeleteZoomMeet = async (meetingId) => {
    try {
      await deleteZoomMeeting(meetingId);
      setSelectedZoomMeet(null);
      setMeetingStatusZoom(null);
    } catch (error) {
      logger.error('Error deleting zoom meeting:', error);
    }
  };

  const handleRecordsPerPageChange = (event) => {
    setRecordsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNextGroup = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevGroup = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFindRecord = (id) => {

  };
  const handleShowSummary = async (id) => {
    if (id) {
      setViewedSessionMap((prev) => ({ ...prev, [id]: true }));
    }
    setShowLoaderPage(true);

    try {
      let foundRecord = UserHistoryData.find(
        (item) => item.session_id === id || item.created_on === id
      );

      if (foundRecord) {
        if (foundRecord?.session_id) {
          await adminCheckedSession(foundRecord.user_id || userid, foundRecord.session_id);
        }

        // If cached data shows an ended meeting, fetch fresh Firestore data first.
        // This prevents a race condition where a new meeting was created while the page
        // was open, but UserHistoryData still has the old (ended) meeting — which would
        // incorrectly trigger processZoomMeeting and mark the new meeting as "completed".
        const cachedMightTrigger =
          foundRecord?.zoom_meeting?.meeting_status === 'active' &&
          !foundRecord?.zoom_meeting?.data_processing_status &&
          Boolean(foundRecord?.zoom_meeting?.meeting_id) &&
          Boolean(foundRecord?.session_id) &&
          Boolean(foundRecord?.zoom_meeting?.end_ts) &&
          (foundRecord.zoom_meeting.end_ts < Math.floor(Date.now() / 1000));

        // Also refresh when meeting is active but end_ts is absent (covers cases where
        // the meeting ended before end_ts was saved, e.g. manual Zoom stop or webhook delay).
        const shouldRefreshStaleActive =
          !cachedMightTrigger &&
          foundRecord?.zoom_meeting?.meeting_status === 'active' &&
          Boolean(foundRecord?.zoom_meeting?.meeting_id) &&
          Boolean(foundRecord?.session_id);

        if (cachedMightTrigger || shouldRefreshStaleActive) {
          try {
            const freshRecord = await getChatSession(id);
            if (freshRecord) {
              foundRecord = { ...freshRecord, session_id: freshRecord.session_id || freshRecord.id || id };
            }
          } catch (e) {
            // Fresh fetch failed — continue with cached data
          }
        }

        const shouldProcessZoomMeeting =
          foundRecord?.zoom_meeting?.meeting_status === 'active' &&
          !foundRecord?.zoom_meeting?.data_processing_status &&
          Boolean(foundRecord?.zoom_meeting?.meeting_id) &&
          Boolean(foundRecord?.session_id) &&
          Boolean(foundRecord?.zoom_meeting?.end_ts) &&
          (foundRecord.zoom_meeting.end_ts < Math.floor(Date.now() / 1000));

        if (shouldProcessZoomMeeting) {
          const data = {
            meeting_id: foundRecord.zoom_meeting.meeting_id,
            session_id: foundRecord.session_id,
          };

          try {
            await processZoomMeeting(data);
            // The Cloud Function response does not include session_data, so always
            // re-read the session from Firestore to get the updated meeting_status
            // ('completed') and zoom summary fields — making Tab 4 visible for all roles.
            try {
              const freshRecord = await getChatSession(foundRecord.session_id);
              if (freshRecord) {
                const merged = { ...freshRecord, session_id: freshRecord.session_id || freshRecord.id || foundRecord.session_id };
                // Keep the UserHistoryData cache in sync so the table row is up to date
                setUserHistoryData(prev => prev.map(s =>
                  (s.session_id || s.id) === (merged.session_id || merged.id) ? merged : s
                ));
                showPatientDataResult(merged);
                // Final note auto-trigger is handled inside showPatientDataResult
              } else {
                showPatientDataResult(foundRecord);
              }
            } catch (fetchErr) {
              logger.error('Error re-fetching session after zoom processing:', fetchErr);
              showPatientDataResult(foundRecord);
            }
          } catch (error) {
            logger.error('Error processing zoom meeting:', error);
            showPatientDataResult(foundRecord);
          }
        } else {
          showPatientDataResult(foundRecord);
          // Final note auto-trigger is handled inside showPatientDataResult
        }
      } else {
        setRecordData(null);
      }
    } catch (error) {
      logger.error('Error in handleShowSummary:', error);
      toast.error('An error occurred. Please try again.', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {

    }

  };
  const calculateDurationInMinutes = (startTs, endTs) => {
    const durationInSeconds = endTs - startTs;
    const durationInMinutes = Math.floor(durationInSeconds / 60);
    return durationInMinutes;
  };
  const calculateDuration = (startTs, endTs) => {
    const durationInSeconds = endTs - startTs;
    const durationInMinutes = Math.floor(durationInSeconds / 60);
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    const hourString = hours > 0 ? `${hours} hour` : "";
    const minuteString = minutes > 0 ? `${minutes} minute` : "";

    return [hourString, minuteString].filter(Boolean).join(" and ");
  };

  // Detect old Q&A format (not an AI-generated summary)
  const isOldQAFormat = (summary) => summary && summary.trim().startsWith('Patient Presenting Symptom:');

  // Monitor input changes and set `checkPhysicalExam` when all values are filled 
  const showPatientDataResult = async (foundRecord) => {
    const filteredConversation = (foundRecord.conversation || []).filter(convo => Object.keys(convo).length !== 0);

    // Set all necessary states based on foundRecord
    setRecordData(foundRecord);
    const aiSummary = isOldQAFormat(foundRecord.chatbot_summary) ? '' : (foundRecord.chatbot_summary || '');

    setFollowSummaryEditAIChatbot(aiSummary);
    setSelectedIllness(foundRecord.illness);
    setChatHistory(filteredConversation);
    setPlanOnCareData(foundRecord.plan_of_care);
    setConditionalDiagnosis(foundRecord.conditional_diagnosis);
    setSessionIDCheck(foundRecord.session_id);
    setPatientstatus(foundRecord.patientstatus);
    setSelectedItem(foundRecord.patientstatus);
    setActiveItem(foundRecord.patientstatus);
    setbpHgTxt(foundRecord.bp_hg);
    setbpMMTxt(foundRecord.bp_mm);
    setheartrateTxt(foundRecord.heartrate);
    setHeightTxt(foundRecord.height ? foundRecord.height : 0);
    seteditbpHgTxt(foundRecord.bp_hg);
    seteditbpMMTxt(foundRecord.bp_mm);
    seteditheartrateTxt(foundRecord.heartrate);

    setpatientbpMMTxt(foundRecord.bmi);
    setTempBpMMTxt(foundRecord.bp_mm);
    setFutureDate(foundRecord.follow_up_date);
    // setSelectedItemFollowup(foundRecord.follow_up_date);
    setSelectedZoomMeet(foundRecord?.zoom_meeting || null);
    setSelectedSession(foundRecord || null); // full chatbot doc — needed for assigned_doctor_* fields
    setMeetingStatusZoom(foundRecord?.zoom_meeting?.meeting_status);
    setMeetingCheckZoomTranscript(foundRecord?.zoom_meeting?.transcript?.length ? true : false)
    setDataProcessingStatus(foundRecord?.zoom_meeting?.data_processing_status);
    setEditZoomSummary(foundRecord?.zoom_summary || '');
    setZoomCD(foundRecord?.zoom_conditional_diagnosis || '');
    setZoomPoC(foundRecord?.zoom_plan_of_care || '');
    setZoomHPI(foundRecord?.zoom_hpi || '');
    setZoomPMH(foundRecord?.zoom_pmh || '');
    setZoomMedications(foundRecord?.zoom_medications || '');
    setZoomAllergies(foundRecord?.zoom_allergies || '');
    setZoomSocialHistory(foundRecord?.zoom_social_history || '');
    setZoomROS(foundRecord?.zoom_ros || '');
    setFinalConsultantNote(foundRecord?.final_consultant_note || '');
    setFinalConsultantDiagnosis(foundRecord?.final_consultant_diagnosis || '');
    setFinalConsultantPlan(foundRecord?.final_consultant_plan || '');
    setFinalConsultantHPI(foundRecord?.final_consultant_hpi || '');
    setFinalConsultantPMH(foundRecord?.final_consultant_pmh || '');
    setFinalConsultantMedications(foundRecord?.final_consultant_medications || '');
    setFinalConsultantPrescribedMedications(foundRecord?.final_consultant_prescribed_medications || '');
    setFinalConsultantAllergies(foundRecord?.final_consultant_allergies || '');
    setFinalConsultantSocialHistory(foundRecord?.final_consultant_social_history || '');
    setFinalConsultantROS(foundRecord?.final_consultant_ros || '');
    setFinalConsultantVisitDate(foundRecord?.final_consultant_visit_date || foundRecord?.zoom_meeting?.end_time || foundRecord?.zoom_meeting?.start_time || '');
    // Set initial submitted flag from Firestore.
    // The useEffect guard will correct this once reportHistory loads if there's a newer unsubmitted version.
    setIsFinalNoteSubmitted(foundRecord?.is_final_note_submitted || false);
    setDoctorRecommendations(foundRecord?.doctor_recommendations || []);

    // Store live report data for history viewer
    liveReportData.current = {
      finalConsultantNote: foundRecord?.final_consultant_note || '',
      finalConsultantDiagnosis: foundRecord?.final_consultant_diagnosis || '',
      finalConsultantPlan: foundRecord?.final_consultant_plan || '',
      finalConsultantHPI: foundRecord?.final_consultant_hpi || '',
      finalConsultantPMH: foundRecord?.final_consultant_pmh || '',
      finalConsultantMedications: foundRecord?.final_consultant_medications || '',
      finalConsultantPrescribedMedications: foundRecord?.final_consultant_prescribed_medications || '',
      finalConsultantAllergies: foundRecord?.final_consultant_allergies || '',
      finalConsultantSocialHistory: foundRecord?.final_consultant_social_history || '',
      finalConsultantROS: foundRecord?.final_consultant_ros || '',
      finalConsultantVisitDate: foundRecord?.final_consultant_visit_date || foundRecord?.zoom_meeting?.end_time || foundRecord?.zoom_meeting?.start_time || '',
    };
    // Reset history state and preload version history for this session
    setSelectedReportVersion(null);
    setReportHistory([]);
    loadReportHistory(foundRecord?.session_id);

    // Restore selected Assessment & Plan files from saved IDs
    const savedFileIds = foundRecord?.selected_final_note_file_ids || [];
    if (savedFileIds.length > 0) {
      const restoredFiles = fileArray.filter((f) => savedFileIds.includes(f.id));
      setSelectedFinalNoteFiles(restoredFiles);
    }
    setEditDurationTxt(
      calculateDuration(foundRecord?.zoom_meeting?.start_ts, foundRecord?.zoom_meeting?.end_ts) ||
      (foundRecord?.zoom_meeting?.duration ? `${foundRecord.zoom_meeting.duration} minutes` : '')
    )
    setFCDurationTxt(foundRecord?.zoom_meeting?.duration);
    setEditduration(foundRecord?.zoom_meeting?.duration);

    // Check if the answer to the specific question is "yes"
    const emergencyQuestion = filteredConversation.find(convo =>
      convo.question === "Do you need emergency care? (YES/NO)" && convo.answer.toLowerCase() === "yes"
    );

    if (emergencyQuestion) {
      setEmergencyQuest(true);
    }

    setChatHistory([]);
    setShowSummary(true);

    try {
      const allRequests = await getAllFollowupRequests(foundRecord.session_id);
      if (allRequests && allRequests.length > 0) {
        const sortedData = [...allRequests].sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
        setFollowupData(sortedData);
      }
    } catch (error) {
      logger.error('Error fetching all followup requests:', error);
    }

    try {
      const activeRequest = await getActiveFollowupRequest(foundRecord.session_id);
      if (activeRequest) {
        const { activeFlag, data } = activeRequest;

        // Set the check for all follow-up meetings
        setCheckAllFollowupMeet(activeFlag);
        // Update selected follow-up item
        setSelectedItemFollowup(data);

        // Check if zoom meeting exists and is still active (not completed)
        if (data.zoom_meeting && Object.keys(data.zoom_meeting).length > 0 &&
            data.zoom_meeting.meeting_status !== 'completed') {
          setFollowupZoomMeet(true);
        }

        // Check for patient request
        if (data.patient_request) {
          setCheckFollowupMeet(true);
        }
      }
    } catch (error) {
      logger.error('Error fetching active followup request:', error);
    }

    try {
      const illnesses = await getIllnesses();
      setIllnessesList(illnesses);
      setShowLoaderPage(false);
    } catch (error) {
      logger.error('Error fetching illnesses:', error);
    }

    try {
      const reports = await getMedicalReports(foundRecord.reports_id);
      if (reports) {
        setReportData(reports);
      }
    } catch (error) {
      logger.error('Error fetching medical reports:', error);
    }

    try {
      let pcpPharmacy = await getPCPPharmacyDetails(foundRecord.reports_id);
      if (!pcpPharmacy) {
        // Fallback: look up by user_id (covers cases where reports_id doesn't match)
        pcpPharmacy = await getPCPPharmacyByUserId(foundRecord.user_id || userid);
      }
      if (pcpPharmacy) {
        setPCP_Pharmacy(pcpPharmacy);
      }
    } catch (error) {
      logger.error('Error fetching PCP/Pharmacy details:', error);
    } finally {
      setShowLoaderPage(false);
    }

    // Auto-generate AI summary if no real AI summary yet (missing or old Q&A format)
    const needsSummary = (!foundRecord.chatbot_summary || isOldQAFormat(foundRecord.chatbot_summary)) && filteredConversation.length > 0;
    const sid = foundRecord.session_id;
    if (needsSummary && sid && !inflightSummaryRef.current[sid]) {
      inflightSummaryRef.current[sid] = true;
      setIsRegeneratingAI(true);
      fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateAISummary', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sid, user_id: foundRecord.user_id || userid }),
      })
        .then(res => res.json())
        .then(data => {
          if (data.chatbot_summary) {
            setFollowSummaryEditAIChatbot(data.chatbot_summary);
            setPlanOnCareData(data.plan_of_care || '');
            setConditionalDiagnosis(data.conditional_diagnosis || '');
          }
        })
        .catch(err => logger.error('Auto-generate AI summary error:', err))
        .finally(() => {
          delete inflightSummaryRef.current[sid];
          setIsRegeneratingAI(false);
        });
    }

    // Auto-generate Final Consultant Note only when telehealth data is available:
    // zoom_hpi/zoom_pmh from generateZoomCombinedSummary, OR
    // zoom_conditional_diagnosis/zoom_plan_of_care from processZoomMeeting
    const hasZoomData = !!(foundRecord?.zoom_hpi || foundRecord?.zoom_pmh ||
                           foundRecord?.zoom_conditional_diagnosis || foundRecord?.zoom_plan_of_care);
    const hasChatbotSummary = !!(foundRecord?.chatbot_summary);
    const hasFinalNote = !!(foundRecord?.final_consultant_note || foundRecord?.final_consultant_hpi);
    const isNoteSubmitted = !!(foundRecord?.is_final_note_submitted);
    const zoomSummaryAt = foundRecord?.zoom_summary_generated_at;
    const finalNoteAt = foundRecord?.final_consultant_generated_at;
    const zoomNewerThanNote = !!(zoomSummaryAt && finalNoteAt &&
      new Date(zoomSummaryAt) > new Date(finalNoteAt));
    if (hasZoomData && (!hasFinalNote || (zoomNewerThanNote && !isNoteSubmitted)) && sid && !inflightFinalNoteRef.current[sid]) {
      inflightFinalNoteRef.current[sid] = true;
      setIsGeneratingFinalNote(true);
      fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateFinalConsultantNote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sid, user_id: foundRecord.user_id || userid }),
      })
        .then(res => res.json())
        .then(data => {
          if (data.final_consultant_note || data.final_consultant_hpi) {
            setFinalConsultantNote(data.final_consultant_note);
            setFinalConsultantDiagnosis(data.final_consultant_diagnosis || '');
            setFinalConsultantPlan(data.final_consultant_plan || '');
            setFinalConsultantHPI(data.final_consultant_hpi || '');
            setFinalConsultantPMH(data.final_consultant_pmh || '');
            setFinalConsultantMedications(data.final_consultant_medications || '');
            setFinalConsultantPrescribedMedications(data.final_consultant_prescribed_medications || '');
            setFinalConsultantAllergies(data.final_consultant_allergies || '');
            setFinalConsultantSocialHistory(data.final_consultant_social_history || '');
            setFinalConsultantROS(data.final_consultant_ros || '');
            setFinalConsultantVisitDate(data.final_consultant_visit_date || '');
          }
        })
        .catch(err => logger.error('Auto-generate Final Consultant Note error:', err))
        .finally(() => {
          // Keep inflightFinalNoteRef.current[sid] set — prevents re-triggering
          // on subsequent showPatientDataResult calls within the same patient session.
          // It's only cleared when a different patient is loaded.
          setIsGeneratingFinalNote(false);
        });
    }

    // Auto-detect ended followup meetings and process them (transcript + AI summary),
    // then auto-generate the merged followup report.
    // A followup meeting is "ended but unprocessed" when:
    //   - meeting_status is 'active' (not yet processed or completed)
    //   - data_processing_status is falsy (not already in progress)
    //   - end_ts has passed (meeting scheduled end is in the past)
    if (hasFinalNote) {
      try {
        const followups = await getAllFollowupRequests(sid);
        if (followups && followups.length > 0) {
          const nowTs = Math.floor(Date.now() / 1000);

          // Step 1: process any followup meeting that has ended but hasn't been transcribed yet
          const meetingToProcess = followups.find(f => {
            const zm = f.zoom_meeting;
            if (!zm || !zm.meeting_id || zm.data_processing_status) return false;
            // Webhook confirmed ended — process immediately regardless of end_ts
            if (zm.meeting_status === 'ended') return true;
            // Active meeting — only process if scheduled end has passed
            return zm.meeting_status === 'active' && zm.end_ts && zm.end_ts < nowTs;
          });

          if (meetingToProcess && !inflightFollowupProcessRef.current[meetingToProcess.followup_id || meetingToProcess.id]) {
            const fId = meetingToProcess.followup_id || meetingToProcess.id;
            const meetingId = meetingToProcess.zoom_meeting.meeting_id;
            inflightFollowupProcessRef.current[fId] = true;
            try {
              const procRes = await fetchWithAppCheck(
                'https://us-central1-aigicare-prod.cloudfunctions.net/processFollowupZoomMeeting',
                {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ meeting_id: meetingId, followup_id: fId }),
                }
              );
              const procData = await procRes.json();
              if (procRes.ok && procData.status === 'success') {
                // Update local followup list with meeting status = completed and summary fields
                setFollowupData(prev => prev.map(f => {
                  const id = f.followup_id || f.id;
                  if (id !== fId) return f;
                  return {
                    ...f,
                    status: 'completed',
                    zoom_meeting: { ...f.zoom_meeting, meeting_status: 'completed' },
                    followup_summary: procData.followup_summary || f.followup_summary,
                    followup_CD: procData.followup_CD || f.followup_CD,
                    followup_PoC: procData.followup_PoC || f.followup_PoC,
                  };
                }));
                // Hide "Meeting Active" badge since meeting is now completed
                setFollowupZoomMeet(false);
                // Always generate merged report — even without call transcript,
                // the report merges previous report + uploaded docs
                handleGenerateFollowupReport(fId, sid, foundRecord.user_id || userid);
              }
            } catch (procErr) {
              logger.error('Auto-process followup Zoom meeting error:', procErr);
              delete inflightFollowupProcessRef.current[fId];
            }
          } else {
            // No new meeting to process — check if any followup with completed/ended meeting
            // still needs its report generated
            const pendingFollowup = followups.find(f => {
              const zm = f.zoom_meeting;
              const meetingDone = zm && (zm.meeting_status === 'completed' || zm.meeting_status === 'ended');
              const hasSummary = f.followup_summary || f.followup_CD || f.followup_cd || f.followup_PoC || f.followup_poc;
              return !f.report_generated && (hasSummary || meetingDone);
            });
            if (pendingFollowup) {
              const fId = pendingFollowup.followup_id || pendingFollowup.id;
              handleGenerateFollowupReport(fId, sid, foundRecord.user_id || userid);
            }
          }
        }
      } catch (err) {
        logger.error('Auto-trigger followup report error:', err);
      }
    }

  };
  // Group documents by doc_type
  //  const groupedDocuments = (reportData || []).reduce((acc, doc) => {
  //   if (doc && doc.doc_type) {
  //     acc[doc.doc_type] = acc[doc.doc_type] || [];
  //     acc[doc.doc_type].push(doc);
  //   }
  //   return acc;
  // }, {}); 
  // Group reportData by doc_type
  const groupedDocuments = (reportData || []).reduce((acc, doc) => {
    if (!doc.doc_type) {
      return acc;
    }
    const docType = doc.doc_type.trim();

    if (!acc[docType]) {
      acc[docType] = [];
    }

    acc[docType].push({
      doc_id: doc.doc_id,
      doc_summary: doc.doc_summary,
      doc_text: doc.doc_text,
      doc_url: doc.doc_url,
    });


    return acc;
  }, {});

  if (PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name) {
    groupedDocuments["pcp"] = [
      ...(groupedDocuments["pcp"] || []),
      {
        doc_summary: [PCP_Pharmacy.pcp.name, PCP_Pharmacy.pcp.address, PCP_Pharmacy.pcp.phone ? `Phone: ${PCP_Pharmacy.pcp.phone}` : '', PCP_Pharmacy.pcp.fax ? `Fax: ${PCP_Pharmacy.pcp.fax}` : ''].filter(Boolean).join(', '),
        doc_text: null,
        doc_url: null,
      },
    ];
  }
  // Push Pharmacy into groupedDocumentspharmacy
  if (PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name) {
    groupedDocuments["pharmacy"] = [
      ...(groupedDocuments[""] || []),
      {
        doc_summary: [PCP_Pharmacy.pharmacy.name, PCP_Pharmacy.pharmacy.address, PCP_Pharmacy.pharmacy.phone ? `Phone: ${PCP_Pharmacy.pharmacy.phone}` : '', PCP_Pharmacy.pharmacy.fax ? `Fax: ${PCP_Pharmacy.pharmacy.fax}` : ''].filter(Boolean).join(', '),
        doc_text: null,
        doc_url: null,
      },
    ];
  }


  // Map checkOrderList to match groupedDocuments and sort by order
  const sortedGroupedDocuments = checkOrderList.map(orderItem => ({
    Name: orderItem.Name,
    doc_type: orderItem.doc_type,
    documents: groupedDocuments[orderItem.doc_type] || []
  }));

  const adminCheckedSession = async (patientId, sessionId) => {
    try {
      await createAdminLog({
        patient_id: patientId,
        admin_id: adminId,
        session_id: sessionId,
      });
      setBackReload(true);
    } catch (error) {
      logger.error('Error creating admin log:', error);
      setShowLoader(false);
    }
  }

  const handleShowChat = (id) => {
    const filteredConversation = (RecordData.conversation || []).filter(convo => Object.keys(convo).length !== 0);

    setActiveTab(id);
    setAnswerLoader(true)
    setTimeout(() => {
      setChatHistory(filteredConversation);
      setAnswerLoader(false)
    }, 1000);
  }
  const handleHideSummary = () => {
    setActiveTab(0);
    setRecordData([])
    setSelectedIllness()
    if (BackReload) {
      window.location.reload();
    }
    setShowSummary(false)
    setAnswerLoader(false)
    setEmergencyQuest(false)
  };

  const handleShowDashboard = () => {
    setShowSummary(false)
    routeChange()
  };

  const handleDownloadFHIRBundle = async () => {
    if (isDownloadingFHIR) return;
    setIsDownloadingFHIR(true);
    try {
      const bundle = await downloadPatientFHIRBundle(adminId, userid);
      if (!bundle) {
        toast.error('Failed to download FHIR bundle. Please try again.', { position: toast.POSITION.TOP_RIGHT });
        return;
      }
      const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `patient-${userid}-fhir-bundle.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success('FHIR bundle downloaded!', { position: toast.POSITION.TOP_RIGHT });
    } catch (err) {
      logger.error('FHIR bundle download error', err);
      toast.error('An error occurred. Please try again.', { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsDownloadingFHIR(false);
    }
  };
  const handleAssignDoctor = async (sessionId, doctorId) => {
    if (!doctorId || assigningSessionId === sessionId) return;
    setAssigningSessionId(sessionId);
    try {
      const res = await fetchWithAppCheck(
        'https://us-central1-aigicare-prod.cloudfunctions.net/assignDoctorToAppointment',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ admin_id: adminId, session_id: sessionId, doctor_id: doctorId }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        toast.error(data.message || 'Failed to assign doctor.', { position: toast.POSITION.TOP_RIGHT });
        return;
      }
      setUserHistoryData(prev =>
        prev.map(s => s.session_id === sessionId
          ? { ...s, assigned_doctor_id: doctorId, assigned_doctor_name: data.assigned_doctor_name }
          : s
        )
      );
      // Update selectedSession so the signature block reflects the new assignment immediately
      if (selectedSession && (selectedSession.session_id === sessionId || selectedSession.id === sessionId)) {
        setSelectedSession(prev => ({
          ...prev,
          assigned_doctor_id: doctorId,
          assigned_doctor_name: data.assigned_doctor_name,
          assigned_doctor_specialty: data.assigned_doctor_specialty || prev?.assigned_doctor_specialty || '',
          assigned_doctor_phone: data.assigned_doctor_phone || prev?.assigned_doctor_phone || '',
          assigned_doctor_signature: data.assigned_doctor_signature || prev?.assigned_doctor_signature || '',
        }));
      }
      toast.success('Doctor assigned successfully!', { position: toast.POSITION.TOP_RIGHT });
    } catch (err) {
      toast.error('An error occurred while assigning doctor.', { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setAssigningSessionId(null);
    }
  };

  const renderTableBody = () => {
    const start = (currentPage - 1) * recordsPerPage;
    const end = start + recordsPerPage;
    const pageData = UserHistoryData?.slice(start, end);

    return pageData.map((UserHistoryData, index) => (
      <tr
        key={index}
        onClick={() => handleShowSummary(UserHistoryData.session_id)}
        style={{
          cursor: 'pointer',
          backgroundColor: viewedSessionMap[UserHistoryData.session_id] ? '#ffffff' : '#c4ccd8',
        }}
        className={`${viewedSessionMap[UserHistoryData.session_id] ? 'row-opened' : 'row-unopened'} ${UserHistoryData.session === 'true' ? 'active' : ''}`}
      >
        <td><span className="d-flex align-items-center"><img src={Icons[0].admin_listIcon} style={{ marginRight: '10px' }} />{UserHistoryData.illness}</span></td>
        {/* <td style={{textAlign:'center'}}> {moment(UserHistoryData.created_on).format('MMM DD, YYYY')}</td>
        <td style={{textAlign:'right'}}> <button className="viewBtnClass">View</button></td>  */}
        <td style={{ textAlign: 'center' }}>
          {UserHistoryData.weight || UserHistoryData.height ? (
            <>
              {UserHistoryData.height ? `${formatHeight(UserHistoryData.height)}  / ` : null}
              {UserHistoryData.weight ? `${UserHistoryData.weight} lbs` : null}
            </>
          ) : (
            "-"
          )}
        </td>
        <td style={{ textAlign: 'center' }}> {formatConsultationDate(UserHistoryData.created_on, UserHistoryData.created_at)}</td>
        <td style={{ textAlign: 'center' }}>
          {UserHistoryData.patientstatus ? (() => {
            const GI_PCP = ['shared_with_pcp','in_review','under_review','approved','needs_signature'];
            const s = UserHistoryData.patientstatus;
            const label = GI_PCP.includes(s) ? 'Pending' : s.charAt(0).toUpperCase() + s.slice(1).replace(/_/g,' ');
            const cls = GI_PCP.includes(s) ? 'colorpending' : `color${s}`;
            return <span className={`selectedItemBtn ${cls}`} style={{ margin: 'auto' }}>{label}</span>;
          })() : '-'}
        </td>
        <td style={{ textAlign: 'center' }} onClick={e => e.stopPropagation()}>
          {(isAdmin() || isMA()) ? (
            <select
              value={UserHistoryData.assigned_doctor_id || ''}
              onChange={e => handleAssignDoctor(UserHistoryData.session_id, e.target.value)}
              disabled={assigningSessionId === UserHistoryData.session_id}
              style={{ fontSize: '12px', padding: '3px 6px', borderRadius: '4px', border: '1px solid #ccc', maxWidth: '140px', cursor: 'pointer' }}
            >
              <option value="">-- Assign Doctor --</option>
              {doctorsList.map(d => (
                <option key={d.id} value={d.id}>{d.fullName || d.email}</option>
              ))}
            </select>
          ) : (
            <span style={{ fontSize: '12px', color: '#555' }}>
              {UserHistoryData.assigned_doctor_name || '—'}
            </span>
          )}
        </td>
        <td style={{ textAlign: 'right' }}> <button className="viewBtnClass">View</button></td>
      </tr>
    ));


  };

  const renderPagination = () => {
    let pages = [];
    const startPage = (currentPageGroup - 1) * 3 + 1;
    const endPage = Math.min(startPage + 2, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`page-button ${i === currentPage ? 'active' : ''}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination">
        <button
          onClick={handlePrevGroup}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {pages}
        <button
          onClick={handleNextGroup}
          disabled={currentPage === totalPages}
        >
          Next
        </button>

      </div>
    );
  };


  useEffect(() => {
    // handleUserRemove()

    handleMyInsurance(UserId)
    const fetchRecords = async () => {
      setShowLoaderPage(true);

      try {
        const sessionData = await getUserSessions(userid);

        // HIPAA audit log: admin viewed patient PHI
        if (userid && adminId) {
          createAdminLog({
            action: 'patient_phi_viewed',
            admin_id: adminId,
            patient_id: userid,
            session_id: id || '',
          }).catch(() => {});
        }

        if (sessionData) {
          // Set user profile data
          setUserProfileData(sessionData.user_details);

          // Sort history: most recent appointments first (by date)
          const sortedHistory = [...(sessionData.history || [])]
            .map((item) => ({
              ...item,
              session_id: item.session_id || item.id || '',
              created_on: item.created_on || item.created_at || null,
            }))
            .sort((a, b) => {
              const dateA = new Date(a.created_on || a.created_at || 0).getTime();
              const dateB = new Date(b.created_on || b.created_at || 0).getTime();
              return dateB - dateA;
            });

          // Doctors only see sessions that are assigned to them
          const filteredHistory = isDoctor()
            ? sortedHistory.filter(s => s.assigned_doctor_id === adminId)
            : sortedHistory;

          setUserHistoryData(filteredHistory);
          setUserHistoryNumber(filteredHistory.length);
          const ud = sessionData.user_details || {};
          setBMITxt(sessionData.bmi ? sessionData.bmi : 0);
          setFullName(ud.fullName || '');
          setEmail(ud.email || '');
          setDOBTxt(ud.dob || '');
          setPhoneNumber(
            ud.phoneNumber
              ? (ud.phoneNumber.startsWith('+')
                ? ud.phoneNumber
                : '+' + ud.phoneNumber)
              : ''
          );
          setUserProfile(ud.userProfile || '');
          setInsuranceIdTxt(ud.insurance ? ud.insurance : 0);
          setGenderTxt(ud.gender ? ud.gender : '');
          setHeightTxt(ud.height ? ud.height : 0);
          setWeightTxt(ud.weight ? ud.weight : 0);
          setIsSession(sessionData.session_status ? sessionData.session_status : 'false');

          // Populate insurance — try sessionData first, then fallback with all known IDs
          if (sessionData.insurance_data && sessionData.insurance_data.length > 0) {
            applyInsuranceData(sessionData.insurance_data[0]);
          } else {
            // Build list of every unique user ID we can find for this patient
            const userDetails = sessionData.user_details || {};
            const sessionUserIds = (sessionData.history || []).slice(0, 5).map(h => h.user_id).filter(Boolean);
            const allIds = [userid, userDetails.id, userDetails.user_id, ...sessionUserIds]
              .filter(Boolean)
              .filter((v, i, a) => a.indexOf(v) === i);

            let insuranceFound = false;
            for (const uid of allIds) {
              try {
                const list = await getInsuranceData(uid);
                if (list && list.length > 0) {
                  applyInsuranceData(list[0]);
                  insuranceFound = true;
                  break;
                }
              } catch (e) {
                logger.warn('Insurance fetch attempt failed for uid:', uid);
              }
            }
            // Patient-specific localStorage fallback — safe, no cross-patient bleed
            const fbKey = id || userid;
            if (!insuranceFound && fbKey) {
              try {
                const cached = JSON.parse(localStorage.getItem(`ins_${fbKey}`) || 'null');
                if (cached && (cached.insurance_carrier || cached.group_name || cached.policy_id)) {
                  setMyinsuranceinfo(cached);
                }
              } catch (e) {}
            }
          }
        }
      } catch (error) {
        logger.error('Error fetching records:', error);
        toast.error('Failed to load patient sessions');
      }

      setShowLoaderPage(false);
    };
    fetchRecords();
  }, []);

  useEffect(() => {
    const loadViewedSessions = async () => {
      if (!userid) return;
      const sessionIds = await getAdminViewedSessionIds(userid, adminId);
      const viewed = {};
      sessionIds.forEach((sessionId) => {
        viewed[sessionId] = true;
      });
      setViewedSessionMap(viewed);
    };
    loadViewedSessions();
  }, [userid, adminId]);

  useEffect(() => {
    const handlePopstate = () => {
      setActiveTab(0); // Reset the active tab to the default tab index
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const handleTabClick = (index) => {
    setActiveTab(index);
    setShowMainPoint(false);
    // Load report history when Final Consultant Note tab is activated
    if (index === 5 && reportHistory.length === 0) {
      loadReportHistory();
    }
  };

  useEffect(() => {
    setActiveTab(0); // Set the default active tab when the component mounts
  }, []);

  // Function to process the user data
  const processUserData = () => {
    if (!RecordData) return []; // If no recordData, return empty array

    return [RecordData].map(user => {
      // Remove empty objects from the conversation array
      const filteredConversation = (user.conversation || []).filter(convo => Object.keys(convo).length !== 0);

      // Check if the answer to the specific question is "yes"
      const emergencyQuestion = filteredConversation.find(convo =>
        convo.question === "Do you need emergency care? (YES/NO)" && convo.answer.toLowerCase() === "yes"
      );

      if (emergencyQuestion) {
        toast.warning("Emergency care is needed!", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }

      return {
        ...user,
        conversation: filteredConversation
      };
    });
  };
  const [ImageHide, setImageHide] = useState(false);
  const [showMainPoint, setShowMainPoint] = useState(false);
  const [showMainPointCD, setShowMainPointCD] = useState(false);
  const [showMainPointFollowCD, setShowMainPointFollowCD] = useState(false);
  const [showSummaryEditFollowup, setShowSummaryEditFollowup] = useState(false);
  const [showSummaryEditAIChatbot, setShowSummaryEditAIChatbot] = useState(false);
  const [showZoomSummaryEdit, setShowZoomSummaryEdit] = useState(false);
  const [showMainPointFollowPoC, setShowMainPointFollowPoC] = useState(false);

  const handleInputMainPoint = () => {
    if (!canEditClinical()) return;
    setShowMainPoint(false);
    {
      !PlanOnCareData ?
      (<>
        setShowMainPoint(false);
      </>
      ) : (
        <>
          setShowMainPoint(true);
        </>
      )
    }
    setShowMainPoint(true);
    setPlanOnCareData(PlanOnCareData);
  };
  const handleCancelClickMPoint = () => {
    setShowLoader(false);
    setShowMainPoint(false);
  };
  const handleInputChangeMPoint = (e) => {
    setPlanOnCareData(e.target.value);
  };
  const handleSaveClickMPoint = () => {
    setShowLoader(true);
    setTimeout(() => {
      setIsEditing(false);
      handleSaveMPoint();
    }, 2000);
  };
  const handleSaveMPoint = async (event) => {
    if (!canEditClinical()) return;
    try {
      await updateChatSession(SessionIDCheck, { plan_of_care: PlanOnCareData });
      saveFHIRCarePlan(PlanOnCareData, userid, SessionIDCheck).catch(err => logger.error('FHIR care plan save failed:', err));

      toast.success('Plan of care updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      });

      setShowLoader(false);
      setShowMainPoint(false);
      setBackReload(true);
    } catch (error) {
      logger.error('Error updating plan of care:', error);
      toast.error(error.message || 'Failed to update plan of care', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }
  };
  //conditionaldiagnosis
  const handleInputMainPointCD = () => {
    if (!canEditClinical()) return;
    setShowMainPointCD(false);
    {
      !ConditionalDiagnosis ?
      (<>
        setShowMainPointCD(false);
      </>
      ) : (
        <>
          setShowMainPointCD(true);
        </>
      )
    }
    setShowMainPointCD(true);
    setConditionalDiagnosis(ConditionalDiagnosis);
  };
  const handleCancelClickMPointCD = () => {
    setShowLoader(false);
    setShowMainPointCD(false);
  };
  const handleInputChangeMPointCD = (e) => {
    setConditionalDiagnosis(e.target.value);
  };
  const handleSaveClickMPointCD = () => {
    setShowLoader(true);
    setTimeout(() => {
      setIsEditingCD(false);
      handleSaveMPointCD();
    }, 2000);
  };
  const handleSaveMPointCD = async (event) => {
    if (!canEditClinical()) return;
    try {
      await updateChatSession(SessionIDCheck, { conditional_diagnosis: ConditionalDiagnosis });
      saveFHIRCondition(ConditionalDiagnosis, userid, SessionIDCheck, selectedIllness || null).catch(err => logger.error('FHIR condition save failed:', err));

      toast.success('Conditional diagnosis updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      });

      setShowLoader(false);
      setShowMainPointCD(false);
      setBackReload(true);
    } catch (error) {
      logger.error('Error updating conditional diagnosis:', error);
      toast.error(error.message || 'Failed to update conditional diagnosis', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    } finally {
      setLoading(false);
    }
  };

  //Follow conditionaldiagnosis  



  const handleInputMainPointFollowCD = (id, followup_CD, index) => {
    if (!canEditClinical()) return;
    setEditingAccordion(id);
    // setUpdatedContent(followup_CD);
    setUpdatedContent((prev) => ({ ...prev, [id]: followup_CD })); // Initialize content for this id

    setShowMainPointFollowCD(false);
    {
      !ConditionalDiagnosis ?
      (<>
        setShowMainPointFollowCD(false);
      </>
      ) : (
        <>
          setShowMainPointFollowCD(true);
        </>
      )
    }
    setShowMainPointFollowCD(true);
    setFollowConditionalDiagnosis(followup_CD);
  };
  const handleCancelClickMPointFollowCD = () => {
    setShowLoader(false);
    setShowMainPointFollowCD(false);
    setEditingAccordion(null);
    setActiveAccordion(null);
  };
  const handleInputChangeMPointFollowCD = (e) => {
    setFollowConditionalDiagnosis(e.target.value);
  };
  const handleSaveClickMPointFollowCD = (followup_id, index) => {
    setShowLoader(true);
    setTimeout(() => {
      setIsEditingFollowCD(false);
      handleSaveMPointFollowCD(followup_id);
    }, 2000);
  };
  const handleSaveMPointFollowCD = async (followup_id) => {
    if (!canEditClinical()) return;
    const data = {
      followup_id: followup_id,
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      followup_cd: updatedContent,
    };
    try {
      await updateFollowupCD(followup_id, updatedContent);

      toast.success('Followup conditional diagnosis updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      });

      setShowLoader(false);
      setShowMainPointFollowCD(false);
      setBackReload(true);
      setEditingAccordion(null);
      setActiveAccordion(null);
    } catch (error) {
      logger.error('Error updating followup CD:', error);
      toast.error(error.message || 'Failed to update followup conditional diagnosis', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    } finally {
      setLoading(false);
    }
  };

  //Follow Plan of Care
  const handleInputMainPointFollowPoC = (followup_PoC) => {
    if (!canEditClinical()) return;
    setShowMainPointFollowPoC(false);
    {
      !ConditionalDiagnosis ?
      (<>
        setShowMainPointFollowPoC(false);
      </>
      ) : (
        <>
          setShowMainPointFollowPoC(true);
        </>
      )
    }
    setShowMainPointFollowPoC(true);
    setFollowPlanOnCareData(followup_PoC);
  };
  const handleCancelClickMPointFollowPoC = () => {
    setShowLoader(false);
    setShowMainPointFollowPoC(false);
  };
  const handleInputChangeMPointFollowPoC = (e) => {
    setFollowPlanOnCareData(e.target.value);
  };
  const handleSaveClickMPointFollowPoC = (followup_id) => {
    setShowLoader(true);
    setTimeout(() => {
      setIsEditingFollowPoC(false);
      handleSaveMPointFollowPoC(followup_id);
    }, 2000);
  };
  const handleSaveMPointFollowPoC = async (followup_id) => {
    if (!canEditClinical()) return;
    const data = {
      followup_id: followup_id,
      admin_id: adminId,
      session_id: SessionIDCheck,
      user_id: userid,
      followup_poc: followPlanOnCareData,
    };
    try {
      await updateFollowupPoC(followup_id, followPlanOnCareData);

      toast.success('Followup plan of care updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      });

      setShowLoader(false);
      setShowMainPointFollowPoC(false);
      setBackReload(true);
    } catch (error) {
      logger.error('Error updating followup PoC:', error);
      toast.error(error.message || 'Failed to update followup plan of care', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    } finally {
      setLoading(false);
    }
  };


  //Summary Edit Followup 
  const handleInputMainSummaryEditFollowup = (id, followup_CD) => {
    setEditMode(id);
    setEditText(followup_CD);
    setShowSummaryEditFollowup(false);
    {
      !ConditionalDiagnosis ?
      (<>
        setShowSummaryEditFollowup(false);
      </>
      ) : (
        <>
          setShowSummaryEditFollowup(true);
        </>
      )
    }
    setShowSummaryEditFollowup(true);
    setFollowSummaryEditFollowup(followup_CD);
  };
  const handleCancelClickSummaryEditFollowup = () => {
    setShowLoaderSummaryFollowup(false);
    setShowSummaryEditFollowup(false);
    setEditMode(null);
    setEditText('');
  };
  const handleInputChangeSummaryEditFollowup = (e) => {
    setFollowSummaryEditFollowup(e.target.value);
  };
  const handleSaveClickSummaryEditFollowup = (followup_id) => {
    setShowLoaderSummaryFollowup(true);
    setTimeout(() => {
      setIsEditingFollowCD(false);
      handleSaveMPointFollowCD(followup_id);
    }, 2000);
  };
  const handleSaveSummaryEditFollowup = async (followup_id, index) => {
    setShowLoaderSummaryFollowup(true);
    let durationVal = index === 1 ? EditdurationFollow1 :
      index === 2 ? EditdurationFollow2 :
        EditdurationFollow3;

    try {
      // Prepare update data, only include duration if it has a value
      const updateData = {
        followup_summary: editText,
      };

      // Only add duration if it's not empty/undefined
      if (durationVal !== undefined && durationVal !== null && durationVal !== '') {
        updateData.duration = durationVal;
      }

      await updateFollowupSummary(followup_id, updateData);

      toast.success('Followup summary updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      });

      // Update the followupData state to reflect the changes
      setFollowupData((prevData) =>
        prevData.map((item) =>
          item.followup_id === followup_id
            ? { ...item, followup_summary: editText }
            : item
        )
      );

      if (durationVal) {
        if (index === 1) {
          setFCDurationFollowTxt1(durationVal);
        } else if (index === 2) {
          setFCDurationFollowTxt2(durationVal);
        } else if (index === 3) {
          setFCDurationFollowTxt3(durationVal);
        }
      }

      setShowLoaderSummaryFollowup(false);
      setShowSummaryEditFollowup(false);
      setBackReload(true);
      setEditMode(null);
      setEditText('');
    } catch (error) {
      logger.error('Error updating followup summary:', error);
      toast.error(error.message || 'Failed to update followup summary', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoaderSummaryFollowup(false);
    } finally {
      setLoading(false);
    }
  };



  //Summary Chatbot Followup 
  const handleInputMainSummaryEditAIChatbot = (followup_CD) => {
    if (!canEditClinical()) return;
    setShowSummaryEditAIChatbot(false);
    {
      !ConditionalDiagnosis ?
      (<>
        setShowSummaryEditAIChatbot(false);
      </>
      ) : (
        <>
          setShowSummaryEditAIChatbot(true);
        </>
      )
    }
    setShowSummaryEditAIChatbot(true);
    setFollowSummaryEditAIChatbot(followup_CD);
  };
  const handleCancelClickSummaryEditAIChatbot = () => {
    setShowLoaderSummaryAIChatbot(false);
    setShowSummaryEditAIChatbot(false);
  };
  const handleInputChangeSummaryEditAIChatbot = (e) => {
    setFollowSummaryEditAIChatbot(e.target.value);
  };
  const handleSaveClickSummaryEditAIChatbot = () => {
    setShowLoaderSummaryAIChatbot(true);
  };
  const handleSaveSummaryEditAIChatbot = async () => {
    if (!canEditClinical()) return;
    setShowLoaderSummaryAIChatbot(true);

    try {
      // Prepare update data, only include duration if it has a value
      const updateData = {
        chatbot_summary: followSummaryEditAIChatbot,
      };

      // Only add duration if it's not empty/undefined
      if (Editduration !== undefined && Editduration !== null && Editduration !== '') {
        updateData.duration = Editduration;
      }

      await updateChatSession(SessionIDCheck, updateData);

      toast.success('Main summary updated successfully', {
        position: toast.POSITION.TOP_RIGHT,
      });

      setShowLoaderSummaryAIChatbot(false);
      setShowSummaryEditAIChatbot(false);
      setBackReload(true);
      if (Editduration) {
        setFCDurationTxt(Editduration);
      }
    } catch (error) {
      logger.error('Error updating main summary:', error);
      toast.error(error.message || 'Failed to update main summary', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoaderSummaryAIChatbot(false);
    } finally {
      setLoading(false);
    }
  };


  //---------------------------------//




  //---------------------------------//




  // Function to copy email to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success("Text copied to clipboard!", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        logger.error("Failed to copy text: ", error);
        toast.error("Failed to copy text", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleCopyAll = () => {
    const hiddenDiv = contentRef.current;

    // Show the hidden div
    hiddenDiv.style.display = 'block';
    const textContent = hiddenDiv.innerHTML.replace(/<\/span>/g, '</span>\n');
    // Select the text inside the div
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(hiddenDiv);
    selection.removeAllRanges();
    selection.addRange(range);

    // Copy the selected text to the clipboard
    document.execCommand('copy');


    // Clear the selection
    selection.removeAllRanges();
    toast.success("Summary copied to clipboard!", {
      position: toast.POSITION.TOP_RIGHT,
    });

  };

  // Copy Final Note as clean plain-text for EMR paste
  const copyFinalNoteAsText = () => {
    const stripBold = (t) => (t || '').replace(/\*\*(.*?)\*\*/g, '$1');
    const lines = [];

    lines.push('FINAL CONSULTANT NOTE');
    lines.push('=====================');
    lines.push('');

    // Provider / PCP / Pharmacy
    if (reportProviderName) {
      lines.push(`PROVIDER: ${reportProviderName}${reportProviderSpecialty ? ' | ' + reportProviderSpecialty : ''}${reportProviderPhone ? ' | Phone: ' + reportProviderPhone : ''}`);
    }
    if (PCP_Pharmacy?.pcp?.name) {
      let pcpLine = `PCP: ${PCP_Pharmacy.pcp.name}`;
      if (PCP_Pharmacy.pcp.address) pcpLine += ` | ${PCP_Pharmacy.pcp.address}`;
      if (PCP_Pharmacy.pcp.phone) pcpLine += ` | Phone: ${PCP_Pharmacy.pcp.phone}`;
      if (PCP_Pharmacy.pcp.fax) pcpLine += ` | Fax: ${PCP_Pharmacy.pcp.fax}`;
      lines.push(pcpLine);
    }
    if (PCP_Pharmacy?.pharmacy?.name) {
      let pharmaLine = `PHARMACY: ${PCP_Pharmacy.pharmacy.name}`;
      if (PCP_Pharmacy.pharmacy.address) pharmaLine += ` | ${PCP_Pharmacy.pharmacy.address}`;
      if (PCP_Pharmacy.pharmacy.phone) pharmaLine += ` | Phone: ${PCP_Pharmacy.pharmacy.phone}`;
      if (PCP_Pharmacy.pharmacy.fax) pharmaLine += ` | Fax: ${PCP_Pharmacy.pharmacy.fax}`;
      lines.push(pharmaLine);
    }
    lines.push('');

    // Patient Demographics
    if (fullName) lines.push(`PATIENT: ${fullName}`);
    const demoItems = [];
    if (DOBTxt) demoItems.push(`DOB: ${moment(DOBTxt).format('MMM DD, YYYY')}`);
    if (ageCal) demoItems.push(`Age: ${ageCal} yrs`);
    if (GenderTxt) demoItems.push(`Sex: ${GenderTxt}`);
    if (phoneNumber) demoItems.push(`Phone: ${phoneNumber}`);
    if (demoItems.length > 0) lines.push(demoItems.join(' | '));
    lines.push('');

    // Vitals
    if (BMITxt || HeightTxt || WeightTxt) {
      const vitals = [];
      if (BMITxt) vitals.push(`BMI: ${BMITxt}`);
      if (HeightTxt) vitals.push(`Height: ${HeightTxt} cm`);
      if (WeightTxt) vitals.push(`Weight: ${WeightTxt} lbs`);
      lines.push(`VITALS: ${vitals.join(' | ')}`);
      lines.push('');
    }

    // Date of Consultation
    if (finalConsultantVisitDate) {
      lines.push(`DATE OF CONSULTATION: ${moment(finalConsultantVisitDate).format('MMMM DD, YYYY')}`);
      lines.push('');
    }

    // Chief Complaint
    let complaint = selectedIllness || RecordData?.illness || '';
    if (!complaint) {
      const hpi = finalConsultantHPI || zoomHPI || '';
      const m = hpi.match(/presents?\s+with\s+([^.,]+)/i);
      if (m) complaint = m[1].trim();
      else if (hpi) complaint = hpi.split(/[.!?]/)[0].trim().slice(0, 150);
    }
    if (complaint) {
      lines.push('CHIEF COMPLAINT:');
      lines.push(complaint);
      lines.push('');
    }

    // Insurance
    if (myinsuranceinfo?.insurance_carrier || myinsuranceinfo?.policy_id) {
      const insItems = [];
      if (myinsuranceinfo.insurance_carrier) insItems.push(myinsuranceinfo.insurance_carrier);
      if (myinsuranceinfo.group_name) insItems.push(`Group: ${myinsuranceinfo.group_name}`);
      if (myinsuranceinfo.policy_id) insItems.push(`ID: ${myinsuranceinfo.policy_id}`);
      lines.push(`INSURANCE: ${insItems.join(' | ')}`);
      lines.push('');
    }

    // Clinical Sections
    const addSection = (title, value) => {
      if (!value) return;
      lines.push(`${title}:`);
      lines.push(stripBold(value));
      lines.push('');
    };

    if (finalConsultantHPI) {
      addSection('HISTORY OF PRESENT ILLNESS (HPI)', finalConsultantHPI);
      addSection('PAST MEDICAL HISTORY (PMH)', finalConsultantPMH || extractChatbotSection(followSummaryEditAIChatbot, 'PAST MEDICAL AND SURGICAL HISTORY', 'PAST MEDICAL HISTORY'));
      addSection('CURRENT MEDICATIONS', finalConsultantMedications || extractChatbotSection(followSummaryEditAIChatbot, 'CURRENT MEDICATIONS', 'MEDICATIONS'));
      addSection('PRESCRIBED MEDICATIONS', finalConsultantPrescribedMedications);
      addSection('ALLERGIES', finalConsultantAllergies || extractChatbotSection(followSummaryEditAIChatbot, 'ALLERGIES'));
      addSection('SOCIAL HISTORY', finalConsultantSocialHistory || extractChatbotSection(followSummaryEditAIChatbot, 'SOCIAL HISTORY'));
      addSection('REVIEW OF SYSTEMS', finalConsultantROS);
    }
    addSection('ASSESSMENT & DIFFERENTIAL DIAGNOSIS', finalConsultantNote);
    addSection('PLAN OF CARE', finalConsultantPlan);

    // Doctor Recommendations
    if (doctorRecommendations.length > 0) {
      lines.push('INVESTIGATIONS SUGGESTED:');
      doctorRecommendations.forEach(rec => lines.push(`- ${rec}`));
      lines.push('');
    }

    // Selected Assessment & Plan file names
    if (selectedFinalNoteFiles.length > 0) {
      lines.push('ATTACHED DOCUMENTS:');
      selectedFinalNoteFiles.forEach(f => lines.push(`- ${f.fileName}`));
      lines.push('');
    }

    // Physician Signature
    if (reportProviderName) {
      lines.push('---');
      lines.push('Electronically Reviewed & Signed');
      lines.push(reportProviderName);
      if (reportProviderSpecialty) lines.push(reportProviderSpecialty);
      if (reportProviderPhone) lines.push(`Phone: ${reportProviderPhone}`);
      lines.push(`Date: ${moment().format('MMM DD, YYYY')}`);
    }

    const text = lines.join('\n');
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success("Final Note copied to clipboard! Ready to paste in EMR.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        logger.error("Failed to copy final note: ", error);
        toast.error("Failed to copy text", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  // Categorized file array
  const fileCategories = [
    {
      category: 'Labs',
      files: [
        { id: 5, fileName: 'Basic Gastro Labs', url: BasicGastroLabs },
        { id: 3, fileName: 'Anemia Labs', url: AnemiaLabs },
        { id: 14, fileName: 'Heaptic Labs', url: HeapticLabs },
        { id: 19, fileName: 'Stool Studies', url: StoolStudies },
      ],
    },
    {
      category: 'Imaging',
      files: [
        { id: 1, fileName: 'Abdominal CT', url: AbdominalCT },
        { id: 2, fileName: 'Abdominal US', url: AbdominalUS },
        { id: 4, fileName: 'Barium Studies', url: BariumStudies },
      ],
    },
    {
      category: 'Procedure',
      files: [
        { id: 10, fileName: 'EGD Order', url: EGDOrder },
        { id: 6, fileName: 'Colon Order', url: ColonOrder },
        { id: 7, fileName: 'Colonoscopy', url: Colonoscopy },
        { id: 22, fileName: 'Upper GI Endoscopy', url: UpperGIEndoscopy },
        { id: 18, fileName: 'Procedural Sedation', url: ProceduralSedation },
        { id: 8, fileName: 'Colon Screening Guidelines', url: ColonScreeningGuidelines },
        { id: 21, fileName: 'Telehealth Disclaimer', url: TelehealthDisclaimer },
      ],
    },
    {
      category: 'Diet & Lifestyle Modification',
      files: [
        { id: 23, fileName: 'Weight Reducing Diet', url: Weight_Reducing_Diet },
        { id: 15, fileName: 'High Fiber Diet', url: High_Fiber_Diet },
        { id: 13, fileName: 'GERD and Lifestyle', url: GERD_Diet_and_Lifestyle },
        { id: 20, fileName: 'Stress Management', url: StressManagement },
        { id: 11, fileName: 'FattyLiver', url: FattyLiver },
        { id: 9, fileName: 'Diverticulosis', url: Diverticulosis },
        { id: 17, fileName: 'Irritable Bowel Syndrome', url: IrritableBowelSyndrome },
        { id: 16, fileName: 'Inflammatory Bowel Disease', url: InflammatoryBowelDisease },
      ],
    },
  ];
  // Flat array for backward compatibility (restore selected files, etc.)
  const fileArray = fileCategories.flatMap((cat) => cat.files);

  const contentRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);


  const handleCheckboxChange = (file) => {
    setSelectedFiles((prevSelectedFiles) => {
      const exists = prevSelectedFiles.find((f) => f.id === file.id);
      if (exists) {
        // Remove the file if it already exists in the selected list
        return prevSelectedFiles.filter((f) => f.id !== file.id);
      } else {
        // Add the file if not already selected
        return [...prevSelectedFiles, file];
      }
    });
  };



  const downloadPDF = (patientName) => {
    setTimeout(() => {
      const input = contentRef.current;

      if (!input) {
        logger.error("Element not found in the document.");
        return;
      }

      html2canvas(input).then((canvas) => {
        const pdf = new jsPDF("p", "mm", "a4");

        // Define margins
        const marginLeft = 10; // Left margin in mm
        const marginTop = 10; // Top margin in mm
        const marginRight = 10; // Right margin in mm
        const marginBottom = 10; // Bottom margin in mm

        const pdfWidth = pdf.internal.pageSize.getWidth() - marginLeft - marginRight; // Content width
        const pdfHeight = pdf.internal.pageSize.getHeight() - marginTop - marginBottom; // Content height

        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        const ratio = pdfWidth / canvasWidth; // Scale factor for canvas to fit PDF width
        const scaledHeight = canvasHeight * ratio;

        let currentHeight = 0;
        let pageNumber = 1; // Start page number

        while (currentHeight < canvasHeight) {
          const sectionCanvas = document.createElement("canvas");
          const sectionContext = sectionCanvas.getContext("2d");

          sectionCanvas.width = canvasWidth;
          sectionCanvas.height = Math.min(canvasHeight - currentHeight, pdfHeight / ratio);

          sectionContext.drawImage(
            canvas,
            0,
            currentHeight,
            canvasWidth,
            sectionCanvas.height,
            0,
            0,
            canvasWidth,
            sectionCanvas.height
          );

          const sectionImageData = sectionCanvas.toDataURL("image/png");

          if (currentHeight > 0) pdf.addPage();

          pdf.addImage(
            sectionImageData,
            "PNG",
            marginLeft,
            marginTop,
            pdfWidth,
            (sectionCanvas.height * pdfWidth) / canvasWidth
          );

          // Add page number in the footer
          const pageHeight = pdf.internal.pageSize.getHeight();
          pdf.setFontSize(8);
          pdf.text(`Page ${pageNumber}`, pdf.internal.pageSize.getWidth() / 2, pageHeight - 4, { align: "center" });

          pageNumber++;
          currentHeight += sectionCanvas.height;
        }

        // Generate filename
        const now = new Date();
        const date = now.toISOString().split("T")[0]; // yyyy-mm-dd format
        const time = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // HH-MM-SS format
        const PatientNameTxt = patientName.replace(/ /g, "_");
        const filename = `${date}_${time}_${PatientNameTxt}_Report.pdf`;

        pdf.save(filename);
      }).catch((error) => {
        logger.error("Error generating PDF:", error);
      });
    }, 100); // Delay of 100ms or adjust as needed
  };


  const generateFilename = (fullName) => {
    const now = new Date();
    const date = now.toISOString().split("T")[0]; // Format YYYY-MM-DD
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // Format HH-MM-SS
    const sanitizedFullName = fullName.replace(/ /g, "_"); // Replace spaces with underscores
    return `${date}_${time}_${sanitizedFullName}_Report.pdf`;
  };

  const generateShareFilename = (fullName) => {
    const now = new Date();
    const date = now.toISOString().split("T")[0]; // Format YYYY-MM-DD
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // Format HH-MM-SS
    const sanitizedFullName = fullName.replace(/ /g, "_"); // Replace spaces with underscores
    return `${sanitizedFullName}-${date}-${time} Report File`;
  };

  const downloadPdfNew = async (fullName, selectedFiles) => {
    try {
      // setIsGeneratingPdf(true); // Hide the "Copy All" button
      const filename = generateFilename(fullName);
      const content = contentRef.current;
      const headerImageUrl = Icons[0].headerImageUrlLink;
      const footerImageUrl = Icons[0].footerImageUrlLink;

      if (!content) {
        logger.error("Content not found!");
        return;
      }

      // Step 1: Generate the PDF content using html2pdf.js
      const options = {
        margin: [1.47, 0.2, 1.1, 0.2], // [top, left, bottom, right] in inches
        filename: filename, // Output filename
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      };

      const contentPdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .outputPdf('blob'); // Generate a Blob directly

      // Step 2: Load the generated content PDF into pdf-lib
      const contentPdfDoc = await PDFDocument.load(await contentPdfBlob.arrayBuffer());

      // Step 3: Create a new merged PDF document
      const mergedPdfDoc = await PDFDocument.create();

      // Step 4: Add modal content pages to merged PDF
      const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
      contentPages.forEach((page) => mergedPdfDoc.addPage(page));

      // Step 5: Filter and merge selected files
      const validSelectedFiles = selectedFiles.filter((file) => file.url);
      if (validSelectedFiles.length === 0) {
        logger.warn("No valid files selected for merging.");
      }

      for (const file of validSelectedFiles) {
        const fileBlob = await fetch(file.url).then((res) => res.blob());
        const filePdf = await PDFDocument.load(await fileBlob.arrayBuffer());
        const filePages = await mergedPdfDoc.copyPages(filePdf, filePdf.getPageIndices());
        filePages.forEach((page) => mergedPdfDoc.addPage(page));
      }

      // Step 6: Add headers and footers to the merged PDF
      const totalPages = mergedPdfDoc.getPageCount();

      // Load images for header and footer
      const headerImageBytes = await fetch(headerImageUrl).then((res) => res.arrayBuffer());
      const footerImageBytes = await fetch(footerImageUrl).then((res) => res.arrayBuffer());
      const headerImage = await mergedPdfDoc.embedPng(headerImageBytes);
      const footerImage = await mergedPdfDoc.embedPng(footerImageBytes);

      for (let i = 0; i < totalPages; i++) {
        const page = mergedPdfDoc.getPage(i);
        const { width, height } = page.getSize();

        // Draw header image
        // const headerImageWidth = 100; // Adjust width as needed
        const headerImageHeight = 50; // Adjust height as needed
        page.drawImage(headerImage, {
          x: 0,
          y: height - headerImageHeight,
          width: width,
          height: headerImageHeight,
        });

        // Add page number below the header image
        page.drawText(`Page ${i + 1} of ${totalPages}`, {
          x: width - 70, // Align near the right edge
          y: height - 15, // Near the top of the page
          size: 10,
        });

        // Draw footer image 
        const footerImageHeight = 25; // Adjust height as needed
        page.drawImage(footerImage, {
          x: 0,
          y: 0,
          width: width,
          height: footerImageHeight,
        });
      }

      // Step 7: Save the merged PDF
      const mergedPdfBytes = await mergedPdfDoc.save();
      const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });

      // Step 8: Trigger download
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(mergedBlob);
      downloadLink.download = filename;
      downloadLink.click();

      // logger.info("PDF with images in header and footer downloaded successfully.");
    } catch (error) {
      // logger.error("Error while generating and merging PDF:", error);
    }
  };


  // Handle the paste event to process multiple emails at once

  // Function to handle email input change
  const handleEmailChange = (event) => {
    const value = event.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Check for space or comma to validate and add email
    if (value.endsWith(" ") || value.endsWith(",")) {
      const trimmedValue = value.trim().replace(/,$/, ""); // Trim and remove trailing comma

      if (emailRegex.test(trimmedValue)) {
        // Check if email is already in the list to prevent duplicates
        setShareEmail((prevEmails) => {
          if (!prevEmails.includes(trimmedValue)) {
            return [...prevEmails, trimmedValue]; // Add email if not already in list
          }
          return prevEmails; // Do not add if email already exists
        });
        setErrorShare("");  // Clear error on valid email
      } else if (trimmedValue) {
        // Set error for invalid email but don't clear the field
        setErrorShare(`Invalid email: ${trimmedValue}`);
      }

      setEmailList(""); // Clear input field for the next email
    } else {
      // Update the input field value (while typing)
      setEmailList(value);
      setErrorShare(""); // Clear error message if no space or comma
    }

  };

  // Function to handle adding email addresses when user clicks "Add Emails"
  const addEmailsToList = (event) => {
    event.preventDefault();
    const emails = emailList
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email); // Remove empty strings
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emails.filter((email) => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      setErrorShare(`Invalid email(s): ${invalidEmails.join(", ")}`);
      return;
    }

    const uniqueEmails = emails.filter(
      (email) => !shareEmail.includes(email) // Avoid duplicates
    );

    if (uniqueEmails.length === 0) {
      setErrorShare("All emails are already added.");
      return;
    }

    setShareEmail([...shareEmail, ...uniqueEmails]);
    setEmailList(""); // Clear input field
    setErrorShare(""); // Clear errors
  };

  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData("text");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Split the pasted text by spaces or commas and validate each email
    const emailsToAdd = pastedText
      .split(/[\s,]+/) // Split by spaces or commas
      .map((email) => email.trim())
      .filter((email) => emailRegex.test(email)); // Keep only valid emails

    // Add valid emails to the list, ensuring no duplicates
    setShareEmail((prevEmails) => {
      const newEmails = emailsToAdd.filter((email) => !prevEmails.includes(email));
      return [...prevEmails, ...newEmails];
    });

    // Update the input field and clear the error message
    setEmailList(""); // Clear input after pasting
    setErrorShare(""); // Clear error if paste is valid
  };

  const handleInputFocus = () => {
    setError(""); // Clear the error when input is clicked/focused
  };



  const handleRegenerateAISummary = async () => {
    if (!SessionIDCheck || !userid) {
      toast.error("Session not found.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    try {
      setIsRegeneratingAI(true);
      const res = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateAISummary', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: SessionIDCheck, user_id: userid }),
      });
      const data = await res.json();
      if (res.ok && data.chatbot_summary) {
        setFollowSummaryEditAIChatbot(data.chatbot_summary);
        setPlanOnCareData(data.plan_of_care || '');
        setConditionalDiagnosis(data.conditional_diagnosis || '');
        toast.success("AI summary generated successfully!", { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(data.error || "Failed to generate AI summary.", { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (err) {
      toast.error("Error generating AI summary.", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsRegeneratingAI(false);
    }
  };

  // --- Final Consultant Note handlers ---

  // Core generation logic — accepts explicit IDs so it can be called both from the
  // button handler AND automatically after zoom processing (before state is settled).
  const generateFinalNoteForSession = async (sessionId, userId, { silent = false } = {}) => {
    if (!sessionId || !userId) {
      if (!silent) toast.error("Session not found.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    try {
      setIsGeneratingFinalNote(true);
      const res = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateFinalConsultantNote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId, user_id: userId }),
      });
      const data = await res.json();
      if (res.ok && data.status === 'success') {
        setFinalConsultantNote(data.final_consultant_note || '');
        setFinalConsultantDiagnosis(data.final_consultant_diagnosis || '');
        setFinalConsultantPlan(data.final_consultant_plan || '');
        setFinalConsultantHPI(data.final_consultant_hpi || '');
        setFinalConsultantPMH(data.final_consultant_pmh || '');
        setFinalConsultantMedications(data.final_consultant_medications || '');
        setFinalConsultantPrescribedMedications(data.final_consultant_prescribed_medications || '');
        setFinalConsultantAllergies(data.final_consultant_allergies || '');
        setFinalConsultantSocialHistory(data.final_consultant_social_history || '');
        setFinalConsultantROS(data.final_consultant_ros || '');
        setFinalConsultantVisitDate(data.final_consultant_visit_date || '');
        if (!silent) toast.success("Final Consultant Note generated!", { position: toast.POSITION.TOP_RIGHT });
      } else {
        if (!silent) toast.error(data.error || "Failed to generate final note.", { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (err) {
      if (!silent) toast.error("Error generating final consultant note.", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsGeneratingFinalNote(false);
    }
  };

  const handleGenerateFinalNote = async () => {
    if (!canEditClinical()) return;
    await generateFinalNoteForSession(SessionIDCheck, userid);
  };

  const handleRegenerateFinalNote = async () => {
    if (!canEditClinical()) return;
    if (!window.confirm('Regenerate the Final Consultant Note? This will create a fresh AI-merged note combining the chatbot intake and telehealth consultation data. The current note will be overwritten.')) return;
    await generateFinalNoteForSession(SessionIDCheck, userid);
  };

  // Generate followup report - merges previous report with followup data
  // overrideSid / overrideUid allow callers inside showPatientDataResult to pass
  // the local variables directly (React state may not be updated yet at that point)
  const handleGenerateFollowupReport = async (followupId, overrideSid, overrideUid) => {
    const resolvedSid = overrideSid || SessionIDCheck;
    const resolvedUid = overrideUid || userid;
    if (!followupId || !resolvedSid || !resolvedUid) {
      logger.warn('handleGenerateFollowupReport: missing required params, skipping', { followupId, resolvedSid, resolvedUid });
      return;
    }
    // Guard: skip if report already generated for this followup
    const existing = FollowupData?.find(f => (f.followup_id || f.id) === followupId);
    if (existing?.report_generated) {
      logger.info('handleGenerateFollowupReport: report already generated for', followupId);
      return;
    }
    setIsGeneratingFollowupReport(followupId);
    try {
      const res = await fetchWithAppCheck(
        'https://us-central1-aigicare-prod.cloudfunctions.net/generateFollowupConsultantNote',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: resolvedSid,
            user_id: resolvedUid,
            followup_id: followupId,
          }),
        }
      );
      const data = await res.json();
      if (res.ok && data.status === 'success') {
        // Update the main Final Consultant Note display with the new merged version
        setFinalConsultantNote(data.final_consultant_note || '');
        setFinalConsultantDiagnosis(data.final_consultant_diagnosis || '');
        setFinalConsultantPlan(data.final_consultant_plan || '');
        setFinalConsultantHPI(data.final_consultant_hpi || '');
        setFinalConsultantPMH(data.final_consultant_pmh || '');
        setFinalConsultantMedications(data.final_consultant_medications || '');
        setFinalConsultantPrescribedMedications(data.final_consultant_prescribed_medications || '');
        setFinalConsultantAllergies(data.final_consultant_allergies || '');
        setFinalConsultantSocialHistory(data.final_consultant_social_history || '');
        setFinalConsultantROS(data.final_consultant_ros || '');
        setFinalConsultantVisitDate(data.final_consultant_visit_date || '');
        setIsFinalNoteSubmitted(false);

        // Update the followup data list to reflect report_generated
        setFollowupData(prev => prev.map(f => {
          const fId = f.followup_id || f.id;
          return fId === followupId ? { ...f, report_generated: true, report_version: data.version } : f;
        }));

        // Store as live data for history viewer
        liveReportData.current = {
          finalConsultantNote: data.final_consultant_note || '',
          finalConsultantDiagnosis: data.final_consultant_diagnosis || '',
          finalConsultantPlan: data.final_consultant_plan || '',
          finalConsultantHPI: data.final_consultant_hpi || '',
          finalConsultantPMH: data.final_consultant_pmh || '',
          finalConsultantMedications: data.final_consultant_medications || '',
          finalConsultantPrescribedMedications: data.final_consultant_prescribed_medications || '',
          finalConsultantAllergies: data.final_consultant_allergies || '',
          finalConsultantSocialHistory: data.final_consultant_social_history || '',
          finalConsultantROS: data.final_consultant_ros || '',
          finalConsultantVisitDate: data.final_consultant_visit_date || '',
        };

        // Reload report history (pass resolvedSid in case SessionIDCheck state isn't set yet)
        loadReportHistory(resolvedSid);

        toast.success('Followup report generated successfully!', { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(data.error || 'Failed to generate followup report.', { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (err) {
      logger.error('Error generating followup report:', err);
      toast.error('Error generating followup report.', { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsGeneratingFollowupReport(null);
    }
  };

  // Load report history for the current session
  // overrideSid allows callers inside showPatientDataResult to pass the local sid directly
  // (React state SessionIDCheck may not be updated yet at that point)
  const loadReportHistory = async (overrideSid) => {
    const sid = overrideSid || SessionIDCheck;
    if (!sid) return;
    try {
      const res = await fetchWithAppCheck(
        'https://us-central1-aigicare-prod.cloudfunctions.net/getReportHistory',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sid }),
        }
      );
      const data = await res.json();
      if (data.versions) {
        setReportHistory(data.versions);
      }
    } catch (err) {
      logger.error('Error loading report history:', err);
    }
  };

  // View a specific historical report version
  const handleViewReportVersion = (version) => {
    if (!version) {
      // Restore live (latest) data
      setSelectedReportVersion(null);
      const live = liveReportData.current;
      if (live.finalConsultantHPI !== undefined) {
        setFinalConsultantNote(live.finalConsultantNote);
        setFinalConsultantDiagnosis(live.finalConsultantDiagnosis);
        setFinalConsultantPlan(live.finalConsultantPlan);
        setFinalConsultantHPI(live.finalConsultantHPI);
        setFinalConsultantPMH(live.finalConsultantPMH);
        setFinalConsultantMedications(live.finalConsultantMedications);
        setFinalConsultantPrescribedMedications(live.finalConsultantPrescribedMedications || '');
        setFinalConsultantAllergies(live.finalConsultantAllergies);
        setFinalConsultantSocialHistory(live.finalConsultantSocialHistory);
        setFinalConsultantROS(live.finalConsultantROS);
        setFinalConsultantVisitDate(live.finalConsultantVisitDate);
      }
      return;
    }
    const historyItem = reportHistory.find(h => h.version === parseInt(version));
    if (historyItem) {
      // Save current live data before switching (only on first switch)
      if (!selectedReportVersion) {
        liveReportData.current = {
          finalConsultantNote: finalConsultantNote,
          finalConsultantDiagnosis: finalConsultantDiagnosis,
          finalConsultantPlan: finalConsultantPlan,
          finalConsultantHPI: finalConsultantHPI,
          finalConsultantPMH: finalConsultantPMH,
          finalConsultantMedications: finalConsultantMedications,
          finalConsultantPrescribedMedications: finalConsultantPrescribedMedications,
          finalConsultantAllergies: finalConsultantAllergies,
          finalConsultantSocialHistory: finalConsultantSocialHistory,
          finalConsultantROS: finalConsultantROS,
          finalConsultantVisitDate: finalConsultantVisitDate,
        };
      }
      setSelectedReportVersion(parseInt(version));
      setFinalConsultantNote(historyItem.final_consultant_note || '');
      setFinalConsultantDiagnosis(historyItem.final_consultant_diagnosis || '');
      setFinalConsultantPlan(historyItem.final_consultant_plan || '');
      setFinalConsultantHPI(historyItem.final_consultant_hpi || '');
      setFinalConsultantPMH(historyItem.final_consultant_pmh || '');
      setFinalConsultantMedications(historyItem.final_consultant_medications || '');
      setFinalConsultantPrescribedMedications(historyItem.final_consultant_prescribed_medications || '');
      setFinalConsultantAllergies(historyItem.final_consultant_allergies || '');
      setFinalConsultantSocialHistory(historyItem.final_consultant_social_history || '');
      setFinalConsultantROS(historyItem.final_consultant_ros || '');
      setFinalConsultantVisitDate(historyItem.final_consultant_visit_date || '');
    }
  };

  // Retry telehealth summary generation when Zoom AI Companion hasn't processed the recording yet
  const handleRetryTelehealthSummary = async () => {
    if (!SessionIDCheck || !userid) return;
    setIsGeneratingFinalNote(true);
    try {
      const res = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/generateZoomCombinedSummary', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: SessionIDCheck, user_id: userid }),
      });
      const data = await res.json();

      // If Zoom AI Companion hasn't processed the recording yet, show a warning and stop.
      // Do NOT generate a Final Note with placeholder/fake telehealth data.
      if (data.status === 'not_ready') {
        toast.warn("Telehealth summary not available yet. Zoom AI Companion is still processing the recording. Please try again in a few minutes.", { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        setIsGeneratingFinalNote(false);
        return;
      }

      if (res.ok && (data.zoom_hpi || data.zoom_conditional_diagnosis || data.zoom_plan_of_care)) {
        setZoomHPI(data.zoom_hpi || '');
        setZoomPMH(data.zoom_pmh || '');
        setZoomMedications(data.zoom_medications || '');
        setZoomCD(data.zoom_conditional_diagnosis || '');
        setZoomPoC(data.zoom_plan_of_care || '');
        setEditZoomSummary(data.zoom_summary || editZoomSummary);
        toast.success("Telehealth summary ready. Generating Final Note...", { position: toast.POSITION.TOP_RIGHT });
        // Now auto-generate the Final Note with the real telehealth data
        await generateFinalNoteForSession(SessionIDCheck, userid, { silent: true });
      } else {
        toast.warn("Telehealth summary not available yet. Please try again in a few minutes.", { position: toast.POSITION.TOP_RIGHT });
        setIsGeneratingFinalNote(false);
      }
    } catch (err) {
      toast.error("Error fetching telehealth summary.", { position: toast.POSITION.TOP_RIGHT });
      setIsGeneratingFinalNote(false);
    }
  };

  const handleEditFinalNote = () => {
    if (!canEditClinical()) return;
    setEditFinalHPI(finalConsultantHPI);
    setEditFinalPMH(finalConsultantPMH);
    setEditFinalMedications(finalConsultantMedications);
    setEditFinalPrescribedMedications(finalConsultantPrescribedMedications);
    setEditFinalAllergies(finalConsultantAllergies);
    setEditFinalSocialHistory(finalConsultantSocialHistory);
    setEditFinalROS(finalConsultantROS);
    setEditFinalNote(finalConsultantNote);
    setEditFinalDiagnosis(finalConsultantDiagnosis);
    setEditFinalPlan(finalConsultantPlan);
    setIsEditingFinalNote(true);
  };

  const handleCancelEditFinalNote = () => {
    setIsEditingFinalNote(false);
    setMedSearchText(''); setMedSuggestions([]); setSelectedMedName('');
    setSelectedMedDose(''); setSelectedMedFrequency(''); setMedDoseOptions([]);
  };

  const handleMedSearch = async (value) => {
    setMedSearchText(value);
    setSelectedMedName('');
    if (value.trim().length >= 3) {
      try {
        const res = await fetchWithAppCheck(
          `https://us-central1-aigicare-prod.cloudfunctions.net/autoSuggest?query=${encodeURIComponent(value.trim())}&type=medicine`
        );
        const data = await res.json();
        setMedSuggestions(data.suggestions || []);
      } catch {
        setMedSuggestions([]);
      }
    } else {
      setMedSuggestions([]);
    }
  };

  const handleMedSelect = async (name) => {
    setSelectedMedName(name);
    setMedSearchText(name);
    setMedSuggestions([]);
    setSelectedMedDose('');
    setSelectedMedFrequency('');
    setMedDoseOptions([]);
    try {
      const res = await fetch(`https://clinicaltables.nlm.nih.gov/api/rxterms/v3/search?terms=${encodeURIComponent(name)}&ef=STRENGTHS_AND_FORMS`);
      const data = await res.json();
      const names = data[1] || [];
      const strengthsData = data[2]?.STRENGTHS_AND_FORMS || [];
      const idx = names.findIndex(n => n.toLowerCase() === name.toLowerCase());
      const doses = idx >= 0 ? (strengthsData[idx] || []) : (strengthsData[0] || []);
      setMedDoseOptions(doses);
    } catch {
      setMedDoseOptions([]);
    }
  };

  const handleAddMedToNote = () => {
    if (!selectedMedName.trim()) return;
    let entry = `• ${selectedMedName}`;
    if (selectedMedDose) entry += ` (${selectedMedDose})`;
    if (selectedMedFrequency) entry += ` - ${selectedMedFrequency}`;
    setEditFinalPrescribedMedications(prev => prev ? `${prev}\n${entry}` : entry);
    setMedSearchText(''); setSelectedMedName('');
    setMedSuggestions([]); setSelectedMedDose(''); setSelectedMedFrequency(''); setMedDoseOptions([]);
    setSelectedMedDose(''); setSelectedMedFrequency('');
  };

  const handleAddRecommendation = async () => {
    if (!canEditClinical()) return;
    const text = newRecommendation.trim();
    if (!text || !SessionIDCheck) return;
    setIsSavingRecommendation(true);
    try {
      const updated = [...doctorRecommendations, text];
      await updateChatSession(SessionIDCheck, { doctor_recommendations: updated });
      setDoctorRecommendations(updated);
      setNewRecommendation('');
      toast.success("Recommendation added!", { position: toast.POSITION.TOP_RIGHT });
    } catch (err) {
      toast.error("Failed to save recommendation.", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsSavingRecommendation(false);
    }
  };

  const handleRemoveRecommendation = async (index) => {
    if (!canEditClinical() || !SessionIDCheck) return;
    try {
      const updated = doctorRecommendations.filter((_, i) => i !== index);
      await updateChatSession(SessionIDCheck, { doctor_recommendations: updated });
      setDoctorRecommendations(updated);
    } catch (err) {
      toast.error("Failed to remove recommendation.", { position: toast.POSITION.TOP_RIGHT });
    }
  };

  const handleSaveEditRecommendation = async (index) => {
    if (!canEditClinical()) return;
    const text = editingRecommendationText.trim();
    if (!text || !SessionIDCheck) return;
    try {
      const updated = [...doctorRecommendations];
      updated[index] = text;
      await updateChatSession(SessionIDCheck, { doctor_recommendations: updated });
      setDoctorRecommendations(updated);
      setEditingRecommendationIndex(null);
      setEditingRecommendationText('');
    } catch (err) {
      toast.error("Failed to update recommendation.", { position: toast.POSITION.TOP_RIGHT });
    }
  };

  const handleSubmitFinalNote = async () => {
    if (!canEditClinical()) return;
    if (!SessionIDCheck) {
      toast.error("Session not found.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    try {
      setIsSubmittingFinalNote(true);
      const res = await fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/submitFinalConsultantNote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: SessionIDCheck,
          patient_email: email,
          patient_name: fullName || RecordData?.fullName || '',
        }),
      });
      const data = await res.json();
      if (res.ok) {
        // Save consulting physician info so patient portal can show it in the signature block
        await updateChatSession(SessionIDCheck, {
          submitted_by_name: selectedSession?.assigned_doctor_name || (isDoctor() ? providerName : '') || '',
          submitted_by_specialty: selectedSession?.assigned_doctor_specialty || (isDoctor() ? providerSpecialty : '') || '',
          submitted_by_phone: selectedSession?.assigned_doctor_phone || (isDoctor() ? providerPhone : '') || '',
          submitted_by_signature: selectedSession?.assigned_doctor_signature || (isDoctor() ? providerSignature : '') || '',
          submitted_at: new Date().toISOString(),
        }).catch(() => {}); // non-blocking
        setIsFinalNoteSubmitted(true);
        // Immediately mark latest version as submitted locally to prevent
        // the useEffect guard from resetting before loadReportHistory resolves
        setReportHistory(prev => {
          if (prev.length === 0) return prev;
          const updated = [...prev];
          updated[0] = { ...updated[0], submitted: true, submitted_at: new Date().toISOString() };
          return updated;
        });
        // Reload from server to get authoritative data
        loadReportHistory();
        toast.success("Final Consultant Note submitted & email sent to patient!", { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(data.error || "Failed to submit.", { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (err) {
      toast.error("Error submitting final note.", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsSubmittingFinalNote(false);
    }
  };

  const handleSaveFinalNote = async () => {
    if (!canEditClinical()) return;
    try {
      await updateChatSession(SessionIDCheck, {
        final_consultant_hpi: editFinalHPI,
        final_consultant_pmh: editFinalPMH,
        final_consultant_medications: editFinalMedications,
        final_consultant_prescribed_medications: editFinalPrescribedMedications,
        final_consultant_allergies: editFinalAllergies,
        final_consultant_social_history: editFinalSocialHistory,
        final_consultant_ros: editFinalROS,
        final_consultant_note: editFinalNote,
        final_consultant_diagnosis: editFinalDiagnosis,
        final_consultant_plan: editFinalPlan,
      });
      setFinalConsultantHPI(editFinalHPI);
      setFinalConsultantPMH(editFinalPMH);
      setFinalConsultantMedications(editFinalMedications);
      setFinalConsultantPrescribedMedications(editFinalPrescribedMedications);
      setFinalConsultantAllergies(editFinalAllergies);
      setFinalConsultantSocialHistory(editFinalSocialHistory);
      setFinalConsultantROS(editFinalROS);
      setFinalConsultantNote(editFinalNote);
      setFinalConsultantDiagnosis(editFinalDiagnosis);
      setFinalConsultantPlan(editFinalPlan);
      setIsEditingFinalNote(false);
      toast.success("Final Consultant Note saved!", { position: toast.POSITION.TOP_RIGHT });
    } catch (err) {
      toast.error("Failed to save.", { position: toast.POSITION.TOP_RIGHT });
    }
  };

  const handleFinalNoteFileToggle = (file, autoSave = false) => {
    setSelectedFinalNoteFiles((prev) => {
      const exists = prev.find((f) => f.id === file.id);
      const updated = exists ? prev.filter((f) => f.id !== file.id) : [...prev, file];
      if (autoSave) {
        const fileIds = updated.map((f) => f.id);
        updateChatSession(SessionIDCheck, { selected_final_note_file_ids: fileIds }).catch(err =>
          logger.error('Error saving selected files:', err)
        );
      }
      return updated;
    });
  };

  const saveFinalNoteFiles = async (files) => {
    try {
      const fileIds = files.map((f) => f.id);
      await updateChatSession(SessionIDCheck, { selected_final_note_file_ids: fileIds });
    } catch (err) {
      logger.error('Error saving selected files:', err);
    }
  };

  const downloadFinalNotePdf = async () => {
    try {
      setIsGeneratingPdf(true);
      const filename = generateFilename(fullName || RecordData?.fullName || 'Patient') + '_FinalNote';
      const content = finalNoteContentRef.current;
      const headerImageUrl = Icons[0].headerImageUrlLink;
      const footerImageUrl = Icons[0].footerImageUrlLink;

      if (!content) {
        toast.error("Content not found!", { position: toast.POSITION.TOP_RIGHT });
        return;
      }

      const options = {
        margin: [1.47, 0.2, 1.1, 0.2],
        filename: filename,
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      };

      // Temporarily show hidden PDF-only elements
      const pdfOnlyEls = content.querySelectorAll('.pdf-only-recommendations');
      pdfOnlyEls.forEach(el => { el.style.height = 'auto'; el.style.overflow = 'visible'; });

      const contentPdfBlob = await html2pdf().set(options).from(content).toPdf().outputPdf('blob');

      // Re-hide PDF-only elements
      pdfOnlyEls.forEach(el => { el.style.height = '0'; el.style.overflow = 'hidden'; });
      const contentPdfDoc = await PDFDocument.load(await contentPdfBlob.arrayBuffer());
      const mergedPdfDoc = await PDFDocument.create();

      const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
      contentPages.forEach((page) => mergedPdfDoc.addPage(page));

      // Merge selected Assessment and Plan files
      const validFiles = selectedFinalNoteFiles.filter((f) => f.url);
      for (const file of validFiles) {
        const fileBlob = await fetch(file.url).then((r) => r.blob());
        const filePdf = await PDFDocument.load(await fileBlob.arrayBuffer());
        const filePages = await mergedPdfDoc.copyPages(filePdf, filePdf.getPageIndices());
        filePages.forEach((page) => mergedPdfDoc.addPage(page));
      }

      // Add headers and footers
      const totalPages = mergedPdfDoc.getPageCount();
      const headerImageBytes = await fetch(headerImageUrl).then((r) => r.arrayBuffer());
      const footerImageBytes = await fetch(footerImageUrl).then((r) => r.arrayBuffer());
      const headerImage = await mergedPdfDoc.embedPng(headerImageBytes);
      const footerImage = await mergedPdfDoc.embedPng(footerImageBytes);

      for (let i = 0; i < totalPages; i++) {
        const page = mergedPdfDoc.getPage(i);
        const { width, height } = page.getSize();
        page.drawImage(headerImage, { x: 0, y: height - 50, width: width, height: 50 });
        page.drawText(`Page ${i + 1} of ${totalPages}`, { x: width - 70, y: height - 15, size: 10 });
        page.drawImage(footerImage, { x: 0, y: 0, width: width, height: 25 });
      }

      const mergedPdfBytes = await mergedPdfDoc.save();
      const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(mergedBlob);
      downloadLink.download = filename + '.pdf';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      toast.success("PDF downloaded!", { position: toast.POSITION.TOP_RIGHT });
    } catch (err) {
      logger.error("Final note PDF error:", err);
      toast.error("Failed to generate PDF.", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  const handleSharetoPatient = async (event, fullName, selectedFiles, email) => {
    try {
      setIsLoadingEmailP(true);
      if (event) event.preventDefault(); // Prevent form reload if event exists


      // Ensure content exists
      const content = contentRef.current;
      if (!content) {
        logger.error("Content not found!");
        toast.error("Content not found!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      // Ensure header and footer image URLs are valid
      const headerImageUrl = Icons[0]?.headerImageUrlLink;
      const footerImageUrl = Icons[0]?.footerImageUrlLink;
      if (!headerImageUrl || !footerImageUrl) {
        logger.error("Header or footer image URL is missing.");
        toast.error("Header or footer image is missing.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      // Ensure selected files contain valid URLs
      const validSelectedFiles = selectedFiles.filter((file) => file?.url);
      if (validSelectedFiles.length === 0) {
        logger.warn("No valid files selected for merging.");
      }

      // Step 1: Generate filename and PDF content
      const filename = generateFilename(fullName);
      const options = {
        margin: [1.1, 0.2, 1, 0.2],
        filename: filename,
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      };

      const contentPdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .outputPdf("blob");

      // Step 2: Load content PDF
      const contentPdfDoc = await PDFDocument.load(await contentPdfBlob.arrayBuffer());

      // Step 3: Create a merged PDF document
      const mergedPdfDoc = await PDFDocument.create();

      // Step 4: Copy content pages
      const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
      contentPages.forEach((page) => mergedPdfDoc.addPage(page));

      // Step 5: Merge selected files
      for (const file of validSelectedFiles) {
        const fileBlob = await fetch(file.url).then((res) => res.blob());
        const filePdf = await PDFDocument.load(await fileBlob.arrayBuffer());
        const filePages = await mergedPdfDoc.copyPages(filePdf, filePdf.getPageIndices());
        filePages.forEach((page) => mergedPdfDoc.addPage(page));
      }

      // Step 6: Add headers and footers
      const totalPages = mergedPdfDoc.getPageCount();
      const headerImageBytes = await fetch(headerImageUrl).then((res) => res.arrayBuffer());
      const footerImageBytes = await fetch(footerImageUrl).then((res) => res.arrayBuffer());
      const headerImage = await mergedPdfDoc.embedPng(headerImageBytes);
      const footerImage = await mergedPdfDoc.embedPng(footerImageBytes);

      for (let i = 0; i < totalPages; i++) {
        const page = mergedPdfDoc.getPage(i);
        const { width, height } = page.getSize();

        // Add header image
        const headerImageHeight = 70;
        page.drawImage(headerImage, {
          x: 0,
          y: height - headerImageHeight,
          width: width,
          height: headerImageHeight,
        });

        // Add page number
        page.drawText(`Page ${i + 1} of ${totalPages}`, {
          x: width - 70,
          y: height - 15,
          size: 10,
        });

        // Add footer image
        const footerImageHeight = 50;
        page.drawImage(footerImage, {
          x: 0,
          y: 0,
          width: width,
          height: footerImageHeight,
        });
      }

      // Step 7: Save merged PDF
      const mergedPdfBytes = await mergedPdfDoc.save();
      const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });

      const base64Pdf = await convertBlobToBase64(mergedBlob);

      // Reset errors and set loading state

      setErrorShare("");

      // Prepare email payload
      const subjectMsg = generateShareFilename(fullName);
      const bodyMsg = "Hello, \n\n Please find the attached report for your reference. If you have any questions or need further assistance, feel free to reach out.\n\nBest regards,\nAIGI Care";

      // Step 8: Send email using SendGrid via Firebase Functions
      try {
        const result = await sendPatientReport({
          email: email,
          subject: subjectMsg,
          pdfData: base64Pdf,
          fileName: filename,
          body: `<div style="font-family: Arial, sans-serif;">
            <p>Hello,</p>
            <p>Please find the attached report for your reference. If you have any questions or need further assistance, feel free to reach out.</p>
            <p style="margin-top: 30px;">Best regards,<br>AIGI Care</p>
          </div>`
        });

        if (result.success) {
          toast.success("Report sent successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setErrorShare(""); // Clear any error messages
          setIsLoadingEmailP(false); // Stop the loading spinner
        } else {
          toast.error(`Failed to send report: ${result.message}`, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsLoadingEmailP(false);
        }
      } catch (error) {
        logger.error("Error sending email:", error);
        toast.error('An error occurred while sending the email. Please try again.', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoadingEmailP(false);
      }


    } catch (error) {
      logger.error("Error while generating and merging PDF:", error);
      toast.error("An error occurred. Please try again.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
    }
  };

  const handleShareBtn = async (event, fullName, selectedFiles) => {
    try {
      setIsLoadingEmail(true);
      if (event) event.preventDefault(); // Prevent form reload if event exists

      // Simple form validation
      let formErrors = {};
      if (shareEmail.length === 0) {
        formErrors.email = "Email list cannot be empty.";
      }

      if (Object.keys(formErrors).length > 0) {
        setErrorShare(formErrors);
        return; // Stop if there are validation errors
      }

      // Ensure content exists
      const content = contentRef.current;
      if (!content) {
        logger.error("Content not found!");
        toast.error("Content not found!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      // Ensure header and footer image URLs are valid
      const headerImageUrl = Icons[0]?.headerImageUrlLink;
      const footerImageUrl = Icons[0]?.footerImageUrlLink;
      if (!headerImageUrl || !footerImageUrl) {
        logger.error("Header or footer image URL is missing.");
        toast.error("Header or footer image is missing.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }

      // Ensure selected files contain valid URLs
      const validSelectedFiles = selectedFiles.filter((file) => file?.url);
      if (validSelectedFiles.length === 0) {
        logger.warn("No valid files selected for merging.");
      }

      // Step 1: Generate filename and PDF content
      const filename = generateFilename(fullName);
      const options = {
        margin: [1.1, 0.2, 1, 0.2],
        filename: filename,
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        html2canvas: { scale: 2, useCORS: true, letterRendering: true },
      };

      const contentPdfBlob = await html2pdf()
        .set(options)
        .from(content)
        .toPdf()
        .outputPdf("blob");

      // Step 2: Load content PDF
      const contentPdfDoc = await PDFDocument.load(await contentPdfBlob.arrayBuffer());

      // Step 3: Create a merged PDF document
      const mergedPdfDoc = await PDFDocument.create();

      // Step 4: Copy content pages
      const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
      contentPages.forEach((page) => mergedPdfDoc.addPage(page));

      // Step 5: Merge selected files
      for (const file of validSelectedFiles) {
        const fileBlob = await fetch(file.url).then((res) => res.blob());
        const filePdf = await PDFDocument.load(await fileBlob.arrayBuffer());
        const filePages = await mergedPdfDoc.copyPages(filePdf, filePdf.getPageIndices());
        filePages.forEach((page) => mergedPdfDoc.addPage(page));
      }

      // Step 6: Add headers and footers
      const totalPages = mergedPdfDoc.getPageCount();
      const headerImageBytes = await fetch(headerImageUrl).then((res) => res.arrayBuffer());
      const footerImageBytes = await fetch(footerImageUrl).then((res) => res.arrayBuffer());
      const headerImage = await mergedPdfDoc.embedPng(headerImageBytes);
      const footerImage = await mergedPdfDoc.embedPng(footerImageBytes);

      for (let i = 0; i < totalPages; i++) {
        const page = mergedPdfDoc.getPage(i);
        const { width, height } = page.getSize();

        // Add header image
        const headerImageHeight = 70;
        page.drawImage(headerImage, {
          x: 0,
          y: height - headerImageHeight,
          width: width,
          height: headerImageHeight,
        });

        // Add page number
        page.drawText(`Page ${i + 1} of ${totalPages}`, {
          x: width - 70,
          y: height - 15,
          size: 10,
        });

        // Add footer image
        const footerImageHeight = 50;
        page.drawImage(footerImage, {
          x: 0,
          y: 0,
          width: width,
          height: footerImageHeight,
        });
      }

      // Step 7: Save merged PDF
      const mergedPdfBytes = await mergedPdfDoc.save();
      const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });

      const base64Pdf = await convertBlobToBase64(mergedBlob);

      // Reset errors and set loading state

      setErrorShare("");

      // Prepare email payload
      const subjectMsg = generateShareFilename(fullName);
      const emailVal = shareEmail;
      const bodyMsg = "Hello, \n\n Please find the attached report for your reference. If you have any questions or need further assistance, feel free to reach out.\n\nBest regards,\nAIGI Care";

      // Step 8: Send email using SendGrid via Firebase Functions
      try {
        const result = await sendBulkEmails({
          emails: emailVal,
          subject: subjectMsg,
          pdfData: base64Pdf,
          fileName: filename,
          body: `<div style="font-family: Arial, sans-serif;">
            <p>Hello,</p>
            <p>Please find the attached report for your reference. If you have any questions or need further assistance, feel free to reach out.</p>
            <p style="margin-top: 30px;">Best regards,<br>AIGI Care</p>
          </div>`
        });

        if (result.success) {
          toast.success(result.message || "Reports sent successfully!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          // Reset form data and form state
          setShareEmail([]); // Clear the email list
          setEmailList(""); // Reset the email input
          setErrorShare(""); // Clear any error messages
          setIsLoadingEmail(false); // Stop the loading spinner
        } else {
          toast.error(`Failed to send reports: ${result.message}`, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsLoadingEmail(false);
        }
      } catch (error) {
        logger.error("Error sending bulk emails:", error);
        toast.error('An error occurred while sending emails. Please try again.', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoadingEmail(false);
      }


    } catch (error) {
      logger.error("Error while generating and merging PDF:", error);
      toast.error("An error occurred. Please try again.", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
    }
  };

  // Utility function to convert Blob to base64
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extract base64 part
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  // Function to handle generating and merging PDFs
  const generateAndMergePDF = async (patientName) => {
    try {
      const modalContent = contentRef.current;

      // Generate PDF from modal content
      const canvas = await html2canvas(modalContent);
      const contentPdf = new jsPDF("p", "mm", "a4");

      const pageWidth = contentPdf.internal.pageSize.getWidth() - 20;
      const pageHeight = contentPdf.internal.pageSize.getHeight() - 26;
      const imageHeight = (canvas.height * pageWidth) / canvas.width;

      let currentHeight = 10;
      let pageCount = 1;

      while (currentHeight < imageHeight) {
        const sectionHeight = Math.min(pageHeight, imageHeight - currentHeight);
        const sectionCanvas = document.createElement("canvas");
        sectionCanvas.width = canvas.width;
        sectionCanvas.height = (sectionHeight * canvas.width) / pageWidth;

        const ctx = sectionCanvas.getContext("2d");
        ctx.drawImage(
          canvas,
          0,
          currentHeight * (canvas.width / pageWidth),
          canvas.width,
          sectionCanvas.height,
          0,
          0,
          canvas.width,
          sectionCanvas.height
        );

        const imgData = sectionCanvas.toDataURL("image/png");
        if (pageCount > 1) contentPdf.addPage();
        contentPdf.addImage(imgData, "PNG", 10, 10, pageWidth, sectionHeight);

        currentHeight += sectionHeight;
        pageCount++;
      }

      const contentPdfBlob = contentPdf.output("arraybuffer");
      const contentPdfDoc = await PDFDocument.load(contentPdfBlob);

      // Create a new merged PDF document
      const mergedPdfDoc = await PDFDocument.create();

      // Add modal content pages to merged PDF
      const contentPages = await mergedPdfDoc.copyPages(contentPdfDoc, contentPdfDoc.getPageIndices());
      contentPages.forEach((page) => mergedPdfDoc.addPage(page));

      // Filter and merge selected files
      const validSelectedFiles = selectedFiles.filter((file) => file.url);
      if (validSelectedFiles.length === 0) {
        logger.warn("No valid files selected for merging.");
      }

      for (const file of validSelectedFiles) {
        const fileBlob = await fetch(file.url).then((res) => res.blob());
        const filePdf = await PDFDocument.load(await fileBlob.arrayBuffer());
        const filePages = await mergedPdfDoc.copyPages(filePdf, filePdf.getPageIndices());
        filePages.forEach((page) => mergedPdfDoc.addPage(page));
      }

      // Add Header with patient name and page number
      const totalPages = mergedPdfDoc.getPageCount();
      for (let i = 0; i < totalPages; i++) {
        const page = mergedPdfDoc.getPage(i);
        const pageHeight = page.getHeight();
        const pageWidth = page.getWidth();

        // Draw patient name and page number in the header, right-aligned
        page.drawText(`Page ${i + 1} of ${totalPages}`, {
          x: pageWidth - 70, // Right-aligned with a margin from the right
          y: pageHeight - 20, // Place at the top of the page
          size: 9,
          color: rgb(0, 0, 0), // Black text
          font: await mergedPdfDoc.embedFont(StandardFonts.Helvetica), // Use Helvetica font
        });
      }

      // Serialize and download the merged PDF
      const mergedPdfBytes = await mergedPdfDoc.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });

      const now = new Date();
      const date = now.toISOString().split("T")[0];
      const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
      const filename = `${date}_${time}_${fullName.replace(/ /g, "_")}_Merged_Report.pdf`;

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (error) {
      logger.error("Error generating merged PDF:", error);
    }
  };


  const isPastDate = moment(selectedItemFollowup).isBefore(moment(), "day");

  const getOrdinalLabel = (number) => {
    const j = number % 10;
    const k = number % 100;

    if (j === 1 && k !== 11) {
      return `${number}st`;
    }
    if (j === 2 && k !== 12) {
      return `${number}nd`;
    }
    if (j === 3 && k !== 13) {
      return `${number}rd`;
    }
    return `${number}th`;
  };


  const handleButtonClickZoomMeet = () => {
    // Use join_url (session_link/patient_url) — never start_url (doctor_url).
    // join_url works for all roles; Zoom auto-detects host and grants controls.
    const zoomSchedulerUrl = selectedZoomMeet?.session_link || selectedZoomMeet?.patient_url;
    if (zoomSchedulerUrl) {
      window.open(zoomSchedulerUrl, "_blank", "noopener,noreferrer");
    }

    //   navigate('/ZoomCallLink', {
    //     state: {sessionid: SessionIDCheck, useridchk: userid, summaryTxt:RecordData.chatbot_summary, followSummaryTxt: FollowupData } 
    //  }); 
  };
  const handleButtonClickFollowZoomMeet = () => {
    // Use join_url (session_link/patient_url) — never start_url (doctor_url).
    // Using start_url for a followup meeting causes "host has another meeting
    // in progress" if the service Zoom account is already hosting another session.
    // join_url works for all roles; Zoom auto-detects host and grants controls.
    const zoomSchedulerUrl = selectedItemFollowup?.zoom_meeting?.session_link
      || selectedItemFollowup?.zoom_meeting?.patient_url;
    if (zoomSchedulerUrl) {
      window.open(zoomSchedulerUrl, "_blank", "noopener,noreferrer");
    }
  };

  // Force-end the current Zoom meeting on Zoom's servers so the host account
  // is freed up. Called when admin sees "host has another meeting in progress".
  const handleEndMeeting = async (meetingId) => {
    if (!meetingId) return;
    setIsEndingMeeting(true);
    try {
      const res = await fetchWithAppCheck(
        'https://us-central1-aigicare-prod.cloudfunctions.net/endZoomMeeting',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ meeting_id: String(meetingId) }),
        }
      );
      const data = await res.json();
      if (res.ok && data.status === 'success') {
        toast.success('Previous meeting ended. You can now join the meeting.', { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error('Could not end meeting: ' + (data.message || 'unknown error'), { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (err) {
      logger.error('handleEndMeeting error:', err);
      toast.error('Failed to end meeting. Please try again.', { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsEndingMeeting(false);
    }
  };
  const handleButtonBackZoomInvite = () => {
    setCheckFollowup(false);
    setOpenDiv(openDiv === 'Followup' ? null : 'Followup');
    setCheckZoomMeetStart(false)
  }

  const [errorMessageNew, setErrorMessageNew] = useState("");


  const handleDurationChange = (e) => {
    let value = e.target.value;

    // Allow empty input (for deletion)
    if (value === "") {
      setEditduration("");
      setErrorMessageNew("");
      return;
    }

    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, "");

    // Validate: Maximum 3 digits
    if (numericValue.length > 3) {
      setErrorMessageNew("Please enter a number between 0-999");
      return;
    } else {
      setErrorMessageNew(""); // Clear error if valid
    }

    setEditduration(numericValue); // Update the input field
  };


  const handleDurationChangeFollow1 = (e) => {
    let value = e.target.value;

    // Allow empty input (for deletion)
    if (value === "") {
      setEditdurationFollow1("");
      setErrorMessageNew("");
      return;
    }

    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, "");

    // Validate: Maximum 3 digits
    if (numericValue.length > 3) {
      setErrorMessageNew("Please enter a number between 0-999");
      return;
    } else {
      setErrorMessageNew(""); // Clear error if valid
    }

    setEditdurationFollow1(numericValue); // Update the input field
  };

  const handleDurationChangeFollow2 = (e) => {
    let value = e.target.value;

    // Allow empty input (for deletion)
    if (value === "") {
      setEditdurationFollow2("");
      setErrorMessageNew("");
      return;
    }

    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, "");

    // Validate: Maximum 3 digits
    if (numericValue.length > 3) {
      setErrorMessageNew("Please enter a number between 0-999");
      return;
    } else {
      setErrorMessageNew(""); // Clear error if valid
    }

    setEditdurationFollow2(numericValue); // Update the input field
  };


  const handleDurationChangeFollow3 = (e) => {
    let value = e.target.value;

    // Allow empty input (for deletion)
    if (value === "") {
      setEditdurationFollow3("");
      setErrorMessageNew("");
      return;
    }

    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, "");

    // Validate: Maximum 3 digits
    if (numericValue.length > 3) {
      setErrorMessageNew("Please enter a number between 0-999");
      return;
    } else {
      setErrorMessageNew(""); // Clear error if valid
    }

    setEditdurationFollow3(numericValue); // Update the input field
  };



  return (
    <div>
      {ShowLoaderPage && <LoaderSpinner />}

      <div className='container-fluid p-0 adminDashboardMain'>
        <SideBarMenu />

        <div className='container-fluid p-0 contentBody'>
          <Header />
          <div className="innerBodyBox bgInnerDiv">

            <div className="contentInnerBody">


              <div className="contentMainBox viewPatientMain">
                <div className={"dashboardMainDiv " + (CheckZoomMeetStart && 'd-none')}>
                  <div className="userInfoMainDiv whiteBg innerDivRecords">
                    <div className="imgBox">
                      <b>
                        {fullName.split(' ').map(word => word.charAt(0).toUpperCase()).join('')}
                      </b>
                    </div>
                    <div className="titleDivRight">
                      <h2 className="capitalizeTxt">{fullName}</h2>
                      <div style={{ position: 'absolute', right: 0, top: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {/* Export Records button hidden
                        <button
                          onClick={handleDownloadFHIRBundle}
                          disabled={isDownloadingFHIR}
                          style={{
                            background: isDownloadingFHIR ? '#aaa' : '#024C9C',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '7px 14px',
                            fontSize: '13px',
                            fontWeight: '500',
                            cursor: isDownloadingFHIR ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                          }}
                        >
                          {isDownloadingFHIR ? <>&#8635; Downloading...</> : <>&#11123; Export Records</>}
                        </button>
                        */}
                        <button className="backBtn" style={{ position: 'static' }} onClick={showSummay ? (handleHideSummary) : (handleShowDashboard)}
                        ><img src={Icons[0].admin_backBtn} />Back</button>
                      </div>
                      <ul className="userInfoDetails">
                        <li className={GenderTxt ? '' : 'd-none'}>
                          <img src={Icons[0].admin_userIcon} />
                          <label className="capitalizeTxt">{GenderTxt}</label>
                        </li>
                        <li className={DOBTxt ? '' : 'd-none'}>
                          <img src={Icons[0].admin_calendarIcon} />
                          <label>{moment(DOBTxt).format('MMM DD, YYYY')} {' '}({ageCal} years)</label>
                        </li>
                        <li>
                          <img src={Icons[0].admin_mailIcon} />
                          <label className="singleLineEllipsis" onClick={() => copyToClipboard(email)} style={{ cursor: 'pointer' }}>{email} {" "}
                            <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                          </label>
                        </li>
                        <li>
                          <img src={Icons[0].admin_phoneIcon} />
                          <label>{phoneNumber}</label>
                        </li>
                      </ul>
                      <div className="listOptDiv">
                        <ul className={"userMedicalInfo " + (CheckExpiry && "CheckExpiryList")}>
                          <li>
                            <b>{BMITxt}</b>
                            <label>BMI</label>
                          </li>
                          <li>
                                <b>{WeightTxt  ? WeightTxt : '0'}{' '}<span>lbs</span></b>
                                <label>Weight</label>
                              </li>
                              <li>
                                <b>{HeightTxt ? HeightTxt : '0'}{' '}<span>cm</span></b>
                                <label>Height</label>
                              </li>
                          <li>
                            <b>{myinsuranceinfo.insurance_carrier}</b>
                            <label>Insurance Carrier</label>
                          </li>
                          <li>
                            <b>{myinsuranceinfo.group_name}</b>
                            <label>Group name</label>
                          </li>
                          <li>
                            <b>{myinsuranceinfo.policy_id}</b>
                            <label>Insurance ID</label>
                          </li>
                          <li>
                            <b>{formatConsultationDate(myinsuranceinfo.expiry_date, myinsuranceinfo.expiry_date)}</b>
                            <label>Effective Date</label>
                          </li>
                        </ul>
                        <ul className="userMedicalInfo">
                          <li>
                            <b className="text-center">{UserHistoryNumber}</b>
                            <label>Appointments</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className={"patientHistoryMain " + (showSummay ? 'd-none' : '')}>
                    <div className="whiteBg innerDivRecords ">
                      <div className="titleDiv">
                        <h2>All Appointments</h2>
                        <ul className={"titleRightSideDiv " + (UserHistoryData.length != 0 ? '' : 'd-none')}>
                          <li>
                            <div className="table-options">
                              <label htmlFor="recordsPerPage">Showing</label>
                              <select id="recordsPerPage" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                            </div>
                          </li>
                        </ul>
                      </div>
                      {UserHistoryData.length != 0 ? (<>
                        <div className="table-container">
                          <table id="patientTable">
                            <thead>
                              <tr>
                                <th>Illnesses</th>
                                <th style={{ textAlign: 'center' }}>Height/Weight</th>
                                <th style={{ textAlign: 'center' }}>Consultation Date</th>
                                <th style={{ textAlign: 'center' }}>Status</th>
                                <th style={{ textAlign: 'center' }}>Assigned Doctor</th>
                                <th style={{ textAlign: 'right', paddingRight: '50px' }}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {renderTableBody()}
                            </tbody>
                          </table>
                        </div>
                      </>) : (<>
                        <div className="titleDiv text-center table-container d-flex justify-content-center align-items-center nodataRecords">
                          <h2> No table record </h2>
                        </div>
                      </>)
                      }
                    </div>

                    <div className={"paginationMain " + (showSummay ? 'd-none' : '') + (UserHistoryData.length != 0 ? '' : 'd-none')}>
                      {renderPagination()}
                      <span className="totalPageDiv">Total Pages: {totalPages}</span>
                    </div>
                  </div>

                  <div className={"patientSummaryMain " + (!showSummay ? 'd-none' : '')}>
                    <div className="innerDivRecords scrollHeightDiv" style={{ borderRadius: "14px", background: "#fff" }} >



                      <div className="whiteBg tab-content d-none p-3 bg-white" style={{ borderRadius: "14px" }}>

                        <div className="despInfoDiv position-relative  d-flex" style={{ height: '70px' }}>
                          <div className="summaryReportBtn">
                            <h2>Summary</h2>
                            <button className="openModalViewAllBtn  " style={{ position: "relative" }} onClick={openModalViewAll}>Final Report</button>
                          </div>

                          <div className="headDespInfoDiv position-absolute top-0 end-0 ">

                            <ul className="optionUpdateList">

                              <li style={{ position: 'relative' }}>
                                <label>Patient Status</label>
                                {selectedItem ? (() => {
                                  const GI_PCP = ['shared_with_pcp','in_review','under_review','approved','needs_signature'];
                                  const isGI = GI_PCP.includes(selectedItem);
                                  const displayLabel = isGI ? 'Pending' : selectedItem.replace(/_/g,' ');
                                  const displayCls = isGI ? 'colorpending' : 'color' + selectedItem;
                                  return <button className={"selectedItemBtn " + displayCls}
                                    onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivStatus}
                                    disabled={selectedItem?.toLowerCase() === "completed"}
                                  >{displayLabel}</button>;
                                })() : (
                                  <button className={"selectedItemBtn cancelBtn"} onClick={toggleDivStatus}>Add Status</button>
                                )}


                                {/* Dropdown div to display the list */}
                                {/* {isOpen && ( */}
                                {openDiv === 'Status' && (
                                  <div className="patientStatusBox" style={{ right: 0, left: 'unset', marginTop: '10px', padding: '10px', zIndex: '11', minWidth: '160px' }}>
                                    <label className='labelTxt pr-0' style={{ width: "130px" }}>Patient Status</label>
                                    <ul style={{ listStyle: 'none', padding: 0 }}>
                                      {items.map((item, index) => (
                                        <li
                                          className={activeItem?.toLowerCase() === item?.toLowerCase() ? 'active' : ''}
                                          key={index}
                                          onClick={() => handleItemClick(item)}
                                        >
                                          {item}
                                        </li>
                                      ))}
                                    </ul>

                                    {/* Save and Cancel buttons */}
                                    <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                      <button className="newBtn cancelBtn" onClick={handleCancel} >
                                        Cancel
                                      </button>
                                      <button
                                        className="newBtn"
                                        onClick={handleSave}
                                        disabled={!activeItem || loading}
                                        style={{
                                          cursor: loading ? 'not-allowed' : 'pointer',
                                        }}
                                      >
                                        {loading ? 'Saving...' : 'Save'}
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </li>
                              {meetingStatusZoom !== 'deactive' && meetingStatusZoom !== 'completed' && (
                                <>
                                  <li className="text-left">
                                    <label>Patient Meeting</label>

                                    {selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? (
                                      <>
                                        {(!meetingStatusZoom || meetingStatusZoom === 'active') ? (
                                          <button className="blueBtnStyle"
                                            onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivZoomMeet}
                                            disabled={selectedItem?.toLowerCase() === "completed"}
                                          >
                                            Meeting Details
                                          </button>
                                        ) : (
                                          <button className="blueBtnStyle" disabled>
                                            Meeting Ended
                                          </button>
                                        )}
                                      </>
                                    ) : (
                                      <button className="selectedItemBtn newClickBtn"
                                        onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivZoomMeet}
                                        disabled={selectedItem?.toLowerCase() === "completed"}
                                        style={{ width: "100px" }}>
                                        Invite Zoom
                                      </button>
                                    )}

                                    {openDiv === 'ZoomMeet' && (
                                      <div className="patientStatusBox ZoomMeetMain" style={{ zIndex: '11' }} >
                                        {selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? (
                                          <>
                                            <div className="p-2">
                                              <h2 className="mb-2">Meeting Details</h2>
                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Meeting ID</label>
                                                <b>{selectedZoomMeet.meeting_id}</b>
                                              </div>
                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Meeting Title</label>
                                                <b>{selectedZoomMeet.topic}</b>
                                              </div>

                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Date Time</label>
                                                <b>{moment.unix(selectedZoomMeet.start_ts).format("MMM DD, YYYY - h:mm A")}</b>
                                              </div>


                                              <div className="meetingDetailsTxt" style={{ display: 'flex', gap: '8px' }}>
                                                <button onClick={handleButtonClickZoomMeet}>Join Meeting</button>
                                                <button style={{ background: '#6c757d', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '5px', cursor: 'pointer', fontSize: '13px' }} onClick={() => {
                                                  const link = selectedZoomMeet.session_link || selectedZoomMeet.patient_url || selectedZoomMeet.doctor_url;
                                                  navigator.clipboard.writeText(link);
                                                  toast.success('Meeting link copied!', { position: toast.POSITION.TOP_RIGHT });
                                                }}>Copy Link</button>
                                              </div>
                                            </div>

                                          </>) : (<>
                                            <form onSubmit={handleSaveZoomInvite}>

                                              <div className="innerZoomMeet">
                                                <h2>Schedule Meeting</h2>
                                                <div>
                                                  <label className="labelTxt">Meeting Title</label>
                                                  <input type="text" className="inputStyle w-100"
                                                    value={meetingTitle}
                                                    onChange={(e) => setMeetingTitle(e.target.value)}
                                                  />
                                                  {errors.meetingTitle && <span className="errorTxt">{errors.meetingTitle}</span>}
                                                </div>
                                                <div className="mt-2 mb-2">


                                                  <span className="d-flex gap-4 datePickerDiv">
                                                    <span>
                                                      <label className="labelTxt">Date</label>
                                                      <DatePicker
                                                        selected={startDate}
                                                        onChange={handleDateChange}
                                                        isClearable
                                                        placeholderText="Select a date"
                                                        dateFormat="MMM dd, yyyy"
                                                        showDisabledMonthNavigation
                                                        minDate={new Date()} // restrict to current and future dates
                                                        className="inputStyle"
                                                        onKeyDown={(e) => e.preventDefault()}
                                                      />
                                                    </span>
                                                    <span>
                                                      <label className="labelTxt">Time</label>
                                                      <DatePicker
                                                        selected={startTime}
                                                        onChange={handleTimeChange}
                                                        showTimeSelect
                                                        showTimeSelectOnly
                                                        timeIntervals={45}
                                                        timeCaption="Time"
                                                        dateFormat="h:mm aa"
                                                        className="inputStyle inputTimeStyle"
                                                        // Restrict to future dates only
                                                        minDate={now}

                                                        // Conditional minTime based on whether today is selected
                                                        minTime={startTime && startTime.toDateString() === now.toDateString() ? now : new Date(0, 0, 0, 0, 0)}
                                                        maxTime={new Date(0, 0, 0, 23, 45)} // Allow up to end of the day

                                                      />
                                                    </span>
                                                  </span>

                                                </div>

                                                <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                                  <button type="button" className="newBtn cancelBtn" onClick={handleCancelZoomMeet}>
                                                    Cancel
                                                  </button>
                                                  <button
                                                    className="newBtn"
                                                    type="submit"
                                                    style={{
                                                      cursor: loading ? 'not-allowed' : 'pointer',
                                                      width: '125px'
                                                    }}
                                                  >
                                                    {loading ? 'Saving...' : 'Invite Meeting'}
                                                  </button>
                                                </div>
                                              </div>
                                            </form>
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </li>
                                </>
                              )}

                              {(meetingStatusZoom === 'deactive' || meetingStatusZoom === 'completed') && (
                                <>
                                  <li style={{ width: "130px" }} className={checkFollowupMeet ? '' : ' '}>
                                    <label>Follow-up
                                      {/* {isPastDate && selectedItem?.toLowerCase() === "completed" && ( <img style={{ width: '18px', marginLeft: '5px' }} src={Icons[0].calendarEdit} className="logoImg  " alt="" onClick={toggleDivFollowup} /> )} */}
                                      {isPastDate && selectedItem?.toLowerCase() !== "completed" && (
                                        <img
                                          style={{ width: '18px', marginLeft: '5px' }}
                                          src={Icons[0]?.calendarEdit}
                                          className="logoImg"
                                          alt="Edit Icon"
                                          onClick={toggleDivFollowup}
                                        />
                                      )}
                                    </label>

                                    <b>{followupZoomMeet}</b>
                                    <button
                                      className={"selectedItemBtn " + (followupZoomMeet ? 'blueBtnStyle newBlueBtn' : 'newClickBtn')}
                                      onClick={toggleDivFollowup}
                                      style={{ width: followupZoomMeet ? "120px" : "110px", padding: "5px" }}
                                    >
                                      {
                                        followupZoomMeet
                                          ? "Meeting Active"
                                          : checkFollowupMeet
                                            ? "Request Sent"
                                            : "Add Followup"}
                                    </button>


                                    {/* {followupZoomMeet && checkFollowupMeet ? (
                                      <button
                                        className="selectedItemBtn blueBtnStyle"
                                        onClick={toggleDivFollowup}
                                        style={{ width: "110px", padding: "5px" }}
                                      >
                                        Meeting Active
                                      </button>
                                    ) : checkFollowupMeet ? (
                                      <button
                                        className="selectedItemBtn newClickBtn"
                                        onClick={toggleDivFollowup}
                                        style={{ width: "110px", padding: "5px" }}
                                      >
                                        Patient Request
                                      </button>
                                    ) : (
                                      <button
                                        className="selectedItemBtn newClickBtn"
                                        onClick={toggleDivFollowup}
                                        style={{ width: "110px", padding: "5px" }}
                                      >
                                        Add Followup
                                      </button>
                                    )} */}

                                    {openDiv === 'Followup' && (
                                      <form onSubmit={handleSaveFollowup}>
                                        <div className="patientStatusBox datePickerDiv followInviteForm ZoomMeetMain" style={{ border: '1px solid #ccc', marginTop: '10px', padding: '10px', zIndex: '11' }}>
                                          {!followupZoomMeet ? (<>
                                            <h2>Schedule Follow up</h2>
                                            {checkAllFollowupMeet ? (<>
                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Title: </label>
                                                <b>{selectedItemFollowup?.title}</b>
                                              </div>
                                            </>) : (
                                              <>
                                                <div>
                                                  <label className="labelTxt">Follow-Up: Choose any one</label>

                                                  <ul className="followupOptList">
                                                    {options.map((option, index) => (
                                                      <li
                                                        key={index}
                                                        className={`option-item ${activeOption === option ? 'active' : ''}`} // Add "active" class to selected item
                                                        onClick={() => handleOptionClick(option)} // Update active option on click
                                                      >
                                                        {option}
                                                      </li>
                                                    ))}
                                                  </ul>
                                                </div>
                                              </>
                                            )}




                                            {checkAllFollowupMeet ?
                                              (<>
                                                <div className="meetingDetailsTxt align-items-start">
                                                  <label className="labelTxt">Followup Description: </label>
                                                  <b className="twoLineEllipsis" title={selectedItemFollowup?.description} >{selectedItemFollowup?.description}</b>
                                                </div>
                                              </>) : (
                                                <>
                                                  <label className="labelTxt">Followup Description: </label>
                                                  <div className="mt3 inputDiv fillDetailsForm newFillDetailForm d-flex border-0">
                                                    <textarea
                                                      className="textareaFollowupNew"
                                                      value={transcripts.medicalcondition}
                                                      onChange={handleTextChangeMedicalCondition}   >
                                                    </textarea>
                                                  </div> </>
                                              )
                                            }

                                            {/* Followup Medical Report Upload */}
                                            {(
                                              <div className="mt-2 mb-3">
                                                <label className="labelTxt">Upload Medical Reports (optional)</label>
                                                <p style={{ fontSize: '11px', color: '#666', margin: '2px 0 8px' }}>
                                                  Lab results, imaging, test results, etc.
                                                </p>

                                                {/* Hidden native file input */}
                                                <input
                                                  ref={followupFileInputRef}
                                                  type="file"
                                                  multiple
                                                  accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                                  onChange={handleFollowupFileChange}
                                                  style={{ display: 'none' }}
                                                />

                                                {/* Custom click zone */}
                                                <div
                                                  onClick={() => followupFileInputRef.current?.click()}
                                                  style={{ border: '2px dashed #024C9C', borderRadius: '8px', padding: '18px 12px', textAlign: 'center', cursor: 'pointer', background: '#f5f9ff', color: '#024C9C', transition: 'background 0.2s' }}
                                                  onMouseEnter={e => e.currentTarget.style.background = '#eaf1ff'}
                                                  onMouseLeave={e => e.currentTarget.style.background = '#f5f9ff'}
                                                >
                                                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#024C9C" strokeWidth="1.8" style={{ marginBottom: '6px' }}>
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                    <polyline points="17 8 12 3 7 8"/>
                                                    <line x1="12" y1="3" x2="12" y2="15"/>
                                                  </svg>
                                                  <p style={{ margin: 0, fontSize: '13px', fontWeight: '500' }}>Click to upload files</p>
                                                  <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#666' }}>PDF, JPG, PNG, DOC, DOCX</p>
                                                </div>

                                                {/* File list */}
                                                {followupFiles.length > 0 && (
                                                  <div className="attachmentListData" style={{ marginTop: '10px' }}>
                                                    <table style={{ width: '100%' }}>
                                                      <tbody>
                                                        {followupFiles.map((f, i) => {
                                                          const tempKey = f.name + '_' + f.size;
                                                          const status = fileUploadStatuses[tempKey];
                                                          return (
                                                            <tr key={i} className="uploadFilelistOpt">
                                                              <td style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
                                                                <span style={{ fontSize: '18px' }}>
                                                                  {f.name.toLowerCase().endsWith('.pdf') ? '📄' : f.name.match(/\.(jpg|jpeg|png)$/i) ? '🖼️' : '📁'}
                                                                </span>
                                                                <span style={{ fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{f.name}</span>
                                                                {status === 'uploading' && <span style={{ fontSize: '10px', color: '#024C9C', whiteSpace: 'nowrap' }}>Uploading...</span>}
                                                                {status === 'summarizing' && <span style={{ fontSize: '10px', color: '#fd7e14', whiteSpace: 'nowrap' }}>Summarizing...</span>}
                                                                {status === 'done' && <span style={{ fontSize: '10px', color: '#28a745', whiteSpace: 'nowrap' }}>✓ Done</span>}
                                                                {status === 'error' && <span style={{ fontSize: '10px', color: '#dc3545', whiteSpace: 'nowrap' }}>✗ Error</span>}
                                                              </td>
                                                              <td style={{ textAlign: 'right', paddingLeft: '8px' }}>
                                                                <button type="button" className="attachmentDeleteBtn" onClick={() => setFollowupFiles(prev => prev.filter((_, idx) => idx !== i))} title="Remove file">
                                                                  <img src={Icons[0].deleteIcon} alt="Remove" />
                                                                </button>
                                                              </td>
                                                            </tr>
                                                          );
                                                        })}
                                                      </tbody>
                                                    </table>
                                                    <div style={{ textAlign: 'right', marginTop: '6px' }}>
                                                      <span onClick={() => followupFileInputRef.current?.click()} style={{ fontSize: '12px', color: '#024C9C', cursor: 'pointer', textDecoration: 'underline' }}>+ Add more files</span>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            )}


                                            <div className="mt-2 mb-2">
                                              <span className="d-flex gap-4 datePickerDiv">
                                                <span>
                                                  <label className="labelTxt">Date</label>
                                                  <DatePicker
                                                    //  selected={startDate}
                                                    selected={followupDate || new Date()}
                                                    // onChange={(date) => setStartDate(date)}
                                                    onChange={handleFollowDateChange}
                                                    isClearable
                                                    placeholderText="Select a date"
                                                    dateFormat="MMM dd, yyyy"
                                                    showDisabledMonthNavigation
                                                    minDate={new Date()} // restrict to current and future dates
                                                    className="inputStyle"
                                                    onKeyDown={(e) => e.preventDefault()}
                                                  />
                                                </span>
                                                <span>
                                                  <label className="labelTxt">Time</label>
                                                  <DatePicker
                                                    selected={followupTime}
                                                    onChange={handleFollowTimeChange}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={45}
                                                    timeCaption="Time"
                                                    dateFormat="h:mm aa"
                                                    className="inputStyle inputTimeStyle"
                                                    // Restrict to future dates only
                                                    minDate={now}
                                                    // Conditional minTime based on whether today is selected
                                                    minTime={startTime && startTime.toDateString() === now.toDateString() ? now : new Date(0, 0, 0, 0, 0)}
                                                    maxTime={new Date(0, 0, 0, 23, 45)} // Allow up to end of the day

                                                  />
                                                </span>
                                              </span>

                                            </div>

                                            {errors.followupDays && <div className="errorTxt" >{errors.followupDays}</div>}

                                            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                              <button type="button" className="newBtn cancelBtn" onClick={handleCancelFollowup}>
                                                Cancel
                                              </button>
                                              <button
                                                className="newBtn"
                                                type="submit"
                                                style={{
                                                  cursor: loading ? 'not-allowed' : 'pointer',
                                                }}
                                              >
                                                {loading ? 'Saving...' : 'Save'}
                                              </button>
                                            </div>
                                          </>) : (<>

                                            <h2 style={{ fontSize: '16px' }} className="mb-2">Follow up Details </h2>
                                            {/* <div className="meetingDetailsTxt">
                                            <label className="labelTxt">Title</label>
                                            <b>{selectedItemFollowup?.title}</b>                      
                                        </div> 
                                        <div className="meetingDetailsTxt">
                                            <label className="labelTxt">Description</label>
                                            <b>{selectedItemFollowup?.description}</b>                      
                                        </div>  */}

                                            <div className="meetingDetailsTxt">
                                              <label className="labelTxt">Meeting ID</label>
                                              <b>{selectedItemFollowup?.zoom_meeting?.meeting_id}</b>
                                            </div>
                                            <div className="meetingDetailsTxt">
                                              <label className="labelTxt">Meeting Title</label>
                                              <b>{selectedItemFollowup?.zoom_meeting?.topic}</b>
                                            </div>

                                            <div className="meetingDetailsTxt">
                                              <label className="labelTxt">Date Time</label>
                                              <b>{selectedItemFollowup?.zoom_meeting?.start_time
                                                ? moment(selectedItemFollowup.zoom_meeting.start_time).format("MMM DD, YYYY - h:mm A")
                                                : selectedItemFollowup?.zoom_meeting?.start_ts
                                                  ? moment(typeof selectedItemFollowup.zoom_meeting.start_ts === 'number' ? selectedItemFollowup.zoom_meeting.start_ts * 1000 : selectedItemFollowup.zoom_meeting.start_ts).format("MMM DD, YYYY - h:mm A")
                                                  : 'N/A'}</b>
                                            </div>

                                            <div className="meetingDetailsTxt" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                              {followupZoomMeet ? (
                                                <>
                                                  <button type="button" onClick={handleButtonClickFollowZoomMeet}>Join Meeting</button>
                                                  <button
                                                    type="button"
                                                    disabled={isEndingMeeting}
                                                    onClick={() => handleEndMeeting(selectedItemFollowup?.zoom_meeting?.meeting_id)}
                                                    style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '5px', cursor: isEndingMeeting ? 'not-allowed' : 'pointer', fontSize: '13px' }}
                                                  >
                                                    {isEndingMeeting ? 'Ending...' : 'End Meeting'}
                                                  </button>
                                                </>
                                              ) : (
                                                <>
                                                  <button className="" disabled={true}>Request in Progress</button>
                                                </>
                                              )}
                                            </div>



                                          </>)

                                          }
                                        </div>
                                      </form>


                                    )}
                                  </li>
                                </>
                              )}

                            </ul>
                          </div>
                        </div>
                        <div className="innerDivBox h-auto">
                          {FollowupData?.length > 0 ? (
                            FollowupData.map((item, index) =>
                              //   [...FollowupData]
                              // .sort((a, b) => new Date(b.created_on) - new Date(a.created_on)) // Sort by `created_on` in descending order
                              // .map((item, index) => 
                              item.followup_summary ? (
                                <div key={index}>
                                  <div className="despInfoDiv">
                                    <div className="headDespInfoDiv">
                                      <ul className="infoDivPatientList">
                                        <li>
                                          <label>
                                            {`${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}
                                          </label>
                                          <b>{formatConsultationDate(item.created_on, item.created_at)}</b>
                                        </li>
                                        <li>
                                          <label>Follow up</label>
                                          <b>{item.topic}</b>
                                        </li>


                                        {calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts) ?
                                          (<>
                                            <li  >
                                              <label>Physician</label>
                                              <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                                            </li>
                                            <li  >
                                              <label>Patient </label>
                                              <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                                            </li>
                                            <li  >
                                              <label>Communication</label>
                                              <b>Audio & Video</b>
                                            </li>
                                            <li >
                                              <label>Duration</label>{" "}
                                              <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                                            </li>
                                            <li >
                                              <label>Verbal consent </label>{" "}
                                              <b>Obtained</b>
                                            </li>


                                          </>
                                          ) : null}


                                      </ul>

                                      <a onClick={() => handleInputMainSummaryEditFollowup(item.followup_id, item.followup_summary)} style={{ marginLeft: '10px', cursor: 'pointer' }} className={ImageHide ? "editBtnNewSummary " : "editBtnNewSummary "}>
                                        Edit <img src={editMode === item.followup_id ? Icons[0].editIcon : Icons[0].editRed} /></a>

                                    </div>
                                  </div>
                                  {/* {!showSummaryEditFollowup ? ( */}
                                  {!editMode || editMode !== item.followup_id ? (
                                    <>
                                      <pre className="innerDivBoxPC h-auto">{item.followup_summary} </pre>
                                    </>
                                  ) : (
                                    <div className='textareaSummary  innerDivBox w-100' style={{ height: 'auto' }}>
                                      <textarea
                                        value={editText}
                                        onChange={(e) => setEditText(e.target.value)}
                                        //  value={item.followup_summary} 
                                        //  onChange={handleInputChangeSummaryEditFollowup} 
                                        style={{ height: '200px', width: ' 100%' }} />
                                      <hr></hr>
                                      <div className='editSaveOpt' >
                                        {ShowLoaderSummaryFollowup ? (<>
                                          <button  > Loading
                                            <div className="spinner-border text-light" role="status">
                                              <span className="visually-hidden">Loading...</span>
                                            </div>
                                          </button>
                                        </>) : (<>
                                          <button onClick={() => handleSaveSummaryEditFollowup(item?.followup_id, index)}>
                                            Save Changes
                                          </button>
                                        </>)

                                        }

                                        <button onClick={handleCancelClickSummaryEditFollowup}>Cancel</button>
                                      </div>
                                    </div>

                                  )}

                                  {/* Generate Followup Report Button */}
                                  {item.followup_summary && !hideClinicEdit && (
                                    <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      {!item.report_generated ? (
                                        <button
                                          className="selectedItemBtn newClickBtn"
                                          style={{ fontSize: '12px', padding: '5px 12px', width: 'auto' }}
                                          disabled={isGeneratingFollowupReport === (item.followup_id || item.id)}
                                          onClick={() => handleGenerateFollowupReport(item.followup_id || item.id)}
                                        >
                                          {isGeneratingFollowupReport === (item.followup_id || item.id) ? 'Generating Report...' : 'Generate Followup Report'}
                                        </button>
                                      ) : (
                                        <span style={{ fontSize: '12px', color: '#28a745', fontWeight: '600' }}>
                                          Report Generated (Version {item.report_version})
                                        </span>
                                      )}
                                    </div>
                                  )}

                                  {/* Uploaded Reports with AI Summaries */}
                                  {followupReportData[item.followup_id || item.id]?.length > 0 && (
                                    <div style={{ marginTop: '14px', marginBottom: '10px' }}>
                                      <p style={{ fontSize: '13px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                                        Uploaded Medical Reports ({followupReportData[item.followup_id || item.id].length})
                                      </p>
                                      {followupReportData[item.followup_id || item.id].map((report, ri) => (
                                        <div key={ri} style={{ border: '1px solid #e0e8f0', borderRadius: '8px', padding: '10px 14px', marginBottom: '8px', background: '#f8fbff' }}>
                                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                            <span style={{ fontSize: '12px', fontWeight: '600', color: '#024C9C', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                              <span>{(report.file_name || '').match(/\.(jpg|jpeg|png)$/i) ? '🖼️' : '📄'}</span>
                                              {report.file_name || 'Report'}
                                            </span>
                                            {report.doc_url && (
                                              <a href={report.doc_url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#024C9C' }}>View File</a>
                                            )}
                                          </div>
                                          {report.doc_summary ? (
                                            <p style={{ fontSize: '12px', color: '#444', margin: 0, whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>{report.doc_summary}</p>
                                          ) : (
                                            <p style={{ fontSize: '11px', color: '#999', margin: 0, fontStyle: 'italic' }}>AI summary pending...</p>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  <hr style={{ margin: '20px 0' }}></hr>
                                </div>
                              ) : null // If followup_summary is null, render nothing
                            )
                          ) : null}

                          <div className="despInfoDiv">
                            <div className="headDespInfoDiv">
                              <ul className="infoDivPatientList">
                                <li>
                                  <label>Consultation</label>
                                  <b> {formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
                                </li>
                                <li>
                                  <label>Illnesses</label>
                                  <b>{RecordData.illness}</b>
                                </li>
                                {meetingCheckZoomTranscript ?
                                  (<>
                                    <li  >
                                      <label>Physician</label>
                                      <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                                    </li>
                                    <li  >
                                      <label>Patient </label>
                                      <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                                    </li>
                                    <li  >
                                      <label>Communication</label>
                                      <b>Audio & Video</b>
                                    </li>
                                    <li >
                                      <label>Duration   {!hideClinicEdit && (<button
                                        className={
                                          'editIcon border-0 ' +
                                          (checkPhysicalExam || filledCheckPhysicalExam ? 'btnactive ' : '') +
                                          (selectedItem?.toLowerCase() === "completed" ? 'd-none' : '')
                                        }
                                        style={{ width: '30px', background: "transparent", padding: "4px" }}
                                        onClick={toggleEditDuration}
                                      >
                                        <img src={Icons[0].editIcon} className="logoImg w-100" alt="Edit Icon" />
                                      </button>)}
                                      </label>
                                      <b>
                                        {EditDurationTxt}

                                        {/* {calculateDuration(selectedZoomMeet.start_ts, selectedZoomMeet.end_ts)}   */}


                                      </b>
                                      {openDiv === 'EditDuration' && (

                                        <div className="patientStatusBox EditDurationBox PhysicalExamDivBox" style={{ zIndex: '11' }} >

                                          <div className=" black-80 center stepFirstForm w-100">

                                            <from className="measure w-100" >


                                              <div className='d-block mt-0 ' >

                                                <div className='d-grid mt-2   gap-3 '>


                                                  <div className='w-100 '>
                                                    <label className='labelTxt pr-0' style={{ width: "130px" }}>Duration</label>
                                                    <div className=" inputDiv">
                                                      <input
                                                        type="text"
                                                        style={{ paddingLeft: "10px" }}
                                                        value={EditDurationTxtTemp} // Use the state value for the input
                                                        onChange={(e) => {
                                                          const value = e.target.value;
                                                          // Remove any non-digit characters
                                                          const numericValue = value.replace(/\D/g, '');
                                                          // Limit to 3 digits
                                                          if (numericValue.length <= 3) {
                                                            setEditDurationTxtTemp(numericValue);
                                                          }
                                                        }}
                                                      />
                                                      <label></label>
                                                    </div>
                                                    {errors.EditDurationTxt && <span className="errorTxt" >{errors.EditDurationTxt}</span>}
                                                  </div>

                                                </div>
                                              </div>
                                              <span className="d-flex gap-4" style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                                <button className="newBtn cancelBtn" onClick={handleCancelEditDuration} >Close</button>
                                                <button onClick={handleSubmitEditDuration}
                                                  disabled={ShowLoader}
                                                  className="newBtn   "
                                                  style={{
                                                    cursor: ShowLoader ? 'not-allowed' : 'pointer',
                                                  }}
                                                  type="submit" >
                                                  {ShowLoader ? 'Saving...' : 'Save'}</button>

                                              </span>

                                            </from>
                                          </div>

                                        </div>
                                      )}
                                    </li>


                                    <li >
                                      <label>Verbal consent </label>{" "}
                                      <b>Obtained</b>
                                    </li>

                                  </>
                                  ) : null}





                              </ul>
                              {!hideClinicEdit ? (<>

                                <a onClick={() => handleInputMainSummaryEditAIChatbot(followSummaryEditAIChatbot || RecordData.chatbot_summary)} style={{ marginLeft: '10px', cursor: 'pointer' }} className={ImageHide ? "editBtnNewSummary " : "editBtnNewSummary "}>
                                  Edit <img src={!showSummaryEditAIChatbot ? Icons[0].editIcon : Icons[0].editRed} /></a> </>) : ('')}

                            </div>
                          </div>
                          {/* {FollowupData.followup_summary ? <p className="innerDivBox">{FollowupData.followup_summary} </p> :  <p className="innerDivBox"> - </p> } */}
                          {!showSummaryEditAIChatbot ? (
                            <>
                              {EmergencyQuest ?
                                <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p>
                                :
                                followSummaryEditAIChatbot ? (
                                  <>
                                    <div className="innerDivBoxPC h-auto">{renderAISummary(followSummaryEditAIChatbot)}</div>
                                    {PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name ? (
                                      <>
                                        <b>Primary Care Physician (PCP): </b>
                                        {PCP_Pharmacy.pcp.name}{PCP_Pharmacy.pcp.address ? ', ' + PCP_Pharmacy.pcp.address : ''}
                                        {PCP_Pharmacy.pcp.phone ? <span> | Phone: {PCP_Pharmacy.pcp.phone}</span> : null}
                                        {PCP_Pharmacy.pcp.fax ? <span> | Fax: {PCP_Pharmacy.pcp.fax}</span> : null}
                                        <br />
                                      </>
                                    ) : null}
                                    {PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name ? (
                                      <>
                                        <b>Pharmacy information: </b>
                                        {PCP_Pharmacy.pharmacy.name}{PCP_Pharmacy.pharmacy.address ? ', ' + PCP_Pharmacy.pharmacy.address : ''}
                                        {PCP_Pharmacy.pharmacy.phone ? <span> | Phone: {PCP_Pharmacy.pharmacy.phone}</span> : null}
                                        {PCP_Pharmacy.pharmacy.fax ? <span> | Fax: {PCP_Pharmacy.pharmacy.fax}</span> : null}
                                      </>
                                    ) : null}
                                  </>
                                ) : (
                                  <div className="innerDivBoxPC" style={{ textAlign: 'center', padding: '20px' }}>
                                    {isRegeneratingAI ? (
                                      <>
                                        <div className="spinner-border text-primary" role="status" style={{ width: '20px', height: '20px', margin: '8px auto' }}>
                                          <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ color: '#666', marginTop: '8px', fontSize: '13px' }}>Generating AI summary...</p>
                                      </>
                                    ) : (
                                      <p style={{ color: '#999' }}>No summary available</p>
                                    )}
                                  </div>
                                )
                              }
                            </>
                          ) : (
                            <div className='textareaSummary innerDivBox w-100' style={{ height: 'auto' }}>
                              <textarea value={followSummaryEditAIChatbot} onChange={handleInputChangeSummaryEditAIChatbot} style={{ height: '200px', width: ' 100%' }} />
                              <hr></hr>
                              <div className='editSaveOpt' >
                                {ShowLoaderSummaryAIChatbot ? (<>
                                  <button  > Loading
                                    <div className="spinner-border text-light" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                  </button>
                                </>) : (<>
                                  <button onClick={() => handleSaveSummaryEditAIChatbot()}>
                                    Save Changes
                                  </button>
                                </>)

                                }

                                <button onClick={handleCancelClickSummaryEditAIChatbot}>Cancel</button>
                              </div>
                            </div>

                          )}

                        </div>

                        <hr></hr>

                        {/* Zoom Meeting AI Summary — shown only if generated from recording */}
                        {editZoomSummary && (
                          <div className="despInfoDiv" style={{ marginBottom: '16px' }}>
                            <div className="despInfoDiv">
                              <h2>Zoom Meeting Summary <span style={{ fontSize: '13px', fontWeight: 'normal', color: '#888' }}>(AI generated from consultation recording)</span></h2>
                            </div>
                            <pre className="innerDivBoxPC h-auto">{editZoomSummary}</pre>
                            <hr></hr>
                          </div>
                        )}

                        <div className="d-block gap-4">

                          <div className="despInfoDiv PlanCareTab w-100 overflow-auto d-block border-0 h-100" ref={scrollupRef} style={{ marginTop: '0px' }}>
                            <div className="despInfoDiv">
                              <h2>Differential Diagnosis<ViewOnlyBadge /></h2>
                            </div>
                            {/* <div ></div> {/* The scroll-up target */}
                            {EmergencyQuest ? (<>
                              <div className="p-3">

                                <h2>Differential Diagnosis</h2> <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} />
                                  Urgent: Patient has called for emergency assistance.</p> </div>
                            </>)

                              : (<>
                                <div className="accordion" id="accordionExampleNew">
                                  {FollowupData?.length > 0 &&
                                    FollowupData.map((item, index) =>
                                      item.followup_CD ? (
                                        <AccordionSection
                                          key={index}
                                          setData={FollowupData}
                                          // title={`Follow up - Differential Diagnosis`}
                                          title={`Follow up - ${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}
                                          content={followConditionalDiagnosis || item?.followup_CD}
                                          onEditClick={() => handleInputMainPointFollowCD(item?.followup_id, item?.followup_CD, index + 1)}
                                          onSaveClick={() => handleSaveClickMPointFollowCD(item?.followup_id, index + 1)}
                                          onCancelClick={handleCancelClickMPointFollowCD}
                                          showLoader={ShowLoader}
                                          isEditing={showMainPointFollowCD}
                                          // isEditing={editingAccordion === item?.followup_id}
                                          // value={updatedContent+index+1}
                                          // onChange={(e) => setUpdatedContent+index+1(e.target.value)}
                                          value={followConditionalDiagnosis}
                                          onChange={(e) => setFollowConditionalDiagnosis(e.target.value)}

                                          EmergencyQuest={hideClinicEdit}
                                          Icons={Icons}
                                          onAccordionClick={handleAccordionClick} // Pass the scroll handler

                                          isActive={activeAccordion === `Follow up - Differential Diagnosis`}
                                          // setActiveAccordion={setActiveAccordion}
                                          setActiveAccordion={() =>
                                            handleAccordionToggle(`Follow up - Differential Diagnosis`)
                                          }

                                        // setActive={setActive} // Set the active accordion
                                        // active={active === 'Follow_up_Details'} // Check if the section is active

                                        />
                                      ) : null
                                    )}

                                  <AccordionSection
                                    title="Differential Diagnosis"
                                    content={ConditionalDiagnosis || ''}
                                    onEditClick={handleInputMainPointCD}
                                    onSaveClick={handleSaveClickMPointCD}
                                    onCancelClick={handleCancelClickMPointCD}
                                    showLoader={ShowLoader}
                                    isEditing={showMainPointCD}
                                    value={ConditionalDiagnosis}
                                    onChange={(e) => setConditionalDiagnosis(e.target.value)}
                                    EmergencyQuest={hideClinicEdit}
                                    Icons={Icons}
                                    onAccordionClick={handleAccordionClick}
                                    isActive={activeAccordion === 'Differential Diagnosis'}
                                    setActiveAccordion={() => handleAccordionToggle('Differential Diagnosis')}
                                  />
                                  {zoomCD && (
                                    <AccordionSection
                                      title="Differential Diagnosis - Online Consultation"
                                      content={zoomCD}
                                      EmergencyQuest={hideClinicEdit}
                                      Icons={Icons}
                                      onAccordionClick={handleAccordionClick}
                                      isActive={activeAccordion === 'Differential Diagnosis - Online Consultation'}
                                      setActiveAccordion={() => handleAccordionToggle('Differential Diagnosis - Online Consultation')}
                                    />
                                  )}
                                </div>
                              </>)
                            }


                          </div>
                          <div className="despInfoDiv PlanCareTab w-100 overflow-auto border-0 h-100">
                            <div className="despInfoDiv">
                              <h2>Plan of Care<ViewOnlyBadge /></h2>
                            </div>

                            {EmergencyQuest ? (<>
                              <div className="p-3">
                                <h2>Plan of Care</h2> <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} />
                                  Urgent: Patient has called for emergency assistance.</p> </div>
                            </>)

                              : (<>
                                <div className="accordion" id="accordionExample">
                                  {FollowupData?.length > 0 &&
                                    FollowupData.map((item, index) =>
                                      item.followup_CD ? (
                                        <AccordionSectionPoC
                                          key={index}
                                          title={`Follow up - ${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}
                                          content={followPlanOnCareData || item?.followup_PoC}
                                          onEditClick={() => handleInputMainPointFollowPoC(followPlanOnCareData || item?.followup_PoC)}
                                          onSaveClick={() => handleSaveClickMPointFollowPoC(item?.followup_id)}
                                          onCancelClick={handleCancelClickMPointFollowPoC}
                                          showLoader={ShowLoader}
                                          isEditing={showMainPointFollowPoC}
                                          value={followPlanOnCareData}
                                          onChange={(e) => setFollowPlanOnCareData(e.target.value)}
                                          EmergencyQuest={hideClinicEdit}
                                          Icons={Icons}
                                          onAccordionClick={handleAccordionClickPoc} // Pass the scroll handler
                                          isActive={activeAccordionPoc === 'Follow up - Plan of Care'}
                                          setActiveAccordionPoc={() => handleAccordionTogglePoc('Follow up - Plan of Care')}
                                        // setActive={setActive} // Set the active accordion
                                        // active={active === 'Follow_up_Details'} // Check if the section is active

                                        />
                                      ) : null
                                    )}


                                  {zoomPoC && (
                                    <AccordionSectionPoC
                                      title="Plan of Care - Online Consultation"
                                      content={zoomPoC}
                                      EmergencyQuest={hideClinicEdit}
                                      Icons={Icons}
                                      onAccordionClick={handleAccordionClickPoc}
                                      isActive={activeAccordionPoc === 'Plan of Care - Online Consultation'}
                                      setActiveAccordionPoc={() => handleAccordionTogglePoc('Plan of Care - Online Consultation')}
                                    />
                                  )}

                                  <AccordionSectionPoC
                                    title="Plan of Care"
                                    content={PlanOnCareData || ''}
                                    onEditClick={handleInputMainPoint}
                                    onSaveClick={handleSaveClickMPoint}
                                    onCancelClick={handleCancelClickMPoint}
                                    showLoader={ShowLoader}
                                    isEditing={showMainPoint}
                                    value={PlanOnCareData}
                                    onChange={(e) => setPlanOnCareData(e.target.value)}
                                    EmergencyQuest={hideClinicEdit}
                                    Icons={Icons}
                                    onAccordionClick={handleAccordionClickPoc} // Pass the scroll handler
                                    isActive={activeAccordionPoc === 'Plan of Care'}
                                    setActiveAccordionPoc={() => handleAccordionTogglePoc('Plan of Care')}
                                  />
                                </div>
                              </>)
                            }

                            {/* {FollowupData?.length > 0 ? (
                        FollowupData.map((item, index) => 
                          item.followup_PoC ? ( 
                            <div key={index}>
                              <h2>Follow up - Plan of Care
                                    {!hideClinicEdit ? ( <a onClick={() => handleInputMainPointFollowPoC(followPlanOnCareData || item?.followup_PoC)} style={{marginLeft:'10px', cursor:'pointer'}}  className={ImageHide ? "editBtnNew " : "editBtnNew "}> Edit <img src={!showMainPointFollowPoC ? Icons[0].editIcon : Icons[0].editRed } /></a>) :  ('')}
                            
                              </h2>
                          
                              {!showMainPointFollowPoC ? (
                                  <>     
                                    <pre className="innerDivBoxPC h-auto overflow-hidden">
                                      {followPlanOnCareData || item.followup_PoC}
                                    </pre>
                                  </>
                              ) :(
                                <div className='textareaSummary innerDivBox w-100'>
                                  <textarea value={followPlanOnCareData} onChange={handleInputChangeMPointFollowPoC} style={{    height: '80%', width:' 100%'}} /> 
                                  <hr></hr>
                                <div className='editSaveOpt' >
                                    {ShowLoader ? (<>
                                      <button  > Loading
                                      <div className="spinner-border text-light" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div> 
                                    </button>
                                    </>):(<>
                                      <button  onClick={() => handleSaveClickMPointFollowPoC(item?.followup_id)}>  
                                    Save Changes
                                    </button>
                                    </>)

                                    }
                                    
                                    <button onClick={handleCancelClickMPointFollowPoC}>Cancel</button>
                                  </div>
                                </div> 

                              )}

                                  
                              <hr />
                            </div>
                          ) : null // If followup_PoC is empty or null, render nothing
                        )
                      ) : null}


                          <h2>Plan of Care
                          {!hideClinicEdit ? ( <a onClick={handleInputMainPoint} style={{marginLeft:'10px', cursor:'pointer'}}  className={ImageHide ? "editBtnNew " : "editBtnNew "}> Edit <img src={!showMainPoint ? Icons[0].editIcon : Icons[0].editRed } /></a>) :  ('')}
                          </h2>
                          { FollowupData.followup_PoC ? <pre className="innerDivBoxPC h-auto overflow-hidden">{FollowupData.followup_PoC}</pre> : '' }          
                        
                          {!showMainPoint ? (
                                  <>     
                                  {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : PlanOnCareData ? <pre className="innerDivBoxPC h-auto  overflow-hidden">{PlanOnCareData}</pre> : 'No Plan On Care' }  
                                </>
                              ) :(
                                <div className='textareaSummary innerDivBox w-100'>
                                  <textarea value={PlanOnCareData} onChange={handleInputChangeMPoint} style={{    height: '80%', width:' 100%'}} /> 
                                  <hr></hr>
                                <div className='editSaveOpt' >
                                    {ShowLoader ? (<>
                                      <button  > Loading
                                      <div className="spinner-border text-light" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div> 
                                    </button>
                                    </>):(<>
                                      <button onClick={handleSaveClickMPoint}>  
                                    Save Changes
                                    </button>
                                    </>)

                                    }
                                    
                                    <button onClick={handleCancelClickMPoint}>Cancel</button>
                                  </div>
                                </div> 

                              )} */}
                          </div>

                        </div>
                        <hr />
                        <div className="despInfoDiv">
                          <h2>Reports </h2>
                        </div>
                        <div className="innerDivBoxPC h-auto overflow-hidden">


                          <ol className="reportListOptLink" style={{ fontSize: '16px' }}>
                            {sortedGroupedDocuments.length > 0 ? (
                              sortedGroupedDocuments
                                .filter(({ documents }) => documents && documents.length > 0) // Filter out empty or null documents
                                .map(({ doc_type, documents, Name }) => (
                                  <li key={doc_type}>

                                    {documents.map((doc, index) => (
                                      <div key={doc.doc_id} style={{ marginBottom: "0px" }}>
                                        <b style={{ textTransform: "capitalize", textDecoration: "none" }} className={doc_type === "other_report" && index !== 0 && 'd-none'}>
                                          {Name}
                                          {/* {doc_type.replace('_', ' ')} */}
                                        </b>
                                        {/* Document URL with conditional button */}
                                        {doc.doc_url && (
                                          <span
                                            className={
                                              "pdfButtonModal" + (doc_type === "other_report" ? " d-none" : "")
                                            }
                                          >
                                            <button
                                              className="pdfButton pdfViewBtn"
                                              onClick={() => openModal(doc?.doc_url)}
                                            >
                                              View{" "}
                                              <img
                                                src={Icons[0].viewPDF}
                                                alt="PDF Icon"
                                                style={{ width: "24px", marginLeft: "10px" }}
                                              />
                                            </button>
                                          </span>
                                        )}

                                        {/* Document Text */}
                                        {/* Document Text */}
                                        {doc.doc_text && (
                                          <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_text}</p>
                                        )}
                                        {/* PCP / Pharmacy — show doc_summary directly */}
                                        {(doc_type === "pcp" || doc_type === "pharmacy") && doc.doc_summary && (
                                          <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_summary}</p>
                                        )}

                                        {/* Document Summary — only for other_report (uploaded PDFs) */}
                                        {doc_type === "other_report" && (
                                          <div className={"d-flex justify-content-between align-items-center " + (doc.doc_summary && doc.doc_summary.length === 4 && doc.doc_summary === "None" ? 'd-none' : null)}>
                                            <h3
                                              style={{
                                                fontSize: "16px",
                                                marginTop: "14px",
                                                fontWeight: "600",
                                              }}
                                              className="my-0"
                                            >
                                              {index + 1}. Other Report Summary
                                            </h3>
                                            {doc.doc_url && (
                                              <span className="pdfButtonModal">
                                                <button
                                                  className="pdfButton pdfViewBtn"
                                                  onClick={() => openModal(doc?.doc_url)}
                                                >
                                                  View{" "}
                                                  <img
                                                    src={Icons[0].viewPDF}
                                                    alt="PDF Icon"
                                                    style={{ width: "24px", marginLeft: "10px" }}
                                                  />
                                                </button>
                                              </span>
                                            )}
                                          </div>
                                        )}
                                        {doc_type === "other_report" && doc.doc_summary && doc.doc_summary !== "None" && (
                                          <pre style={{ margin: "5px 0", textTransform: "capitalize" }}>
                                            {doc.doc_summary}
                                          </pre>
                                        )}

                                        {/* Conditional Divider */}
                                        {doc.doc_url && (
                                          <hr className={doc_type !== "other_report" ? " d-none" : ""} />
                                        )}
                                      </div>
                                    ))}
                                  </li>
                                ))
                            ) : (
                              <p style={{ textAlign: "center" }}>No reports found</p>
                            )}
                          </ol>



                        </div>



                      </div>

                      <nav className="d-grid newLeftContentDiv" style={{ position: 'relative' }}>
                        <div className="nav nav-tabs mb-0" id="nav-tab" role="tablist">
                          <button className={`nav-link ${activeTab === 0 ? 'active' : ''}`}
                            onClick={() => handleTabClick(0)} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Initial AI Interview</button>
                          <button className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => handleTabClick(1)} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Plan of Care</button>
                          <button className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
                            onClick={() => handleShowChat(2)} id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Presenting Symptoms</button>
                          <button className={`nav-link ${activeTab === 3 ? 'active' : ''}`}
                            onClick={() => handleShowChat(3)} id="nav-reportData-tab" data-bs-toggle="tab" data-bs-target="#nav-reportData" type="button" role="tab" aria-controls="nav-reportData" aria-selected="false">Reports</button>
                          {selectedZoomMeet?.meeting_status === 'completed' && (!isMA() || isFinalNoteSubmitted) && (
                            <button className={`nav-link ${activeTab === 4 ? 'active' : ''}`}
                              onClick={() => handleTabClick(4)} id="nav-zoom-tab" data-bs-toggle="tab" data-bs-target="#nav-zoom" type="button" role="tab" aria-controls="nav-zoom" aria-selected="false">
                              Telehealth Consultation
                            </button>
                          )}
                          {selectedZoomMeet?.meeting_status === 'completed' && (zoomHPI || zoomCD || zoomPoC || editZoomSummary) && (finalConsultantNote || finalConsultantHPI || isGeneratingFinalNote) && (!isMA() || isFinalNoteSubmitted) && (
                            <button className={`nav-link ${activeTab === 5 ? 'active' : ''}`}
                              onClick={() => handleTabClick(5)} id="nav-finalnote-tab" data-bs-toggle="tab" data-bs-target="#nav-finalnote" type="button" role="tab" aria-controls="nav-finalnote" aria-selected="false">
                              Final Consultant Note
                            </button>
                          )}
                        </div>
                        {/* Generate Final Note button — visible to admin/doctor when zoom completed but note not yet generated */}
                        {!hideClinicEdit && selectedZoomMeet?.meeting_status === 'completed' && !finalConsultantNote && !finalConsultantHPI && !isGeneratingFinalNote && (
                          (zoomHPI || zoomCD || zoomPoC || editZoomSummary) ? (
                            <button
                              onClick={handleGenerateFinalNote}
                              style={{ margin: '8px 0', padding: '6px 14px', background: '#024C9C', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
                            >
                              Generate Final Consultant Note
                            </button>
                          ) : (
                            <div style={{ margin: '8px 0', fontSize: '11px', color: '#888', fontStyle: 'italic', padding: '6px 10px', background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '6px' }}>
                              Waiting for telehealth summary to be processed. Final Note will generate automatically once the telehealth data is ready.
                            </div>
                          )
                        )}
                        {isGeneratingFinalNote && (
                          <span style={{ margin: '8px 0', display: 'inline-block', fontSize: '12px', color: '#666' }}>Generating Final Consultant Note...</span>
                        )}
                        {/* Info for admin: why tabs may not be visible */}
                        {(isAdmin() || isDoctor()) && selectedZoomMeet && selectedZoomMeet.meeting_status !== 'completed' && (
                          <div style={{ margin: '6px 0', fontSize: '11px', color: '#94a3b8', fontStyle: 'italic' }}>
                            Telehealth & Final Note tabs will appear after the Zoom meeting is completed (current status: {selectedZoomMeet.meeting_status || 'pending'})
                          </div>
                        )}
                      </nav>
                      <div className="whiteBg tab-content p-3 bg-white float-right newRightContentDiv" id="nav-tabContent" >
                        <div className={`tab-pane fade ${activeTab === 0 ? 'active show' : ''}`} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                          <div className="despInfoDiv position-relative  d-flex" style={{ height: '70px' }}>
                            <h2 className="finalReportH2Tag">Initial AI Interview
                              {selectedZoomMeet?.meeting_status === 'completed' && (
                                <button className="openModalViewAllBtn  " style={{ position: "relative" }} onClick={openModalViewAll}>Final Report</button>
                              )}
                              {isRegeneratingAI && <span style={{ position: "relative", marginLeft: '8px', fontSize: '12px', color: '#666' }}>Generating summary...</span>}
                            </h2>
                            <div className="headDespInfoDiv position-absolute top-0 end-0 ">

                              <ul className="optionUpdateList">

                                <li style={{ position: 'relative' }}>
                                  <label>Patient Status</label>
                                  {selectedItem ? (() => {
                                    const GI_PCP = ['shared_with_pcp','in_review','under_review','approved','needs_signature'];
                                    const isGI = GI_PCP.includes(selectedItem);
                                    const displayLabel = isGI ? 'Pending' : selectedItem.replace(/_/g,' ');
                                    const displayCls = isGI ? 'colorpending' : 'color' + selectedItem;
                                    return <button className={"selectedItemBtn " + displayCls}
                                      onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivStatus}
                                      disabled={selectedItem?.toLowerCase() === "completed"}
                                    >{displayLabel}</button>;
                                  })() : (
                                    <button className={"selectedItemBtn cancelBtn"} onClick={toggleDivStatus}>Add Status</button>
                                  )}


                                  {/* Dropdown div to display the list */}
                                  {/* {isOpen && ( */}
                                  {openDiv === 'Status' && (
                                    <div className="patientStatusBox" style={{ right: 0, left: 'unset', marginTop: '10px', padding: '10px', zIndex: '11', minWidth: '160px' }}>
                                      <label className='labelTxt pr-0' style={{ width: "130px" }}>Patient Status</label>
                                      <ul style={{ listStyle: 'none', padding: 0 }}>
                                        {items.map((item, index) => (
                                          <li
                                            className={activeItem?.toLowerCase() === item?.toLowerCase() ? 'active' : ''}
                                            key={index}
                                            onClick={() => handleItemClick(item)}
                                          >
                                            {item}
                                          </li>
                                        ))}
                                      </ul>

                                      {/* Save and Cancel buttons */}
                                      <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                        <button className="newBtn cancelBtn" onClick={handleCancel} >
                                          Cancel
                                        </button>
                                        <button
                                          className="newBtn"
                                          onClick={handleSave}
                                          disabled={!activeItem || loading}
                                          style={{
                                            cursor: loading ? 'not-allowed' : 'pointer',
                                          }}
                                        >
                                          {loading ? 'Saving...' : 'Save'}
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </li>
                                {meetingStatusZoom !== 'deactive' && meetingStatusZoom !== 'completed' && (
                                  <>
                                    <li className="text-left">
                                      <label>Patient Meeting</label>

                                      {selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? (
                                        <>
                                          {(!meetingStatusZoom || meetingStatusZoom === 'active') ? (
                                            <button className="blueBtnStyle"
                                              onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivZoomMeet}
                                              disabled={selectedItem?.toLowerCase() === "completed"}
                                            >
                                              Meeting Details
                                            </button>
                                          ) : (
                                            <button className="blueBtnStyle" disabled>
                                              Meeting Ended
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <button className="selectedItemBtn newClickBtn"
                                          onClick={selectedItem?.toLowerCase() === "completed" ? null : toggleDivZoomMeet}
                                          disabled={selectedItem?.toLowerCase() === "completed"}
                                          style={{ width: "100px" }}>
                                          Invite Zoom
                                        </button>
                                      )}

                                      {openDiv === 'ZoomMeet' && (
                                        <div className="patientStatusBox ZoomMeetMain" style={{ zIndex: '11' }} >
                                          {selectedZoomMeet && Object.keys(selectedZoomMeet).length > 0 ? (
                                            <>
                                              <div className="p-2">
                                                <h2 className="mb-2">Meeting Details</h2>
                                                <div className="meetingDetailsTxt">
                                                  <label className="labelTxt">Meeting ID</label>
                                                  <b>{selectedZoomMeet.meeting_id}</b>
                                                </div>
                                                <div className="meetingDetailsTxt">
                                                  <label className="labelTxt">Meeting Title</label>
                                                  <b>{selectedZoomMeet.topic}</b>
                                                </div>

                                                <div className="meetingDetailsTxt">
                                                  <label className="labelTxt">Date Time</label>
                                                  <b>{moment.unix(selectedZoomMeet.start_ts).format("MMM DD, YYYY - h:mm A")}</b>
                                                </div>


                                                <div className="meetingDetailsTxt" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                  <button type="button" onClick={handleButtonClickZoomMeet}>Join Meeting</button>
                                                  <button
                                                    type="button"
                                                    disabled={isEndingMeeting}
                                                    onClick={() => handleEndMeeting(selectedZoomMeet.meeting_id)}
                                                    style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '5px', cursor: isEndingMeeting ? 'not-allowed' : 'pointer', fontSize: '13px' }}
                                                  >
                                                    {isEndingMeeting ? 'Ending...' : 'End Meeting'}
                                                  </button>
                                                </div>
                                              </div>

                                            </>) : (<>
                                              <form onSubmit={handleSaveZoomInvite}>

                                                <div className="innerZoomMeet">
                                                  <h2>Schedule Meeting</h2>
                                                  <div>
                                                    <label className="labelTxt">Meeting Title</label>
                                                    <input type="text" className="inputStyle w-100"
                                                      value={meetingTitle}
                                                      onChange={(e) => setMeetingTitle(e.target.value)}
                                                    />
                                                    {errors.meetingTitle && <span className="errorTxt">{errors.meetingTitle}</span>}
                                                  </div>
                                                  <div className="mt-2 mb-2">


                                                    <span className="d-flex gap-4 datePickerDiv">
                                                      <span>
                                                        <label className="labelTxt">Date</label>
                                                        <DatePicker
                                                          selected={startDate}
                                                          onChange={handleDateChange}
                                                          isClearable
                                                          placeholderText="Select a date"
                                                          dateFormat="MMM dd, yyyy"
                                                          showDisabledMonthNavigation
                                                          minDate={new Date()} // restrict to current and future dates
                                                          className="inputStyle"
                                                          onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                      </span>
                                                      <span>
                                                        <label className="labelTxt">Time</label>
                                                        <DatePicker
                                                          selected={startTime}
                                                          onChange={handleTimeChange}
                                                          showTimeSelect
                                                          showTimeSelectOnly
                                                          timeIntervals={45}
                                                          timeCaption="Time"
                                                          dateFormat="h:mm aa"
                                                          className="inputStyle inputTimeStyle"
                                                          // Restrict to future dates only
                                                          minDate={now}

                                                          // Conditional minTime based on whether today is selected
                                                          minTime={startTime && startTime.toDateString() === now.toDateString() ? now : new Date(0, 0, 0, 0, 0)}
                                                          maxTime={new Date(0, 0, 0, 23, 45)} // Allow up to end of the day

                                                        />
                                                      </span>
                                                    </span>

                                                  </div>

                                                  <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                                    <button type="button" className="newBtn cancelBtn" onClick={handleCancelZoomMeet}>
                                                      Cancel
                                                    </button>
                                                    <button
                                                      className="newBtn"
                                                      type="submit"
                                                      style={{
                                                        cursor: loading ? 'not-allowed' : 'pointer',
                                                        width: '125px'
                                                      }}
                                                    >
                                                      {loading ? 'Saving...' : 'Invite Meeting'}
                                                    </button>
                                                  </div>
                                                </div>
                                              </form>
                                            </>
                                          )}
                                        </div>
                                      )}
                                    </li>
                                  </>
                                )}

                                {(meetingStatusZoom === 'deactive' || meetingStatusZoom === 'completed') && (
                                  <>
                                    <li style={{ width: "130px" }} className={checkFollowupMeet ? '' : ' '}>
                                      <label>Follow-up
                                        {/* {isPastDate && selectedItem?.toLowerCase() === "completed" && ( <img style={{ width: '18px', marginLeft: '5px' }} src={Icons[0].calendarEdit} className="logoImg  " alt="" onClick={toggleDivFollowup} /> )} */}
                                        {isPastDate && selectedItem?.toLowerCase() !== "completed" && (
                                          <img
                                            style={{ width: '18px', marginLeft: '5px' }}
                                            src={Icons[0]?.calendarEdit}
                                            className="logoImg"
                                            alt="Edit Icon"
                                            onClick={toggleDivFollowup}
                                          />
                                        )}
                                      </label>

                                      <b>{followupZoomMeet}</b>
                                      <button
                                        className={"selectedItemBtn " + (followupZoomMeet ? 'blueBtnStyle newBlueBtn' : 'newClickBtn')}
                                        onClick={toggleDivFollowup}
                                        style={{ width: followupZoomMeet ? "120px" : "110px", padding: "5px" }}
                                      >
                                        {
                                          followupZoomMeet
                                            ? "Meeting Active"
                                            : checkFollowupMeet
                                              ? "Request Sent"
                                              : "Add Followup"}
                                      </button>


                                      {/* {followupZoomMeet && checkFollowupMeet ? (
                                      <button
                                        className="selectedItemBtn blueBtnStyle"
                                        onClick={toggleDivFollowup}
                                        style={{ width: "110px", padding: "5px" }}
                                      >
                                        Meeting Active
                                      </button>
                                    ) : checkFollowupMeet ? (
                                      <button
                                        className="selectedItemBtn newClickBtn"
                                        onClick={toggleDivFollowup}
                                        style={{ width: "110px", padding: "5px" }}
                                      >
                                        Patient Request
                                      </button>
                                    ) : (
                                      <button
                                        className="selectedItemBtn newClickBtn"
                                        onClick={toggleDivFollowup}
                                        style={{ width: "110px", padding: "5px" }}
                                      >
                                        Add Followup
                                      </button>
                                    )} */}

                                      {openDiv === 'Followup' && (
                                        <form onSubmit={handleSaveFollowup}>
                                          <div className="patientStatusBox datePickerDiv followInviteForm ZoomMeetMain" style={{ border: '1px solid #ccc', marginTop: '10px', padding: '10px', zIndex: '11' }}>
                                            {!followupZoomMeet ? (<>
                                              <h2>Schedule Follow up</h2>
                                              {checkAllFollowupMeet ? (<>
                                                <div className="meetingDetailsTxt">
                                                  <label className="labelTxt">Title: </label>
                                                  <b>{selectedItemFollowup?.title}</b>
                                                </div>
                                              </>) : (
                                                <>
                                                  <div>
                                                    <label className="labelTxt">Follow-Up: Choose any one</label>

                                                    <ul className="followupOptList">
                                                      {options.map((option, index) => (
                                                        <li
                                                          key={index}
                                                          className={`option-item ${activeOption === option ? 'active' : ''}`} // Add "active" class to selected item
                                                          onClick={() => handleOptionClick(option)} // Update active option on click
                                                        >
                                                          {option}
                                                        </li>
                                                      ))}
                                                    </ul>
                                                  </div>
                                                </>
                                              )}




                                              {checkAllFollowupMeet ?
                                                (<>
                                                  <div className="meetingDetailsTxt align-items-start">
                                                    <label className="labelTxt">Followup Description: </label>
                                                    <b className="twoLineEllipsis" title={selectedItemFollowup?.description} >{selectedItemFollowup?.description}</b>
                                                  </div>
                                                </>) : (
                                                  <>
                                                    <label className="labelTxt">Followup Description: </label>
                                                    <div className="mt3 inputDiv fillDetailsForm newFillDetailForm d-flex border-0">
                                                      <textarea
                                                        className="textareaFollowupNew"
                                                        value={transcripts.medicalcondition}
                                                        onChange={handleTextChangeMedicalCondition}   >
                                                      </textarea>
                                                    </div> </>
                                                )
                                              }

                                              {/* Followup Medical Report Upload */}
                                              {(
                                                <div className="mt-2 mb-3">
                                                  <label className="labelTxt">Upload Medical Reports (optional)</label>
                                                  <p style={{ fontSize: '11px', color: '#666', margin: '2px 0 8px' }}>
                                                    Lab results, imaging, test results, etc.
                                                  </p>

                                                  {/* Hidden native file input */}
                                                  <input
                                                    ref={followupFileInputRef}
                                                    type="file"
                                                    multiple
                                                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                                                    onChange={handleFollowupFileChange}
                                                    style={{ display: 'none' }}
                                                  />

                                                  {/* Custom click zone */}
                                                  <div
                                                    onClick={() => followupFileInputRef.current?.click()}
                                                    style={{ border: '2px dashed #024C9C', borderRadius: '8px', padding: '18px 12px', textAlign: 'center', cursor: 'pointer', background: '#f5f9ff', color: '#024C9C', transition: 'background 0.2s' }}
                                                    onMouseEnter={e => e.currentTarget.style.background = '#eaf1ff'}
                                                    onMouseLeave={e => e.currentTarget.style.background = '#f5f9ff'}
                                                  >
                                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#024C9C" strokeWidth="1.8" style={{ marginBottom: '6px' }}>
                                                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                                                      <polyline points="17 8 12 3 7 8"/>
                                                      <line x1="12" y1="3" x2="12" y2="15"/>
                                                    </svg>
                                                    <p style={{ margin: 0, fontSize: '13px', fontWeight: '500' }}>Click to upload files</p>
                                                    <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#666' }}>PDF, JPG, PNG, DOC, DOCX</p>
                                                  </div>

                                                  {/* File list */}
                                                  {followupFiles.length > 0 && (
                                                    <div className="attachmentListData" style={{ marginTop: '10px' }}>
                                                      <table style={{ width: '100%' }}>
                                                        <tbody>
                                                          {followupFiles.map((f, i) => {
                                                            const tempKey = f.name + '_' + f.size;
                                                            const status = fileUploadStatuses[tempKey];
                                                            return (
                                                              <tr key={i} className="uploadFilelistOpt">
                                                                <td style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
                                                                  <span style={{ fontSize: '18px' }}>
                                                                    {f.name.toLowerCase().endsWith('.pdf') ? '📄' : f.name.match(/\.(jpg|jpeg|png)$/i) ? '🖼️' : '📁'}
                                                                  </span>
                                                                  <span style={{ fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>{f.name}</span>
                                                                  {status === 'uploading' && <span style={{ fontSize: '10px', color: '#024C9C', whiteSpace: 'nowrap' }}>Uploading...</span>}
                                                                  {status === 'summarizing' && <span style={{ fontSize: '10px', color: '#fd7e14', whiteSpace: 'nowrap' }}>Summarizing...</span>}
                                                                  {status === 'done' && <span style={{ fontSize: '10px', color: '#28a745', whiteSpace: 'nowrap' }}>✓ Done</span>}
                                                                  {status === 'error' && <span style={{ fontSize: '10px', color: '#dc3545', whiteSpace: 'nowrap' }}>✗ Error</span>}
                                                                </td>
                                                                <td style={{ textAlign: 'right', paddingLeft: '8px' }}>
                                                                  <button type="button" className="attachmentDeleteBtn" onClick={() => setFollowupFiles(prev => prev.filter((_, idx) => idx !== i))} title="Remove file">
                                                                    <img src={Icons[0].deleteIcon} alt="Remove" />
                                                                  </button>
                                                                </td>
                                                              </tr>
                                                            );
                                                          })}
                                                        </tbody>
                                                      </table>
                                                      <div style={{ textAlign: 'right', marginTop: '6px' }}>
                                                        <span onClick={() => followupFileInputRef.current?.click()} style={{ fontSize: '12px', color: '#024C9C', cursor: 'pointer', textDecoration: 'underline' }}>+ Add more files</span>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              )}


                                              <div className="mt-2 mb-2">
                                                <span className="d-flex gap-4 datePickerDiv">
                                                  <span>
                                                    <label className="labelTxt">Date</label>
                                                    <DatePicker
                                                      //  selected={startDate}
                                                      selected={followupDate || new Date()}
                                                      // onChange={(date) => setStartDate(date)}
                                                      onChange={handleFollowDateChange}
                                                      isClearable
                                                      placeholderText="Select a date"
                                                      dateFormat="MMM dd, yyyy"
                                                      showDisabledMonthNavigation
                                                      minDate={new Date()} // restrict to current and future dates
                                                      className="inputStyle"
                                                      onKeyDown={(e) => e.preventDefault()}
                                                    />
                                                  </span>
                                                  <span>
                                                    <label className="labelTxt">Time</label>
                                                    <DatePicker
                                                      selected={followupTime}
                                                      onChange={handleFollowTimeChange}
                                                      showTimeSelect
                                                      showTimeSelectOnly
                                                      timeIntervals={45}
                                                      timeCaption="Time"
                                                      dateFormat="h:mm aa"
                                                      className="inputStyle inputTimeStyle"
                                                      // Restrict to future dates only
                                                      minDate={now}
                                                      // Conditional minTime based on whether today is selected
                                                      minTime={startTime && startTime.toDateString() === now.toDateString() ? now : new Date(0, 0, 0, 0, 0)}
                                                      maxTime={new Date(0, 0, 0, 23, 45)} // Allow up to end of the day

                                                    />
                                                  </span>
                                                </span>

                                              </div>

                                              {errors.followupDays && <div className="errorTxt" >{errors.followupDays}</div>}

                                              <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                                <button type="button" className="newBtn cancelBtn" onClick={handleCancelFollowup}>
                                                  Cancel
                                                </button>
                                                <button
                                                  className="newBtn"
                                                  type="submit"
                                                  style={{
                                                    cursor: loading ? 'not-allowed' : 'pointer',
                                                  }}
                                                >
                                                  {loading ? 'Saving...' : 'Save'}
                                                </button>
                                              </div>
                                            </>) : (<>

                                              <h2 style={{ fontSize: '16px' }} className="mb-2">Follow up Details </h2>
                                              {/* <div className="meetingDetailsTxt">
                                            <label className="labelTxt">Title</label>
                                            <b>{selectedItemFollowup?.title}</b>                      
                                        </div> 
                                        <div className="meetingDetailsTxt">
                                            <label className="labelTxt">Description</label>
                                            <b>{selectedItemFollowup?.description}</b>                      
                                        </div>  */}

                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Meeting ID</label>
                                                <b>{selectedItemFollowup?.zoom_meeting?.meeting_id}</b>
                                              </div>
                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Meeting Title</label>
                                                <b>{selectedItemFollowup?.zoom_meeting?.topic}</b>
                                              </div>

                                              <div className="meetingDetailsTxt">
                                                <label className="labelTxt">Date Time</label>
                                                <b>{selectedItemFollowup?.zoom_meeting?.start_time
                                                ? moment(selectedItemFollowup.zoom_meeting.start_time).format("MMM DD, YYYY - h:mm A")
                                                : selectedItemFollowup?.zoom_meeting?.start_ts
                                                  ? moment(typeof selectedItemFollowup.zoom_meeting.start_ts === 'number' ? selectedItemFollowup.zoom_meeting.start_ts * 1000 : selectedItemFollowup.zoom_meeting.start_ts).format("MMM DD, YYYY - h:mm A")
                                                  : 'N/A'}</b>
                                              </div>

                                              <div className="meetingDetailsTxt" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                {followupZoomMeet ? (
                                                  <>
                                                    <button type="button" onClick={handleButtonClickFollowZoomMeet}>Join Meeting</button>
                                                    <button
                                                      type="button"
                                                      disabled={isEndingMeeting}
                                                      onClick={() => handleEndMeeting(selectedItemFollowup?.zoom_meeting?.meeting_id)}
                                                      style={{ background: '#dc3545', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: '5px', cursor: isEndingMeeting ? 'not-allowed' : 'pointer', fontSize: '13px' }}
                                                    >
                                                      {isEndingMeeting ? 'Ending...' : 'End Meeting'}
                                                    </button>
                                                  </>
                                                ) : (
                                                  <>
                                                    <button className="" disabled={true}>Request in Progress</button>
                                                  </>
                                                )}
                                              </div>



                                            </>)

                                            }
                                          </div>
                                        </form>


                                      )}
                                    </li>
                                  </>
                                )}

                              </ul>
                            </div>
                          </div>
                          <div className="innerDivBox">
                            {FollowupData?.length > 0 ? (
                              FollowupData.map((item, index) =>
                                //   [...FollowupData]
                                // .sort((a, b) => new Date(b.created_on) - new Date(a.created_on)) // Sort by `created_on` in descending order
                                // .map((item, index) => 
                                item.followup_summary ? ( // Check if followup_summary exists
                                  <div key={index}>
                                    <div className="despInfoDiv">
                                      <div className="headDespInfoDiv">
                                        <ul className="infoDivPatientList">
                                          <li>
                                            <label>
                                              {`${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}
                                            </label>
                                            <b>{formatConsultationDate(item.created_on, item.created_at)}</b>
                                          </li>
                                          <li>
                                            <label>Follow up</label>
                                            <b>{item.topic}</b>
                                          </li>


                                          {calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts) ?
                                            (<>
                                              <li  >
                                                <label>Physician</label>
                                                <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                                              </li>
                                              <li  >
                                                <label>Patient </label>
                                                <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                                              </li>
                                              <li  >
                                                <label>Communication</label>
                                                <b>Audio & Video</b>
                                              </li>
                                              <li >
                                                <label>Duration</label>{" "}
                                                <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)} minutes</b>
                                              </li>
                                              <li >
                                                <label>Verbal consent </label>{" "}
                                                <b>Obtained</b>
                                              </li>


                                            </>
                                            ) : null}


                                        </ul>

                                        <a onClick={() => handleInputMainSummaryEditFollowup(item.followup_id, item.followup_summary)} style={{ marginLeft: '10px', cursor: 'pointer' }} className={ImageHide ? "editBtnNewSummary " : "editBtnNewSummary "}>
                                          Edit <img src={editMode === item.followup_id ? Icons[0].editIcon : Icons[0].editRed} /></a>

                                      </div>
                                    </div>
                                    {/* {!showSummaryEditFollowup ? ( */}
                                    {!editMode || editMode !== item.followup_id ? (
                                      <>
                                        <pre className="innerDivBoxPC h-auto">{item.followup_summary} </pre>
                                      </>
                                    ) : (
                                      <div className='textareaSummary  innerDivBox w-100' style={{ height: 'auto' }}>

                                        <div className='w-100 stepFirstForm editDurationDiv' >
                                          <div className="mt-0 inputDiv">
                                            <label className='labelTxt pr-0' style={{ width: "130px" }}>Duration</label>
                                            <input type="text"
                                              style={{ paddingLeft: "20px" }}
                                              //  placeholder="Duration" 
                                              // value={Editduration}
                                              value={index === 1
                                                ? EditdurationFollow1
                                                : index === 2
                                                  ? EditdurationFollow2
                                                  : EditdurationFollow3}
                                              onChange={index === 1
                                                ? handleDurationChangeFollow1
                                                : index === 2
                                                  ? handleDurationChangeFollow2
                                                  : handleDurationChangeFollow3}

                                            />
                                            <label>minutes</label>
                                          </div>
                                          {errorMessageNew && <span className="errorTxt" >{errorMessageNew}</span>}
                                        </div>

                                        <textarea
                                          value={editText}
                                          onChange={(e) => setEditText(e.target.value)}
                                          //  value={item.followup_summary}
                                          //  onChange={handleInputChangeSummaryEditFollowup}
                                          style={{ height: '200px', width: ' 100%' }} />
                                        <hr></hr>
                                        <div className='editSaveOpt' >
                                          {ShowLoaderSummaryFollowup ? (<>
                                            <button  > Loading
                                              <div className="spinner-border text-light" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            </button>
                                          </>) : (<>
                                            <button onClick={() => handleSaveSummaryEditFollowup(item?.followup_id, index)}>
                                              Save Changes
                                            </button>
                                          </>)

                                          }

                                          <button onClick={handleCancelClickSummaryEditFollowup}>Cancel</button>
                                        </div>
                                      </div>

                                    )}

                                    {/* Generate Followup Report Button */}
                                    {item.followup_summary && !hideClinicEdit && (
                                      <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        {!item.report_generated ? (
                                          <button
                                            className="selectedItemBtn newClickBtn"
                                            style={{ fontSize: '12px', padding: '5px 12px', width: 'auto' }}
                                            disabled={isGeneratingFollowupReport === (item.followup_id || item.id)}
                                            onClick={() => handleGenerateFollowupReport(item.followup_id || item.id)}
                                          >
                                            {isGeneratingFollowupReport === (item.followup_id || item.id) ? 'Generating Report...' : 'Generate Followup Report'}
                                          </button>
                                        ) : (
                                          <span style={{ fontSize: '12px', color: '#28a745', fontWeight: '600' }}>
                                            Report Generated (Version {item.report_version})
                                          </span>
                                        )}
                                      </div>
                                    )}

                                    {/* Uploaded Reports with AI Summaries */}
                                    {followupReportData[item.followup_id || item.id]?.length > 0 && (
                                      <div style={{ marginTop: '14px', marginBottom: '10px' }}>
                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
                                          Uploaded Medical Reports ({followupReportData[item.followup_id || item.id].length})
                                        </p>
                                        {followupReportData[item.followup_id || item.id].map((report, ri) => (
                                          <div key={ri} style={{ border: '1px solid #e0e8f0', borderRadius: '8px', padding: '10px 14px', marginBottom: '8px', background: '#f8fbff' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                              <span style={{ fontSize: '12px', fontWeight: '600', color: '#024C9C', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <span>{(report.file_name || '').match(/\.(jpg|jpeg|png)$/i) ? '🖼️' : '📄'}</span>
                                                {report.file_name || 'Report'}
                                              </span>
                                              {report.doc_url && (
                                                <a href={report.doc_url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#024C9C' }}>View File</a>
                                              )}
                                            </div>
                                            {report.doc_summary ? (
                                              <p style={{ fontSize: '12px', color: '#444', margin: 0, whiteSpace: 'pre-wrap', lineHeight: '1.5' }}>{report.doc_summary}</p>
                                            ) : (
                                              <p style={{ fontSize: '11px', color: '#999', margin: 0, fontStyle: 'italic' }}>AI summary pending...</p>
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                    <hr style={{ margin: '20px 0' }}></hr>
                                  </div>
                                ) : null // If followup_summary is null, render nothing
                              )
                            ) : null}

                            <div className="despInfoDiv">
                              <div className="headDespInfoDiv">
                                <ul className="infoDivPatientList">
                                  <li>
                                    <label>Consultation</label>
                                    <b> {formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
                                  </li>
                                  <li>
                                    <label>Illnesses</label>
                                    <b>{RecordData.illness}</b>
                                  </li>
                                  {meetingStatusZoom ?
                                    (<>
                                      <li  >
                                        <label>Physician</label>
                                        <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                                      </li>
                                      <li  >
                                        <label>Patient </label>
                                        <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                                      </li>
                                      <li  >
                                        <label>Communication</label>
                                        <b>Audio & Video</b>
                                      </li>
                                      <li >
                                        <label>Duration</label>{" "}
                                        <b>
                                          {FCdurationTxt} minutes
                                          {/* {calculateDuration(selectedZoomMeet.start_ts, selectedZoomMeet.end_ts)}   */}
                                        </b>
                                      </li>


                                      <li >
                                        <label>Verbal consent </label>{" "}
                                        <b>Obtained</b>
                                      </li>

                                    </>
                                    ) : null}





                                </ul>
                                {!hideClinicEdit ? (<>

                                  <a onClick={() => handleInputMainSummaryEditAIChatbot(followSummaryEditAIChatbot || RecordData.chatbot_summary)} style={{ marginLeft: '10px', cursor: 'pointer' }} className={ImageHide ? "editBtnNewSummary " : "editBtnNewSummary "}>
                                    Edit <img src={!showSummaryEditAIChatbot ? Icons[0].editIcon : Icons[0].editRed} /></a> </>) : ('')}

                              </div>
                            </div>
                            {/* {FollowupData.followup_summary ? <p className="innerDivBox">{FollowupData.followup_summary} </p> :  <p className="innerDivBox"> - </p> } */}
                            {!showSummaryEditAIChatbot ? (
                              <>
                                {EmergencyQuest ?
                                  <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p>
                                  :
                                  followSummaryEditAIChatbot ? (
                                    <>
                                      <div className="innerDivBoxPC h-auto">{renderAISummary(followSummaryEditAIChatbot)}</div>
                                      {PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name ? (
                                        <>
                                          <b>Primary Care Physician (PCP): </b>
                                          {PCP_Pharmacy.pcp.name}{PCP_Pharmacy.pcp.address ? ', ' + PCP_Pharmacy.pcp.address : ''}
                                          {PCP_Pharmacy.pcp.phone ? <span> | Phone: {PCP_Pharmacy.pcp.phone}</span> : null}
                                          {PCP_Pharmacy.pcp.fax ? <span> | Fax: {PCP_Pharmacy.pcp.fax}</span> : null}
                                          <br />
                                        </>
                                      ) : null}
                                      {PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name ? (
                                        <>
                                          <b>Pharmacy information: </b>
                                          {PCP_Pharmacy.pharmacy.name}{PCP_Pharmacy.pharmacy.address ? ', ' + PCP_Pharmacy.pharmacy.address : ''}
                                          {PCP_Pharmacy.pharmacy.phone ? <span> | Phone: {PCP_Pharmacy.pharmacy.phone}</span> : null}
                                          {PCP_Pharmacy.pharmacy.fax ? <span> | Fax: {PCP_Pharmacy.pharmacy.fax}</span> : null}
                                        </>
                                      ) : null}
                                    </>
                                  ) : (
                                    <div className="innerDivBoxPC" style={{ textAlign: 'center', padding: '20px' }}>
                                      {isRegeneratingAI ? (
                                        <>
                                          <div className="spinner-border text-primary" role="status" style={{ width: '20px', height: '20px', margin: '8px auto' }}>
                                            <span className="visually-hidden">Loading...</span>
                                          </div>
                                          <p style={{ color: '#666', marginTop: '8px', fontSize: '13px' }}>Generating AI summary...</p>
                                        </>
                                      ) : (
                                        <p style={{ color: '#999' }}>No summary available</p>
                                      )}
                                    </div>
                                  )
                                }
                              </>
                            ) : (
                              <div className='textareaSummary innerDivBox w-100' style={{ height: 'auto' }}>
                                <div className='w-100 stepFirstForm editDurationDiv' >
                                  <div className="mt-0 inputDiv">
                                    <label className='labelTxt pr-0' style={{ width: "130px" }}>Duration</label>
                                    <input type="text"
                                      style={{ paddingLeft: "20px" }}
                                      //  placeholder="Duration" 
                                      value={Editduration}
                                      onChange={handleDurationChange}
                                    />
                                    <label>minutes</label>
                                  </div>
                                  {errorMessageNew && <span className="errorTxt" >{errorMessageNew}</span>}
                                </div>
                                <textarea value={followSummaryEditAIChatbot} onChange={handleInputChangeSummaryEditAIChatbot} style={{ height: '200px', width: ' 100%' }} />
                                <hr></hr>
                                <div className='editSaveOpt' >
                                  {ShowLoaderSummaryAIChatbot ? (<>
                                    <button  > Loading
                                      <div className="spinner-border text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </button>
                                  </>) : (<>
                                    <button onClick={() => handleSaveSummaryEditAIChatbot()}>
                                      Save Changes
                                    </button>
                                  </>)

                                  }

                                  <button onClick={handleCancelClickSummaryEditAIChatbot}>Cancel</button>
                                </div>
                              </div>

                            )}

                          </div>





                        </div>
                        <div className={`tab-pane fade ${activeTab === 1 ? 'active show' : ''}`} id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                          <div className="d-block gap-4">

                            <div className="despInfoDiv PlanCareTab w-100 overflow-auto h-auto p-0 mb-2" ref={scrollupRef} style={{ borderRadius: '0', marginTop: '0px', border: '0px' }}>
                              {/* <div ></div> {/* The scroll-up target */}
                              {EmergencyQuest ? (<>
                                <div className="p-3">
                                  <h2>Differential Diagnosis</h2> <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} />
                                    Urgent: Patient has called for emergency assistance.</p> </div>
                              </>)

                                : (<>
                                  <div className="accordion" id="accordionExampleNew">
                                    {FollowupData?.length > 0 &&
                                      FollowupData.map((item, index) =>
                                        item.followup_CD ? (
                                          <AccordionSection
                                            key={index}
                                            setData={FollowupData}
                                            title={`Follow up - Differential Diagnosis`}
                                            content={followConditionalDiagnosis || item?.followup_CD}
                                            onEditClick={() => handleInputMainPointFollowCD(item?.followup_id, item?.followup_CD, index + 1)}
                                            onSaveClick={() => handleSaveClickMPointFollowCD(item?.followup_id, index + 1)}
                                            onCancelClick={handleCancelClickMPointFollowCD}
                                            showLoader={ShowLoader}
                                            isEditing={showMainPointFollowCD}
                                            // isEditing={editingAccordion === item?.followup_id}
                                            // value={updatedContent+index+1}
                                            // onChange={(e) => setUpdatedContent+index+1(e.target.value)}
                                            value={followConditionalDiagnosis}
                                            onChange={(e) => setFollowConditionalDiagnosis(e.target.value)}

                                            EmergencyQuest={hideClinicEdit}
                                            Icons={Icons}
                                            onAccordionClick={handleAccordionClick} // Pass the scroll handler

                                            isActive={activeAccordion === `Follow up - Differential Diagnosis`}
                                            // setActiveAccordion={setActiveAccordion}
                                            setActiveAccordion={() =>
                                              handleAccordionToggle(`Follow up - Differential Diagnosis`)
                                            }

                                          // setActive={setActive} // Set the active accordion
                                          // active={active === 'Follow_up_Details'} // Check if the section is active

                                          />
                                        ) : null
                                      )}

                                    <AccordionSection
                                      title="Differential Diagnosis"
                                      content={ConditionalDiagnosis || ''}
                                      onEditClick={handleInputMainPointCD}
                                      onSaveClick={handleSaveClickMPointCD}
                                      onCancelClick={handleCancelClickMPointCD}
                                      showLoader={ShowLoader}
                                      isEditing={showMainPointCD}
                                      value={ConditionalDiagnosis}
                                      onChange={(e) => setConditionalDiagnosis(e.target.value)}
                                      EmergencyQuest={hideClinicEdit}
                                      Icons={Icons}
                                      onAccordionClick={handleAccordionClick} // Pass the scroll handler
                                      isActive={activeAccordion === 'Differential Diagnosis'}
                                      setActiveAccordion={() => handleAccordionToggle('Differential Diagnosis')}
                                    />
                                  </div>
                                </>)
                              }


                            </div>
                            <div className="despInfoDiv PlanCareTab w-100 overflow-auto h-auto p-0" style={{ borderRadius: '0', marginTop: '0px', border: '0px' }}>

                              {EmergencyQuest ? (<>
                                <div className="p-3">
                                  <h2>Differential Diagnosis</h2> <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} />
                                    Urgent: Patient has called for emergency assistance.</p> </div>
                              </>)

                                : (<>
                                  <div className="accordion" id="accordionExample">
                                    {FollowupData?.length > 0 &&
                                      FollowupData.map((item, index) =>
                                        item.followup_CD ? (
                                          <AccordionSectionPoC
                                            key={index}
                                            title={`Follow up - Plan of Care`}
                                            content={followPlanOnCareData || item?.followup_PoC}
                                            onEditClick={() => handleInputMainPointFollowPoC(followPlanOnCareData || item?.followup_PoC)}
                                            onSaveClick={() => handleSaveClickMPointFollowPoC(item?.followup_id)}
                                            onCancelClick={handleCancelClickMPointFollowPoC}
                                            showLoader={ShowLoader}
                                            isEditing={showMainPointFollowPoC}
                                            value={followPlanOnCareData}
                                            onChange={(e) => setFollowPlanOnCareData(e.target.value)}
                                            EmergencyQuest={hideClinicEdit}
                                            Icons={Icons}
                                            onAccordionClick={handleAccordionClickPoc} // Pass the scroll handler
                                            isActive={activeAccordionPoc === 'Follow up - Plan of Care'}
                                            setActiveAccordionPoc={() => handleAccordionTogglePoc('Follow up - Plan of Care')}
                                          // setActive={setActive} // Set the active accordion
                                          // active={active === 'Follow_up_Details'} // Check if the section is active

                                          />
                                        ) : null
                                      )}


                                    {/* <AccordionSectionPoC
                            title="Plan of Care - Online"
                            content={zoomPoC || ''}
                            onEditClick={handleInputMainPoint}
                            onSaveClick={handleSaveClickMPoint}
                            onCancelClick={handleCancelClickMPoint}
                            showLoader={ShowLoader}
                            isEditing={showMainPoint}
                            value={zoomPoC}
                            onChange={(e) => setPlanOnCareData(e.target.value)}
                            EmergencyQuest={hideClinicEdit}
                            Icons={Icons}
                            onAccordionClick={handleAccordionClickPoc} // Pass the scroll handler
                            isActive={activeAccordionPoc === 'Plan of Care - Online'} 
                            setActiveAccordionPoc={() => handleAccordionTogglePoc('Plan of Care - Online')}
                            // setActive={setActive} // Set the active accordion
                            // active={active === 'Differential_Diagnosis'} // Check if the section is active
                            /> */}

                                    <AccordionSectionPoC
                                      title="Plan of Care"
                                      content={PlanOnCareData || ''}
                                      onEditClick={handleInputMainPoint}
                                      onSaveClick={handleSaveClickMPoint}
                                      onCancelClick={handleCancelClickMPoint}
                                      showLoader={ShowLoader}
                                      isEditing={showMainPoint}
                                      value={PlanOnCareData}
                                      onChange={(e) => setPlanOnCareData(e.target.value)}
                                      EmergencyQuest={hideClinicEdit}
                                      Icons={Icons}
                                      onAccordionClick={handleAccordionClickPoc} // Pass the scroll handler
                                      isActive={activeAccordionPoc === 'Plan of Care'}
                                      setActiveAccordionPoc={() => handleAccordionTogglePoc('Plan of Care')}
                                    // setActive={setActive} // Set the active accordion
                                    // active={active === 'Differential_Diagnosis'} // Check if the section is active
                                    />
                                  </div>
                                </>)
                              }

                              {/* {FollowupData?.length > 0 ? (
                          FollowupData.map((item, index) => 
                            item.followup_PoC ? ( 
                              <div key={index}>
                                <h2>Follow up - Plan of Care
                                      {!hideClinicEdit ? ( <a onClick={() => handleInputMainPointFollowPoC(followPlanOnCareData || item?.followup_PoC)} style={{marginLeft:'10px', cursor:'pointer'}}  className={ImageHide ? "editBtnNew " : "editBtnNew "}> Edit <img src={!showMainPointFollowPoC ? Icons[0].editIcon : Icons[0].editRed } /></a>) :  ('')}
                              
                                </h2>
                            
                                {!showMainPointFollowPoC ? (
                                    <>     
                                      <pre className="innerDivBoxPC h-auto overflow-hidden">
                                        {followPlanOnCareData || item.followup_PoC}
                                      </pre>
                                    </>
                                ) :(
                                  <div className='textareaSummary innerDivBox w-100'>
                                    <textarea value={followPlanOnCareData} onChange={handleInputChangeMPointFollowPoC} style={{    height: '80%', width:' 100%'}} /> 
                                    <hr></hr>
                                  <div className='editSaveOpt' >
                                      {ShowLoader ? (<>
                                        <button  > Loading
                                        <div className="spinner-border text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div> 
                                      </button>
                                      </>):(<>
                                        <button  onClick={() => handleSaveClickMPointFollowPoC(item?.followup_id)}>  
                                      Save Changes
                                      </button>
                                      </>)

                                      }
                                      
                                      <button onClick={handleCancelClickMPointFollowPoC}>Cancel</button>
                                    </div>
                                  </div> 

                                )}

                                    
                                <hr />
                              </div>
                            ) : null // If followup_PoC is empty or null, render nothing
                          )
                        ) : null}


                            <h2>Plan of Care
                            {!hideClinicEdit ? ( <a onClick={handleInputMainPoint} style={{marginLeft:'10px', cursor:'pointer'}}  className={ImageHide ? "editBtnNew " : "editBtnNew "}> Edit <img src={!showMainPoint ? Icons[0].editIcon : Icons[0].editRed } /></a>) :  ('')}
                            </h2>
                            { FollowupData.followup_PoC ? <pre className="innerDivBoxPC h-auto overflow-hidden">{FollowupData.followup_PoC}</pre> : '' }          
                          
                            {!showMainPoint ? (
                                    <>     
                                    {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : PlanOnCareData ? <pre className="innerDivBoxPC h-auto  overflow-hidden">{PlanOnCareData}</pre> : 'No Plan On Care' }  
                                  </>
                                ) :(
                                  <div className='textareaSummary innerDivBox w-100'>
                                    <textarea value={PlanOnCareData} onChange={handleInputChangeMPoint} style={{    height: '80%', width:' 100%'}} /> 
                                    <hr></hr>
                                  <div className='editSaveOpt' >
                                      {ShowLoader ? (<>
                                        <button  > Loading
                                        <div className="spinner-border text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div> 
                                      </button>
                                      </>):(<>
                                        <button onClick={handleSaveClickMPoint}>  
                                      Save Changes
                                      </button>
                                      </>)

                                      }
                                      
                                      <button onClick={handleCancelClickMPoint}>Cancel</button>
                                    </div>
                                  </div> 

                                )} */}
                            </div>

                          </div>
                        </div>
                        <div className={`tab-pane fade ${activeTab === 2 ? 'active show' : ''}`} id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                          <div className="despInfoDiv">
                            <h2>Presenting Symptoms   </h2>
                          </div>
                          <div className="chatbotConversation  pb-0">
                            <div className="messageListBox mb-0">
                              {answerLoader ? (
                                <>
                                  <div className="quesListDiv " >
                                    <div className={"chatbot aiQuest "}>
                                      <span className="imgBox">
                                        <img src={Icons[0].chatbot} alt="Chatbot" />
                                      </span>
                                      <span>
                                        <div className="showLoaderDot">
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                        </div>
                                      </span>
                                    </div>
                                  </div>
                                </>) : (<>

                                  <div className="chatbot">
                                    <span className="imgBox">
                                      <img src={Icons[0].chatbot} alt="Chatbot" />
                                    </span>
                                    <span>
                                      <b className="AI_dateTime">
                                        AI
                                      </b>
                                      <label className="quesTxt">Hi, How may I help you today? You may select or type a symptom you’re facing currently.</label>
                                      <div className="questOpt">
                                        <b>Please select any</b>
                                        <ul className={!selectedIllness ? 'illnessesListOpt' : 'illnessesListOpt selected'}>
                                          {illnessesList?.map((item, index) => (
                                            <li
                                              key={index}
                                              className={selectedIllness === item ? 'active' : 'disabled'}
                                              style={{ pointerEvents: selectedIllness && selectedIllness !== item ? 'none' : 'auto' }}
                                            >
                                              <b>{item}</b>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>

                                    </span>
                                  </div>

                                  {ChatHistory.length > 0 && (
                                    <div className="quesListDiv">
                                      {ChatHistory.map((q, index) => (
                                        <div key={index}>
                                          <div className="chatbot aiQuest">
                                            <span className="imgBox">
                                              <img src={Icons[0].chatbot} alt="Chatbot" />
                                            </span>
                                            <span>
                                              <b className="AI_dateTime">
                                                AI
                                              </b>
                                              <label className="quesTxt">{q.question}</label>

                                            </span>
                                          </div>
                                          {q.answer && (
                                            <div className="chatbot userReply">
                                              <span className="imgBox">
                                                <b>{fullName.split(' ').map(word => word.charAt(0).toUpperCase()).join('')}</b>

                                              </span>
                                              <span>
                                                <b className="AI_dateTime">
                                                  YOU
                                                </b>
                                                <label className="quesTxt">{q.answer}</label>
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                </>)}


                            </div>
                          </div>

                        </div>
                        <div className={`tab-pane fade ${activeTab === 3 ? 'active show' : ''}`} id="nav-reportData" role="tabpanel" aria-labelledby="nav-reportData-tab">
                          <div className="despInfoDiv">
                            <h2>Reports </h2>
                          </div>
                          <div className="innerDivBoxPC">


                            <ol className="reportListOptLink" style={{ fontSize: '16px' }}>
                              {sortedGroupedDocuments.length > 0 ? (
                                sortedGroupedDocuments
                                  .filter(({ documents }) => documents && documents.length > 0) // Filter out empty or null documents
                                  .map(({ doc_type, documents, Name }) => (
                                    <li key={doc_type}>

                                      {documents.map((doc, index) => (
                                        <div key={doc.doc_id} style={{ marginBottom: "0px" }}>
                                          <b style={{ textTransform: "capitalize", textDecoration: "none" }} className={doc_type === "other_report" && index !== 0 && 'd-none'}>
                                            {Name}
                                            {/* {doc_type.replace('_', ' ')} */}
                                          </b>
                                          {/* Document URL with conditional button */}
                                          {doc.doc_url && (
                                            <span
                                              className={
                                                "pdfButtonModal" + (doc_type === "other_report" ? " d-none" : "")
                                              }
                                            >
                                              <button
                                                className="pdfButton pdfViewBtn"
                                                onClick={() => openModal(doc?.doc_url)}
                                              >
                                                View{" "}
                                                <img
                                                  src={Icons[0].viewPDF}
                                                  alt="PDF Icon"
                                                  style={{ width: "24px", marginLeft: "10px" }}
                                                />
                                              </button>
                                            </span>
                                          )}

                                          {/* Document Text */}
                                          {/* Document Text */}
                                          {doc.doc_text && (
                                            <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_text}</p>
                                          )}
                                          {/* PCP / Pharmacy — show doc_summary directly */}
                                          {(doc_type === "pcp" || doc_type === "pharmacy") && doc.doc_summary && (
                                            <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_summary}</p>
                                          )}

                                          {/* Document Summary — only for other_report (uploaded PDFs) */}
                                          {doc_type === "other_report" && (
                                            <div className={"d-flex justify-content-between align-items-center " + (doc.doc_summary && doc.doc_summary.length === 4 && doc.doc_summary === "None" ? 'd-none' : null)}>
                                              <h3
                                                style={{
                                                  fontSize: "16px",
                                                  marginTop: "14px",
                                                  fontWeight: "600",
                                                }}
                                                className="my-0"
                                              >
                                                {index + 1}. Other Report Summary
                                              </h3>
                                              {doc.doc_url && (
                                                <span className="pdfButtonModal">
                                                  <button
                                                    className="pdfButton pdfViewBtn"
                                                    onClick={() => openModal(doc?.doc_url)}
                                                  >
                                                    View{" "}
                                                    <img
                                                      src={Icons[0].viewPDF}
                                                      alt="PDF Icon"
                                                      style={{ width: "24px", marginLeft: "10px" }}
                                                    />
                                                  </button>
                                                </span>
                                              )}
                                            </div>
                                          )}
                                          {doc_type === "other_report" && doc.doc_summary && doc.doc_summary !== "None" && (
                                            <pre style={{ margin: "5px 0", textTransform: "capitalize" }}>
                                              {doc.doc_summary}
                                            </pre>
                                          )}

                                          {/* Conditional Divider */}
                                          {doc.doc_url && (
                                            <hr className={doc_type !== "other_report" ? " d-none" : ""} />
                                          )}
                                        </div>
                                      ))}
                                    </li>
                                  ))
                              ) : (
                                <p style={{ textAlign: "center" }}>No reports found</p>
                              )}
                            </ol>



                          </div>

                        </div>

                        {/* Tab 4: Telehealth Consultation */}
                        <div className={`tab-pane fade ${activeTab === 4 ? 'active show' : ''}`} id="nav-zoom" role="tabpanel" aria-labelledby="nav-zoom-tab">
                          <div className="despInfoDiv">
                            <h2>Telehealth Consultation</h2>
                          </div>
                          <div className="innerDivBoxPC h-auto">
                            {(editZoomSummary || zoomHPI) ? (
                              <div>
                                {zoomHPI ? (
                                  <>
                                    <div style={{ marginBottom: '16px' }}>
                                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>History of Present Illness (HPI)</h3>
                                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomHPI)}</div>
                                    </div>
                                    {zoomPMH && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Past Medical History (PMH)</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomPMH)}</div>
                                      </div>
                                    )}
                                    {zoomMedications && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Medications</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomMedications)}</div>
                                      </div>
                                    )}
                                    {zoomAllergies && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Allergies</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomAllergies)}</div>
                                      </div>
                                    )}
                                    {zoomSocialHistory && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Social History</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomSocialHistory)}</div>
                                      </div>
                                    )}
                                    {zoomROS && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Review of Systems</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomROS)}</div>
                                      </div>
                                    )}
                                    {zoomCD && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomCD)}</div>
                                      </div>
                                    )}
                                    {zoomPoC && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomPoC)}</div>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div style={{ fontSize: '14px', lineHeight: '1.7', marginBottom: '16px' }}>{renderAISummary(editZoomSummary)}</div>
                                    {zoomCD && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomCD)}</div>
                                      </div>
                                    )}
                                    {zoomPoC && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(zoomPoC)}</div>
                                      </div>
                                    )}
                                  </>
                                )}
                                {selectedZoomMeet?.meeting_id && (
                                  <p style={{ fontSize: '12px', color: '#aaa', marginTop: '16px' }}>Meeting ID: {selectedZoomMeet.meeting_id} &nbsp;|&nbsp; {selectedZoomMeet.start_time ? moment(selectedZoomMeet.start_time).format('MMM DD, YYYY h:mm A') : ''}</p>
                                )}
                              </div>
                            ) : (
                              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#888' }}>
                                <p style={{ fontSize: '15px', marginBottom: '8px' }}>Telehealth summary is being processed by Zoom.</p>
                                <p style={{ fontSize: '13px', marginBottom: '16px' }}>Please wait a few minutes for the recording to be ready, then click Retry.</p>
                                {!hideClinicEdit && !isGeneratingFinalNote && (
                                  <button
                                    onClick={handleRetryTelehealthSummary}
                                    style={{ padding: '8px 20px', background: '#024C9C', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                                  >
                                    Retry — Fetch Telehealth Summary
                                  </button>
                                )}
                                {isGeneratingFinalNote && (
                                  <p style={{ fontSize: '13px', color: '#024C9C', marginTop: '8px' }}>Fetching telehealth summary and generating Final Note...</p>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Tab 5: Final Consultant Note */}
                        <div className={`tab-pane fade ${activeTab === 5 ? 'active show' : ''}`} id="nav-finalnote" role="tabpanel" aria-labelledby="nav-finalnote-tab">
                          <div className="despInfoDiv position-relative d-flex" style={{ height: '50px', alignItems: 'center' }}>
                            <h2 className="finalReportH2Tag" style={{ margin: 0, whiteSpace: 'nowrap' }}>Final Consultant Note<ViewOnlyBadge /></h2>
                            <div className="headDespInfoDiv position-absolute top-0 end-0" style={{ display: 'flex', alignItems: 'center', gap: '8px', height: '100%' }}>
                              {isEditingFinalNote && !hideClinicEdit && !selectedReportVersion ? (
                                <>
                                  <a onClick={handleSaveFinalNote} style={{ cursor: 'pointer', width: 'auto', padding: '0 10px' }} className="editBtnNewSummary">Save</a>
                                  <a onClick={handleCancelEditFinalNote} style={{ cursor: 'pointer', width: 'auto', padding: '0 10px', background: '#6c757d' }} className="editBtnNewSummary">Cancel</a>
                                </>
                              ) : (finalConsultantNote || finalConsultantHPI) && !selectedReportVersion && (
                                <>
                                  {!hideClinicEdit && !effectiveSubmitted && (
                                    <a onClick={() => setShowFinalNoteFileModal(true)} style={{ cursor: 'pointer', width: 'auto', padding: '0 10px' }} className="editBtnNewSummary">
                                      + Assessment & Plan
                                    </a>
                                  )}
                                  {!hideClinicEdit && !effectiveSubmitted && (
                                    <a onClick={handleEditFinalNote} style={{ cursor: 'pointer' }} className="editBtnNewSummary">
                                      Edit <img src={Icons[0].editIcon} />
                                    </a>
                                  )}
                                  <a onClick={copyFinalNoteAsText} style={{ cursor: 'pointer', width: 'auto', padding: '0 10px', background: '#17a2b8' }} className="editBtnNewSummary">
                                    Copy for EMR
                                  </a>
                                  <a onClick={!isGeneratingPdf ? downloadFinalNotePdf : undefined} style={{ cursor: isGeneratingPdf ? 'not-allowed' : 'pointer', width: 'auto', padding: '0 10px', opacity: isGeneratingPdf ? 0.6 : 1 }} className="editBtnNewSummary">
                                    {isGeneratingPdf ? 'Generating...' : 'Download PDF'}
                                  </a>
                                  {!effectiveSubmitted && !hideClinicEdit ? (
                                    <a onClick={!isSubmittingFinalNote ? handleSubmitFinalNote : undefined} style={{ cursor: isSubmittingFinalNote ? 'not-allowed' : 'pointer', width: 'auto', padding: '0 10px', background: '#28a745', opacity: isSubmittingFinalNote ? 0.6 : 1 }} className="editBtnNewSummary">
                                      {isSubmittingFinalNote ? 'Submitting...' : 'Submit'}
                                    </a>
                                  ) : effectiveSubmitted ? (
                                    <span style={{ fontSize: '12px', color: '#28a745', fontWeight: '600', padding: '0 8px' }}>Submitted</span>
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>

                          {/* Version History Bar — shown whenever there are multiple report versions */}
                          {reportHistory.length > 1 && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '8px 0 12px 0', padding: '8px 14px', background: '#f0f4f8', borderRadius: '6px', border: '1px solid #d0d7e2', flexWrap: 'wrap' }}>
                              <span style={{ fontSize: '12px', color: '#4a6fa5', fontWeight: '700', whiteSpace: 'nowrap' }}>Report Version:</span>
                              <select
                                value={selectedReportVersion || ''}
                                onChange={(e) => handleViewReportVersion(e.target.value || null)}
                                style={{ flex: 1, minWidth: '220px', maxWidth: '420px', fontSize: '12px', padding: '5px 8px', borderRadius: '4px', border: '1px solid #b0c0d8', background: '#fff', cursor: 'pointer' }}
                              >
                                <option value="">Latest (Current)</option>
                                {reportHistory.map(h => (
                                  <option key={h.version} value={h.version}>
                                    V{h.version} — {h.report_type === 'initial' ? 'Initial Report' : `Followup: ${h.followup_topic || 'Consultation'}`}
                                    {h.final_consultant_generated_at ? ` · ${moment(h.final_consultant_generated_at).format('MMM DD, YYYY')}` : ''}
                                  </option>
                                ))}
                              </select>
                              <span style={{ fontSize: '11px', color: '#888' }}>({reportHistory.length} versions)</span>
                              {selectedReportVersion && (
                                <a onClick={() => handleViewReportVersion(null)} style={{ cursor: 'pointer', fontSize: '12px', color: '#024C9C', fontWeight: '600', textDecoration: 'underline', whiteSpace: 'nowrap', marginLeft: 'auto' }}>
                                  Back to Latest
                                </a>
                              )}
                            </div>
                          )}
                          {/* Read-only notice when viewing historical version */}
                          {selectedReportVersion && (
                            <div style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '6px', padding: '6px 14px', marginBottom: '10px', fontSize: '12px', color: '#856404', fontWeight: '600' }}>
                              Viewing Version {selectedReportVersion} of {reportHistory.length}
                              {reportHistory.find(h => h.version === selectedReportVersion)?.report_type === 'followup'
                                ? ` (Followup: ${reportHistory.find(h => h.version === selectedReportVersion)?.followup_topic || ''})`
                                : ' (Initial Report)'}
                              {' '}— Read Only
                            </div>
                          )}

                          {isEditingFinalNote && !hideClinicEdit ? (
                            <div className="innerDivBoxPC" style={{ padding: '12px' }}>
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>History of Present Illness (HPI):</label>
                              <textarea value={editFinalHPI} onChange={(e) => setEditFinalHPI(e.target.value)}
                                style={{ width: '100%', height: '160px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Past Medical History (PMH):</label>
                              <textarea value={editFinalPMH} onChange={(e) => setEditFinalPMH(e.target.value)}
                                style={{ width: '100%', height: '120px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Current Medications <span style={{ fontWeight: '400', fontSize: '12px', color: '#888' }}>(patient's existing medications)</span>:</label>
                              <textarea value={editFinalMedications} onChange={(e) => setEditFinalMedications(e.target.value)}
                                style={{ width: '100%', height: '100px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Prescribed Medications <span style={{ fontWeight: '400', fontSize: '12px', color: '#888' }}>(doctor prescribed)</span>:</label>
                              <textarea value={editFinalPrescribedMedications} onChange={(e) => setEditFinalPrescribedMedications(e.target.value)}
                                style={{ width: '100%', height: '80px', marginBottom: '8px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              {/* Prescribed Medication Autosuggest */}
                              <div style={{ background: '#f0f4f8', border: '1px solid #d0d7e2', borderRadius: '8px', padding: '10px 12px', marginBottom: '12px' }}>
                                <div style={{ fontSize: '12px', fontWeight: '600', color: '#4a6fa5', marginBottom: '8px' }}>Search & Add Prescribed Medication</div>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', marginBottom: '8px' }}>
                                  <div style={{ position: 'relative', flex: 2, minWidth: 0 }}>
                                    <input
                                      type="text"
                                      value={medSearchText}
                                      onChange={(e) => handleMedSearch(e.target.value)}
                                      placeholder="Type medication name (min 3 chars)..."
                                      style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #d0d7e2', borderRadius: '6px', fontSize: '13px', fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }}
                                      autoComplete="off"
                                    />
                                    {medSuggestions.length > 0 && (
                                      <ul style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #d0d7e2', borderRadius: '6px', zIndex: 999, listStyle: 'none', margin: '2px 0 0', padding: '4px 0', maxHeight: '180px', overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                        {medSuggestions.map((name, idx) => (
                                          <li key={idx} onClick={() => handleMedSelect(name)}
                                            style={{ padding: '7px 12px', cursor: 'pointer', fontSize: '13px', color: '#222' }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#e8f0fe'}
                                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                            {name}
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </div>
                                  {selectedMedName && medDoseOptions.length > 0 ? (
                                    <select value={selectedMedDose} onChange={(e) => setSelectedMedDose(e.target.value)}
                                      style={{ flex: 1, minWidth: '120px', padding: '7px 8px', border: '1.5px solid #d0d7e2', borderRadius: '6px', fontSize: '13px', background: '#fff', boxSizing: 'border-box' }}>
                                      <option value="">Dose</option>
                                      {medDoseOptions.map((dose, idx) => (
                                        <option key={idx} value={dose}>{dose}</option>
                                      ))}
                                    </select>
                                  ) : (
                                    <input type="text" value={selectedMedDose} onChange={(e) => setSelectedMedDose(e.target.value)}
                                      placeholder="Dose (e.g. 10mg)"
                                      style={{ flex: 1, minWidth: '100px', padding: '7px 8px', border: '1.5px solid #d0d7e2', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
                                  )}
                                  <select value={selectedMedFrequency} onChange={(e) => setSelectedMedFrequency(e.target.value)}
                                    style={{ flex: 1, minWidth: '120px', padding: '7px 8px', border: '1.5px solid #d0d7e2', borderRadius: '6px', fontSize: '13px', background: '#fff', boxSizing: 'border-box' }}>
                                    <option value="">Frequency</option>
                                    <option value="Once daily">Once daily</option>
                                    <option value="Twice daily">Twice daily</option>
                                    <option value="3 times a day">3 times a day</option>
                                    <option value="4 times a day">4 times a day</option>
                                    <option value="Every morning">Every morning</option>
                                    <option value="Every night">Every night</option>
                                    <option value="Every 6 hours">Every 6 hours</option>
                                    <option value="Every 8 hours">Every 8 hours</option>
                                    <option value="Every 12 hours">Every 12 hours</option>
                                    <option value="As needed">As needed</option>
                                    <option value="Weekly">Weekly</option>
                                  </select>
                                </div>
                                <button onClick={handleAddMedToNote} disabled={!selectedMedName}
                                  style={{ padding: '6px 16px', background: selectedMedName ? '#024C9C' : '#b0c4de', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: selectedMedName ? 'pointer' : 'not-allowed' }}>
                                  + Add Prescribed Medication
                                </button>
                              </div>
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Allergies:</label>
                              <textarea value={editFinalAllergies} onChange={(e) => setEditFinalAllergies(e.target.value)}
                                style={{ width: '100%', height: '80px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Social History:</label>
                              <textarea value={editFinalSocialHistory} onChange={(e) => setEditFinalSocialHistory(e.target.value)}
                                style={{ width: '100%', height: '80px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Review of Systems:</label>
                              <textarea value={editFinalROS} onChange={(e) => setEditFinalROS(e.target.value)}
                                style={{ width: '100%', height: '100px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Assessment & Differential Diagnosis:</label>
                              <textarea value={editFinalNote} onChange={(e) => setEditFinalNote(e.target.value)}
                                style={{ width: '100%', height: '200px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                              <label style={{ fontWeight: '600', marginBottom: '4px', display: 'block' }}>Plan of Care:</label>
                              <textarea value={editFinalPlan} onChange={(e) => setEditFinalPlan(e.target.value)}
                                style={{ width: '100%', height: '150px', marginBottom: '12px', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontFamily: 'inherit', fontSize: '13px' }} />
                            </div>
                          ) : (
                            <div className="innerDivBoxPC h-auto">
                              <div ref={finalNoteContentRef}>

                                {/* ── Issue 4: Provider / PCP / Pharmacy Header Block ── */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', marginBottom: '16px', overflow: 'hidden', fontSize: '12px' }}>
                                  <div style={{ padding: '12px 14px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f4f8' }}>
                                    <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Provider</div>
                                    {reportProviderName ? <div style={{ fontWeight: '700', marginBottom: '3px' }}>{reportProviderName}</div> : null}
                                    {reportProviderSpecialty ? <div style={{ color: '#555', marginBottom: '2px' }}>{reportProviderSpecialty}</div> : null}
                                    {reportProviderPhone ? <div style={{ color: '#555' }}>Phone: {reportProviderPhone}</div> : null}
                                  </div>
                                  <div style={{ padding: '12px 14px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                                    <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Primary Care Physician</div>
                                    {PCP_Pharmacy?.pcp?.name
                                      ? <><div style={{ fontWeight: '700', marginBottom: '3px' }}>{PCP_Pharmacy.pcp.name}</div>{PCP_Pharmacy.pcp.address ? <div style={{ color: '#555', marginBottom: '2px' }}>{PCP_Pharmacy.pcp.address}</div> : null}{PCP_Pharmacy.pcp.phone ? <div style={{ color: '#555', marginBottom: '2px' }}>Phone: {PCP_Pharmacy.pcp.phone}</div> : null}{PCP_Pharmacy.pcp.fax ? <div style={{ color: '#555' }}>Fax: {PCP_Pharmacy.pcp.fax}</div> : null}</>
                                      : <div style={{ color: '#aaa', fontStyle: 'italic' }}>Not provided</div>}
                                  </div>
                                  <div style={{ padding: '12px 14px', backgroundColor: '#f8f9fa' }}>
                                    <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Pharmacy</div>
                                    {PCP_Pharmacy?.pharmacy?.name
                                      ? <><div style={{ fontWeight: '700', marginBottom: '3px' }}>{PCP_Pharmacy.pharmacy.name}</div>{PCP_Pharmacy.pharmacy.address ? <div style={{ color: '#555', marginBottom: '2px' }}>{PCP_Pharmacy.pharmacy.address}</div> : null}{PCP_Pharmacy.pharmacy.phone ? <div style={{ color: '#555', marginBottom: '2px' }}>Phone: {PCP_Pharmacy.pharmacy.phone}</div> : null}{PCP_Pharmacy.pharmacy.fax ? <div style={{ color: '#555' }}>Fax: {PCP_Pharmacy.pharmacy.fax}</div> : null}</>
                                      : <div style={{ color: '#aaa', fontStyle: 'italic' }}>Not provided</div>}
                                  </div>
                                </div>

                                {/* ── Patient Demographics ── */}
                                {(fullName || DOBTxt || GenderTxt || phoneNumber) && (
                                  <div style={{ marginBottom: '16px' }}>
                                    <div style={{ fontWeight: '700', fontSize: '18px', color: '#024C9C', marginBottom: '8px', textTransform: 'capitalize' }}>{fullName}</div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'hidden', fontSize: '12px' }}>
                                      <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Date of Birth</div>
                                        <div style={{ fontWeight: '600', color: '#222' }}>{DOBTxt ? moment(DOBTxt).format('MMM DD, YYYY') : '—'}</div>
                                      </div>
                                      <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Age</div>
                                        <div style={{ fontWeight: '600', color: '#222' }}>{ageCal ? `${ageCal} yrs` : '—'}</div>
                                      </div>
                                      <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Sex</div>
                                        <div style={{ fontWeight: '600', color: '#222', textTransform: 'capitalize' }}>{GenderTxt || '—'}</div>
                                      </div>
                                      <div style={{ padding: '10px 12px', backgroundColor: '#f8f9fa' }}>
                                        <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Phone</div>
                                        <div style={{ fontWeight: '600', color: '#222' }}>{phoneNumber || '—'}</div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* ── Vitals Row ── */}
                                {(BMITxt || WeightTxt || HeightTxt) && (
                                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', marginBottom: '16px', overflow: 'hidden', fontSize: '12px' }}>
                                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>BMI</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{BMITxt || '—'}</div>
                                    </div>
                                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Height</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{HeightTxt ? `${HeightTxt} cm` : '—'}</div>
                                    </div>
                                    <div style={{ padding: '10px 12px', backgroundColor: '#f8f9fa' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#6c757d', marginBottom: '4px' }}>Weight</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{WeightTxt ? `${WeightTxt} lbs` : '—'}</div>
                                    </div>
                                  </div>
                                )}

                                {/* ── Visit / Consultation Date ── */}
                                {finalConsultantVisitDate && (
                                  <div style={{ marginBottom: '12px', fontSize: '12px', color: '#555' }}>
                                    <span style={{ fontWeight: '700', color: '#024C9C' }}>Date of Consultation: </span>
                                    {moment(finalConsultantVisitDate).format('MMMM DD, YYYY')}
                                  </div>
                                )}

                                {/* ── Issue 5: Chief Complaint ── */}
                                {(() => {
                                  // Fallback chain: illness field → extract from HPI text
                                  let complaint = selectedIllness || RecordData?.illness || '';
                                  if (!complaint) {
                                    const hpi = finalConsultantHPI || zoomHPI || '';
                                    const m = hpi.match(/presents?\s+with\s+([^.,]+)/i);
                                    if (m) complaint = m[1].trim();
                                    else if (hpi) complaint = hpi.split(/[.!?]/)[0].trim().slice(0, 150);
                                  }
                                  return complaint ? (
                                    <div style={{ marginBottom: '16px', padding: '10px 14px', backgroundColor: '#fff8e1', border: '1px solid #ffe082', borderRadius: '6px' }}>
                                      <div style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#b8860b', marginBottom: '4px', letterSpacing: '0.5px' }}>Chief Complaint</div>
                                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>{complaint}</div>
                                    </div>
                                  ) : null;
                                })()}

                                {/* ── Issue 7: Insurance Information ── */}
                                {(myinsuranceinfo?.insurance_carrier || myinsuranceinfo?.group_name || myinsuranceinfo?.policy_id || myinsuranceinfo?.expiry_date) && (
                                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0', border: '1px solid #dee2e6', borderRadius: '6px', marginBottom: '16px', overflow: 'hidden', fontSize: '12px' }}>
                                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f7ff' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Insurance Carrier</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.insurance_carrier || '-'}</div>
                                    </div>
                                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f7ff' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Group Name</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.group_name || '-'}</div>
                                    </div>
                                    <div style={{ padding: '10px 12px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f7ff' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Insurance ID</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{myinsuranceinfo.policy_id || '-'}</div>
                                    </div>
                                    <div style={{ padding: '10px 12px', backgroundColor: '#f0f7ff' }}>
                                      <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '4px', letterSpacing: '0.5px' }}>Effective Date</div>
                                      <div style={{ fontWeight: '600', color: '#222' }}>{formatConsultationDate(myinsuranceinfo.expiry_date, myinsuranceinfo.expiry_date)}</div>
                                    </div>
                                  </div>
                                )}

                                {(finalConsultantNote || finalConsultantHPI) ? (
                                  <>
                                {finalConsultantHPI ? (
                                  <>
                                    <div style={{ marginBottom: '16px' }}>
                                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>History of Present Illness (HPI)</h3>
                                      <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantHPI)}</div>
                                    </div>
                                    {(() => { const val = finalConsultantPMH || extractChatbotSection(followSummaryEditAIChatbot, 'PAST MEDICAL AND SURGICAL HISTORY', 'PAST MEDICAL HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Past Medical History (PMH)</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                                    {(() => { const val = finalConsultantMedications || extractChatbotSection(followSummaryEditAIChatbot, 'CURRENT MEDICATIONS', 'MEDICATIONS'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Current Medications</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                                    {finalConsultantPrescribedMedications && (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Prescribed Medications</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantPrescribedMedications)}</div></div>)}
                                    {(() => { const val = finalConsultantAllergies || extractChatbotSection(followSummaryEditAIChatbot, 'ALLERGIES'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Allergies</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                                    {(() => { const val = finalConsultantSocialHistory || extractChatbotSection(followSummaryEditAIChatbot, 'SOCIAL HISTORY'); return val ? (<div style={{ marginBottom: '16px' }}><h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Social History</h3><div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(val)}</div></div>) : null; })()}
                                    {finalConsultantROS && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Review of Systems</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantROS)}</div>
                                      </div>
                                    )}
                                    {finalConsultantNote && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantNote)}</div>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {finalConsultantNote && (
                                      <div style={{ marginBottom: '16px' }}>
                                        <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Assessment & Differential Diagnosis</h3>
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(finalConsultantNote)}</div>
                                      </div>
                                    )}
                                  </>
                                )}
                                {finalConsultantPlan && (() => {
                                  const investigationFileNames = ['Basic Gastro Labs', 'Anemia Labs', 'Heaptic Labs', 'Stool Studies', 'Abdominal CT', 'Abdominal US', 'Barium Studies', 'EGD Order', 'Colon Order', 'Colonoscopy', 'Upper GI Endoscopy', 'Procedural Sedation'];
                                  const recommendationFileNames = ['Colon Screening Guidelines', 'Telehealth Disclaimer', 'Weight Reducing Diet', 'High Fiber Diet', 'GERD and Lifestyle', 'Stress Management', 'FattyLiver', 'Fatty Liver', 'Diverticulosis', 'Irritable Bowel Syndrome', 'Inflammatory Bowel Disease'];
                                  const investigationDocs = selectedFinalNoteFiles.filter(f => investigationFileNames.includes(f.fileName));
                                  const recommendationDocs = selectedFinalNoteFiles.filter(f => recommendationFileNames.includes(f.fileName));

                                  // Split plan text into INVESTIGATIONS, THERAPIES, and RECOMMENDATIONS sections
                                  const planLines = finalConsultantPlan.split('\n');
                                  let currentSection = '';
                                  let investigationLines = [];
                                  let therapyLines = [];
                                  let recommendationLines = [];
                                  let otherLines = [];

                                  planLines.forEach(line => {
                                    const trimmed = line.trim();
                                    if (/^INVESTIGATIONS\s*:/i.test(trimmed) || /^\d+[\.\)]\s*INVESTIGATIONS\s*:/i.test(trimmed)) {
                                      currentSection = 'investigation';
                                      return;
                                    }
                                    if (/^THERAPIES\s*:/i.test(trimmed) || /^\d+[\.\)]\s*THERAPIES\s*:/i.test(trimmed)) {
                                      currentSection = 'therapy';
                                      return;
                                    }
                                    if (/^RECOMMENDATIONS\s*:/i.test(trimmed) || /^\d+[\.\)]\s*RECOMMENDATIONS\s*:/i.test(trimmed)) {
                                      currentSection = 'recommendation';
                                      return;
                                    }
                                    if (!trimmed) return;
                                    if (currentSection === 'investigation') investigationLines.push(line);
                                    else if (currentSection === 'therapy') therapyLines.push(line);
                                    else if (currentSection === 'recommendation') recommendationLines.push(line);
                                    else otherLines.push(line);
                                  });

                                  const renderDocGrid = (docs) => (
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', marginTop: '8px' }}>
                                      {docs.map((file) => (
                                        <div key={file.id} style={{
                                          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                          background: '#f8fafd', padding: '5px 10px',
                                          borderRadius: '5px', border: '1px solid #e2e8f0',
                                        }}>
                                          <span style={{ fontSize: '12px', fontWeight: '500', color: '#013c7d', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{file.fileName}</span>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, marginLeft: '8px' }}>
                                            <a href={file.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#024C9C', fontWeight: '600', textDecoration: 'none', cursor: 'pointer' }}>View</a>
                                            {!effectiveSubmitted && !isGeneratingPdf && (
                                              <span
                                                onClick={() => handleFinalNoteFileToggle(file, true)}
                                                style={{ cursor: 'pointer', fontWeight: '700', fontSize: '14px', color: '#a0a0a0', lineHeight: 1 }}
                                                title="Remove"
                                              >&times;</span>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  );

                                  return (
                                    <div style={{ marginBottom: '16px' }}>
                                      <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Plan of Care</h3>
                                      {otherLines.length > 0 && (
                                        <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary(otherLines.join('\n'))}</div>
                                      )}
                                      {(investigationLines.length > 0 || investigationDocs.length > 0 || doctorRecommendations.length > 0) && (
                                        <div style={{ marginBottom: '10px' }}>
                                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('INVESTIGATIONS:\n' + investigationLines.concat(doctorRecommendations.map(r => '• ' + r)).join('\n'))}</div>
                                          {investigationDocs.length > 0 && renderDocGrid(investigationDocs)}
                                          {!effectiveSubmitted && !hideClinicEdit && !isGeneratingPdf && (
                                            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                                              <input
                                                type="text"
                                                value={newRecommendation}
                                                onChange={(e) => setNewRecommendation(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleAddRecommendation(); }}
                                                placeholder="Add investigation..."
                                                style={{ flex: 1, padding: '8px 12px', border: '1.5px solid #d0d7e2', borderRadius: '8px', fontSize: '13px', fontFamily: 'inherit', outline: 'none' }}
                                              />
                                              <a onClick={!isSavingRecommendation ? handleAddRecommendation : undefined}
                                                style={{ cursor: isSavingRecommendation ? 'not-allowed' : 'pointer', width: 'auto', padding: '0 14px', opacity: isSavingRecommendation ? 0.6 : 1, display: 'flex', alignItems: 'center', borderRadius: '8px' }}
                                                className="editBtnNewSummary">
                                                {isSavingRecommendation ? 'Adding...' : '+ Add'}
                                              </a>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {therapyLines.length > 0 && (
                                        <div style={{ marginBottom: '10px' }}>
                                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('THERAPIES:\n' + therapyLines.join('\n'))}</div>
                                        </div>
                                      )}
                                      {(recommendationLines.length > 0 || recommendationDocs.length > 0) && (
                                        <div style={{ marginBottom: '10px' }}>
                                          <div style={{ fontSize: '14px', lineHeight: '1.7' }}>{renderAISummary('RECOMMENDATIONS:\n' + recommendationLines.join('\n'))}</div>
                                          {recommendationDocs.length > 0 && renderDocGrid(recommendationDocs)}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })()}
                                {/* For PDF only - hidden on screen */}
                                {doctorRecommendations.length > 0 && (
                                  <div className="pdf-only-recommendations" style={{ marginBottom: '16px', height: 0, overflow: 'hidden' }}>
                                    <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#024C9C', marginBottom: '8px' }}>Investigation Suggested</h3>
                                    {doctorRecommendations.map((rec, idx) => (
                                      <div key={idx} style={{ marginBottom: '4px' }}>
                                        <span style={{ fontSize: '14px', lineHeight: '1.6' }}>• {rec}</span>
                                      </div>
                                    ))}
                                  </div>
                                )}

                                {/* ── Physician Signature Block ── */}
                                {reportProviderName && (
                                  <div style={{ marginTop: '32px', paddingTop: '16px', borderTop: '1px solid #dee2e6' }}>
                                    <div style={{ display: 'inline-block', minWidth: '220px' }}>
                                      <div style={{ fontSize: '13px', color: '#555', marginBottom: '6px' }}>Electronically Reviewed &amp; Signed</div>
                                      {reportProviderSignature && (
                                        <div style={{ marginBottom: '6px' }}>
                                          <img src={reportProviderSignature} alt="Signature" style={{ maxHeight: '52px', maxWidth: '200px', objectFit: 'contain', display: 'block' }} />
                                        </div>
                                      )}
                                      <div style={{ borderBottom: '1.5px solid #333', paddingBottom: '4px', marginBottom: '6px', fontSize: '15px', fontWeight: '700', color: '#024C9C' }}>{reportProviderName}</div>
                                      {reportProviderSpecialty && <div style={{ fontSize: '12px', color: '#555', marginBottom: '2px' }}>{reportProviderSpecialty}</div>}
                                      {reportProviderPhone && <div style={{ fontSize: '12px', color: '#555', marginBottom: '2px' }}>Phone: {reportProviderPhone}</div>}
                                      <div style={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>Date: {moment().format('MMM DD, YYYY')}</div>
                                    </div>
                                  </div>
                                )}
                                  </>
                                ) : (
                                  <div style={{ textAlign: 'center', padding: '40px 20px', color: '#888' }}>
                                    {isGeneratingFinalNote ? (
                                      <>
                                        <div className="spinner-border text-primary" role="status" style={{ width: '20px', height: '20px', margin: '8px auto' }}>
                                          <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p style={{ fontSize: '14px', marginTop: '8px' }}>Generating Final Consultant Note...</p>
                                      </>
                                    ) : (
                                      <p style={{ fontSize: '15px', marginBottom: '8px' }}>Final Consultant Note will be auto-generated after consultation summary is available.</p>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div className={"zoomCallMeeting d-flex  p-2 " + (!CheckZoomMeetStart && 'd-none')}>

                  {/* */}
                  <div className="w-50 ">
                    <div className="userInfoMainDiv whiteBg innerDivRecords m-0 w-100">
                      <div className="titleDivRight w-100">
                        <h2 className="capitalizeTxt">{fullName}</h2>
                        <button className="backBtn" onClick={handleButtonBackZoomInvite}
                        ><img src={Icons[0].admin_backBtn} />Back</button>
                        <ul className="userInfoDetails mt-4 d-grid w-100 userInfoListView">
                          <li className={GenderTxt ? '' : 'd-none'}>
                            <img src={Icons[0].admin_userIcon} />
                            <label className="capitalizeTxt">{GenderTxt}</label>
                          </li>
                          <li className={DOBTxt ? '' : 'd-none'}>
                            <img src={Icons[0].admin_calendarIcon} />
                            <label>{moment(DOBTxt).format('MMM DD, YYYY')} {' '}({ageCal} years)</label>
                          </li>
                          <li>
                            <img src={Icons[0].admin_mailIcon} />
                            <label className="singleLineEllipsis" onClick={() => copyToClipboard(email)} style={{ cursor: 'pointer' }}>{email} {" "}
                              <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                            </label>
                          </li>
                          <li>
                            <img src={Icons[0].admin_phoneIcon} />
                            <label>{phoneNumber}</label>
                          </li>
                        </ul>
                        <hr></hr>

                        <div className="whiteBg tab-content p-0 bg-white" style={{ borderRadius: "14px" }}>

                          <div className="despInfoDiv position-relative  d-flex" style={{ height: '40px' }}>
                            <h2>Summary</h2>

                          </div>
                          <div className="innerDivBox h-auto" >
                            {FollowupData?.length > 0 ? (
                              FollowupData.map((item, index) =>
                                //   [...FollowupData]
                                // .sort((a, b) => new Date(b.created_on) - new Date(a.created_on)) // Sort by `created_on` in descending order
                                // .map((item, index) => 
                                item.followup_summary ? ( // Check if followup_summary exists
                                  <div key={index}>
                                    <div className="despInfoDiv">
                                      <div className="headDespInfoDiv">
                                        <ul className="infoDivPatientList">
                                          <li>
                                            <label>
                                              {`${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}
                                            </label>
                                            <b>{formatConsultationDate(item.created_on, item.created_at)}</b>
                                          </li>
                                          <li>
                                            <label>Follow up</label>
                                            <b>{item.topic}</b>
                                          </li>


                                          {calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts) ?
                                            (<>
                                              <li  >
                                                <label>Physician</label>
                                                <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                                              </li>
                                              <li  >
                                                <label>Patient </label>
                                                <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                                              </li>
                                              <li  >
                                                <label>Communication</label>
                                                <b>Audio & Video</b>
                                              </li>
                                              <li >
                                                <label>Duration</label>{" "}
                                                <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                                              </li>
                                              <li >
                                                <label>Verbal consent </label>{" "}
                                                <b>Obtained</b>
                                              </li>


                                            </>
                                            ) : null}


                                        </ul>

                                        <a onClick={() => handleInputMainSummaryEditFollowup(item.followup_id, item.followup_summary)} style={{ marginLeft: '10px', cursor: 'pointer' }} className={ImageHide ? "editBtnNewSummary " : "editBtnNewSummary "}>
                                          Edit <img src={editMode === item.followup_id ? Icons[0].editIcon : Icons[0].editRed} /></a>

                                      </div>
                                    </div>
                                    {/* {!showSummaryEditFollowup ? ( */}
                                    {!editMode || editMode !== item.followup_id ? (
                                      <>
                                        <pre className="innerDivBoxPC h-auto">{item.followup_summary} </pre>
                                      </>
                                    ) : (
                                      <div className='textareaSummary  innerDivBox w-100' style={{ height: 'auto' }}>
                                        <textarea
                                          value={editText}
                                          onChange={(e) => setEditText(e.target.value)}
                                          //  value={item.followup_summary} 
                                          //  onChange={handleInputChangeSummaryEditFollowup} 
                                          style={{ height: '200px', width: ' 100%' }} />
                                        <hr></hr>
                                        <div className='editSaveOpt' >
                                          {ShowLoaderSummaryFollowup ? (<>
                                            <button  > Loading
                                              <div className="spinner-border text-light" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                              </div>
                                            </button>
                                          </>) : (<>
                                            <button onClick={() => handleSaveSummaryEditFollowup(item?.followup_id)}>
                                              Save Changes
                                            </button>
                                          </>)

                                          }

                                          <button onClick={handleCancelClickSummaryEditFollowup}>Cancel</button>
                                        </div>
                                      </div>

                                    )}


                                    <hr style={{ margin: '20px 0' }}></hr>
                                  </div>
                                ) : null // If followup_summary is null, render nothing
                              )
                            ) : null}

                            <div className="despInfoDiv">
                              <div className="headDespInfoDiv">
                                <ul className="infoDivPatientList">
                                  <li>
                                    <label>Consultation</label>
                                    <b> {formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
                                  </li>
                                  <li>
                                    <label>Illnesses</label>
                                    <b>{RecordData.illness}</b>
                                  </li>

                                </ul>


                              </div>
                            </div>
                            {/* {FollowupData.followup_summary ? <p className="innerDivBox">{FollowupData.followup_summary} </p> :  <p className="innerDivBox"> - </p> } */}
                            {!showSummaryEditAIChatbot ? (
                              <>
                                {EmergencyQuest ?
                                  <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p>
                                  :
                                  followSummaryEditAIChatbot ? (
                                    <>
                                      <div className="innerDivBoxPC h-auto">{renderAISummary(followSummaryEditAIChatbot)}</div>
                                      {PCP_Pharmacy && PCP_Pharmacy.pcp && PCP_Pharmacy.pcp.name ? (
                                        <>
                                          <b>Primary Care Physician (PCP): </b>
                                          {PCP_Pharmacy.pcp.name}{PCP_Pharmacy.pcp.address ? ', ' + PCP_Pharmacy.pcp.address : ''}
                                          {PCP_Pharmacy.pcp.phone ? <span> | Phone: {PCP_Pharmacy.pcp.phone}</span> : null}
                                          {PCP_Pharmacy.pcp.fax ? <span> | Fax: {PCP_Pharmacy.pcp.fax}</span> : null}
                                          <br />
                                        </>
                                      ) : null}
                                      {PCP_Pharmacy && PCP_Pharmacy.pharmacy && PCP_Pharmacy.pharmacy.name ? (
                                        <>
                                          <b>Pharmacy information: </b>
                                          {PCP_Pharmacy.pharmacy.name}{PCP_Pharmacy.pharmacy.address ? ', ' + PCP_Pharmacy.pharmacy.address : ''}
                                          {PCP_Pharmacy.pharmacy.phone ? <span> | Phone: {PCP_Pharmacy.pharmacy.phone}</span> : null}
                                          {PCP_Pharmacy.pharmacy.fax ? <span> | Fax: {PCP_Pharmacy.pharmacy.fax}</span> : null}
                                        </>
                                      ) : null}
                                    </>
                                  ) : (
                                    <div className="innerDivBoxPC" style={{ textAlign: 'center', padding: '20px' }}>
                                      {isRegeneratingAI ? (
                                        <>
                                          <div className="spinner-border text-primary" role="status" style={{ width: '20px', height: '20px', margin: '8px auto' }}>
                                            <span className="visually-hidden">Loading...</span>
                                          </div>
                                          <p style={{ color: '#666', marginTop: '8px', fontSize: '13px' }}>Generating AI summary...</p>
                                        </>
                                      ) : (
                                        <p style={{ color: '#999' }}>No summary available</p>
                                      )}
                                    </div>
                                  )
                                }
                              </>
                            ) : (
                              <div className='textareaSummary innerDivBox w-100' style={{ height: 'auto' }}>
                                <textarea value={followSummaryEditAIChatbot} onChange={handleInputChangeSummaryEditAIChatbot} style={{ height: '200px', width: ' 100%' }} />
                                <hr></hr>
                                <div className='editSaveOpt' >
                                  {ShowLoaderSummaryAIChatbot ? (<>
                                    <button  > Loading
                                      <div className="spinner-border text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </button>
                                  </>) : (<>
                                    <button onClick={() => handleSaveSummaryEditAIChatbot()}>
                                      Save Changes
                                    </button>
                                  </>)

                                  }

                                  <button onClick={handleCancelClickSummaryEditAIChatbot}>Cancel</button>
                                </div>
                              </div>

                            )}

                          </div>

                          <hr></hr>


                          <div className="despInfoDiv">
                            <h2>Reports </h2>
                          </div>
                          <div className="innerDivBoxPC h-auto overflow-hidden">


                            <ol className="reportListOptLink" style={{ fontSize: '16px' }}>
                              {sortedGroupedDocuments.length > 0 ? (
                                sortedGroupedDocuments
                                  .filter(({ documents }) => documents && documents.length > 0) // Filter out empty or null documents
                                  .map(({ doc_type, documents, Name }) => (
                                    <li key={doc_type}>

                                      {documents.map((doc, index) => (
                                        <div key={doc.doc_id} style={{ marginBottom: "0px" }}>
                                          <b style={{ textTransform: "capitalize", textDecoration: "none" }} className={doc_type === "other_report" && index !== 0 && 'd-none'}>
                                            {Name}
                                            {/* {doc_type.replace('_', ' ')} */}
                                          </b>
                                          {/* Document URL with conditional button */}
                                          {doc.doc_url && (
                                            <span
                                              className={
                                                "pdfButtonModal" + (doc_type === "other_report" ? " d-none" : "")
                                              }
                                            >

                                            </span>
                                          )}

                                          {/* Document Text */}
                                          {/* Document Text */}
                                          {doc.doc_text && (
                                            <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_text}</p>
                                          )}
                                          {/* PCP / Pharmacy — show doc_summary directly */}
                                          {(doc_type === "pcp" || doc_type === "pharmacy") && doc.doc_summary && (
                                            <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_summary}</p>
                                          )}

                                          {doc_type === "other_report" && doc.doc_summary && doc.doc_summary !== "None" && (
                                            <>
                                              <h3 style={{ fontSize: "16px", marginTop: "14px", fontWeight: "600" }} className="my-0">
                                                {index + 1}. Other Report Summary
                                              </h3>
                                              <pre style={{ margin: "5px 0", textTransform: "capitalize" }}>
                                                {doc.doc_summary}
                                              </pre>
                                            </>
                                          )}

                                          {/* Conditional Divider */}
                                          {doc.doc_url && (
                                            <hr className={doc_type !== "other_report" ? " d-none" : ""} />
                                          )}
                                        </div>
                                      ))}
                                    </li>
                                  ))
                              ) : (
                                <p style={{ textAlign: "center" }}>No reports found</p>
                              )}
                            </ol>



                          </div>



                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-50 zoomLinkShowDiv">
                    <iframe className="w-100 h-100"
                      src={CheckZoomMeetURL}></iframe>

                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>


      {/* Modal Popup for Viewing Documents */}
      <Modal
        className='viewDocModal'
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Document Viewer"
      >
        <button
          onClick={closeModal}
          style={{
            float: 'right',
            cursor: 'pointer',
            background: 'red',
            color: 'white',
            border: 'none',
            padding: '4px 10px',
            borderRadius: '0px',
            marginBottom: '-9px',
          }}
        >
          Close
        </button>
        <div style={{ display: "flex", flexDirection: "column", height: "100%", clear: 'both' }}>
          {/* Ensure selectedDocument exists before rendering */}
          {selectedDocument ? (
            <>
              <h3>{selectedDocument.name}</h3>
              {/* <iframe src={selectedDocument} width="100%" height="100%" type="application/pdf"  /> */}
              {/* Render PDF or Image based on file type */}
              <embed src={selectedDocument} width="100%" height="100%" type="application/pdf" className="innerContainer" />

              {/* <iframe
          src={selectedDocument}
          width="100%"
          height="600px"
          style={{ border: "none" }}
          title="PDF Viewer"
        /> */}
              {/* <PDFViewer pdfUrl={pdfUrl} onClose={closeModal} /> */}
            </>
          ) : (
            <p>Loading document...</p> // Fallback content if document is not available
          )}
        </div>
      </Modal>




      {/* Modal Popup for Viewing Documents */}
      <Modal
        isOpen={isModalOpenViewAll}
        onRequestClose={closeModalViewAll}
        contentLabel="Document Viewer"
        className={"modalViewAllMain"}
      >
        <button
          className="closeBtn"
          onClick={closeModalViewAll}
        >
          Close
        </button>



        <div className="innerModalDiv" id="pdfContent">

          <div ref={contentRef} style={{ padding: "20px" }}>

            {/* ── Issue 4: Provider / PCP / Pharmacy Header Block ── */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '0',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              marginBottom: '16px',
              overflow: 'hidden',
              fontSize: '12px'
            }}>
              {/* Provider column */}
              <div style={{ padding: '12px 14px', borderRight: '1px solid #dee2e6', backgroundColor: '#f0f4f8' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Provider</div>
                {reportProviderName ? <div style={{ fontWeight: '700', marginBottom: '3px' }}>{reportProviderName}</div> : null}
                {reportProviderSpecialty ? <div style={{ color: '#555', marginBottom: '2px' }}>{reportProviderSpecialty}</div> : null}
                {reportProviderPhone ? <div style={{ color: '#555' }}>Phone: {reportProviderPhone}</div> : null}
              </div>
              {/* PCP column */}
              <div style={{ padding: '12px 14px', borderRight: '1px solid #dee2e6', backgroundColor: '#f8f9fa' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Primary Care Physician</div>
                {PCP_Pharmacy?.pcp?.name
                  ? <>
                      <div style={{ fontWeight: '700', marginBottom: '3px' }}>{PCP_Pharmacy.pcp.name}</div>
                      {PCP_Pharmacy.pcp.address ? <div style={{ color: '#555', marginBottom: '2px' }}>{PCP_Pharmacy.pcp.address}</div> : null}
                      {PCP_Pharmacy.pcp.phone ? <div style={{ color: '#555', marginBottom: '2px' }}>Phone: {PCP_Pharmacy.pcp.phone}</div> : null}
                      {PCP_Pharmacy.pcp.fax ? <div style={{ color: '#555' }}>Fax: {PCP_Pharmacy.pcp.fax}</div> : null}
                    </>
                  : <div style={{ color: '#aaa', fontStyle: 'italic' }}>Not provided</div>
                }
              </div>
              {/* Pharmacy column */}
              <div style={{ padding: '12px 14px', backgroundColor: '#f8f9fa' }}>
                <div style={{ fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', color: '#4a6fa5', marginBottom: '6px', letterSpacing: '0.5px' }}>Pharmacy</div>
                {PCP_Pharmacy?.pharmacy?.name
                  ? <>
                      <div style={{ fontWeight: '700', marginBottom: '3px' }}>{PCP_Pharmacy.pharmacy.name}</div>
                      {PCP_Pharmacy.pharmacy.address ? <div style={{ color: '#555', marginBottom: '2px' }}>{PCP_Pharmacy.pharmacy.address}</div> : null}
                      {PCP_Pharmacy.pharmacy.phone ? <div style={{ color: '#555', marginBottom: '2px' }}>Phone: {PCP_Pharmacy.pharmacy.phone}</div> : null}
                      {PCP_Pharmacy.pharmacy.fax ? <div style={{ color: '#555' }}>Fax: {PCP_Pharmacy.pharmacy.fax}</div> : null}
                    </>
                  : <div style={{ color: '#aaa', fontStyle: 'italic' }}>Not provided</div>
                }
              </div>
            </div>

            <div className="titleDivRight">
              <div className="d-flex gap-2 justify-content-start align-items-center mb-2" style={{ marginTop: '20px' }}>
                <h2 className="capitalizeTxt m-0 d-flex align-items-center" style={{ fontSize: '24px' }}>{fullName}
                  {!isGeneratingPdf && (
                    <button
                      className="copyAllclipBtn"
                      onClick={() => handleCopyAll()}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src={Icons[0].copyclip} style={{ width: '18px' }} /> Copy All
                    </button>
                  )}
                </h2>
              </div>

              {/* Patient Demographics - Clinical Format */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '10px 20px',
                backgroundColor: '#f8f9fa',
                padding: '12px 16px',
                borderRadius: '6px',
                marginBottom: '12px',
                border: '1px solid #dee2e6'
              }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Date of Birth</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{DOBTxt ? moment(DOBTxt).format('MMM DD, YYYY') : '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Age</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{ageCal ? `${ageCal} yrs` : '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Sex</div>
                  <div style={{ fontSize: '13px', fontWeight: '700', textTransform: 'capitalize' }}>{GenderTxt || '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Phone</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{phoneNumber || '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Height</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{HeightTxt ? `${formatHeight(HeightTxt)}` : '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Weight</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{WeightTxt ? `${WeightTxt} lbs` : '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>BMI</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{BMITxt || '—'}</div>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Email</div>
                  <div style={{ fontSize: '13px', fontWeight: '700' }}>{email || '—'}</div>
                </div>
              </div>

              {/* Insurance Information */}
              {(myinsuranceinfo?.insurance_carrier || myinsuranceinfo?.group_name || myinsuranceinfo?.policy_id || myinsuranceinfo?.expiry_date) && (
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '10px 20px',
                  backgroundColor: '#f0f7ff',
                  padding: '12px 16px',
                  borderRadius: '6px',
                  marginBottom: '12px',
                  border: '1px solid #cce0ff'
                }}>
                  <div>
                    <div style={{ fontSize: '11px', color: '#4a6fa5', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Insurance Carrier</div>
                    <div style={{ fontSize: '13px', fontWeight: '700' }}>{myinsuranceinfo.insurance_carrier || '—'}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', color: '#4a6fa5', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Group Name</div>
                    <div style={{ fontSize: '13px', fontWeight: '700' }}>{myinsuranceinfo.group_name || '—'}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', color: '#4a6fa5', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Insurance ID</div>
                    <div style={{ fontSize: '13px', fontWeight: '700' }}>{myinsuranceinfo.policy_id || '—'}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', color: '#4a6fa5', fontWeight: '600', textTransform: 'uppercase', marginBottom: '2px' }}>Effective Date</div>
                    <div style={{ fontSize: '13px', fontWeight: '700' }}>{formatConsultationDate(myinsuranceinfo.expiry_date, myinsuranceinfo.expiry_date)}</div>
                  </div>
                </div>
              )}
              <hr />
            </div>



            {FollowupData?.length > 0 ? (
              [...FollowupData]
                .sort((a, b) => new Date(b.created_on) - new Date(a.created_on)) // Sort by `created_on` in descending order
                .map((item, index) =>
                  item.followup_summary ? ( // Check if followup_summary exists
                    <div key={index}>
                      <div className="despInfoDiv">
                        <div className="headDespInfoDiv">
                          <ul className="infoDivPatientList" style={{ listStyle: 'none', padding: '10px 0px', display: 'flex', marginBottom: '8px', gap: '10px', alignItems: 'end' }}>
                            <li style={{
                              marginRight: '5px',
                              display: 'grid',
                              gridTemplateColumns: '100%',
                              fontSize: '14px',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <label style={{
                                fontSize: '14px',
                                fontWeight: '800',
                              }} >  {`${getOrdinalLabel(FollowupData.length - index + 1)} Consultation`}</label>

                              <b>{formatConsultationDate(item.created_on, item.created_at)}</b>
                            </li>
                            <li style={{
                              marginRight: '5px',
                              display: 'grid',
                              gridTemplateColumns: '100%',
                              fontSize: '14px',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              <label style={{
                                fontSize: '14px',
                                fontWeight: '800',
                              }} >Follow up</label>
                              <b>{item.topic}</b>
                            </li>
                            {
                              calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts) ?
                                (<>

                                  <li style={{
                                    marginRight: '5px',
                                    display: 'grid',
                                    gridTemplateColumns: '100%',
                                    fontSize: '14px',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <label style={{
                                      fontSize: '14px',
                                      fontWeight: '800',
                                    }} >Physician</label>
                                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                                  </li>
                                  <li style={{
                                    marginRight: '5px',
                                    display: 'grid',
                                    gridTemplateColumns: '100%',
                                    fontSize: '14px',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <label style={{
                                      fontSize: '14px',
                                      fontWeight: '800',
                                    }} >Patient</label>
                                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                                  </li>
                                  <li style={{
                                    marginRight: '5px',
                                    display: 'grid',
                                    gridTemplateColumns: '100%',
                                    fontSize: '14px',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <label style={{
                                      fontSize: '14px',
                                      fontWeight: '800',
                                    }} >Communication</label>
                                    <b>Audio & Video</b>
                                  </li>

                                  <li style={{
                                    marginRight: '5px',
                                    display: 'grid',
                                    gridTemplateColumns: '100%',
                                    fontSize: '14px',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <label style={{
                                      fontSize: '14px',
                                      fontWeight: '800',
                                    }} >Duration</label>{" "}
                                    <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                                  </li>

                                  <li style={{
                                    marginRight: '5px',
                                    display: 'grid',
                                    gridTemplateColumns: '100%',
                                    fontSize: '14px',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}>
                                    <label style={{
                                      fontSize: '14px',
                                      fontWeight: '800',
                                    }} >Verbal consent </label>{" "}
                                    <b>Obtained</b>
                                  </li>


                                </>
                                ) : null}

                            {/* <li>
                        <label>Duration:</label>{" "}
                        <b>{calculateDuration(item.zoom_meeting.start_ts, item.zoom_meeting.end_ts)}</b>
                      </li> */}


                          </ul>
                        </div>
                      </div>
                      {(followSummaryEditFollowup || item.followup_summary) && (
                        <>
                          <h2 style={{ fontSize: '22px' }}>
                            Follow up - Summary
                            {!isGeneratingPdf && ( // Hide the "Copy All" button while PDF is generating
                              <button
                                className="copyclipBtn"
                                onClick={() => copyToClipboard(followSummaryEditFollowup)}
                                style={{ cursor: 'pointer' }}
                              >
                                <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                              </button>
                            )}


                          </h2>
                          <pre>{followSummaryEditFollowup || item.followup_summary}</pre>
                        </>
                      )}
                      <hr></hr>
                    </div>
                  ) : null // If followup_summary is null, render nothing
                )
            ) : null}
            {FollowupData?.length > 0 ? (
              FollowupData.map((item, index) =>
                item.followup_PoC ? ( // Check if followup_PoC exists
                  <div key={index}>
                    <h2 style={{ fontSize: '22px' }}>Follow up - Plan of Care

                      {!isGeneratingPdf && ( // Hide the "Copy All" button while PDF is generating
                        <button
                          className="copyclipBtn"
                          onClick={() => copyToClipboard(followPlanOnCareData || item?.followup_PoC)}
                          style={{ cursor: 'pointer' }}
                        >
                          <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                        </button>
                      )}


                    </h2>
                    <pre className="innerDivBoxPC h-auto  overflow-hidden">
                      {followPlanOnCareData || item?.followup_PoC}
                    </pre>
                    <hr />
                  </div>
                ) : null // If followup_PoC is empty or null, render nothing
              )
            ) : null}

            <ul className="infoDivPatientList" style={{ listStyle: 'none', padding: '10px 0px', display: 'flex', marginBottom: '8px', gap: '10px', alignItems: 'end' }}>
              <li style={{
                marginRight: '5px',
                display: 'grid',
                gridTemplateColumns: '100%',
                fontSize: '14px',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <label style={{
                  fontSize: '14px',
                  fontWeight: '800',
                }} >Consultation</label>
                <b> {formatConsultationDate(RecordData?.created_on, RecordData?.created_at)}</b>
              </li>
              <li style={{
                marginRight: '5px',
                display: 'grid',
                gridTemplateColumns: '100%',
                fontSize: '14px',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <label style={{
                  fontSize: '14px',
                  fontWeight: '800',
                }} >Illnesses</label>
                <b>{RecordData.illness}</b>
              </li>
              {meetingStatusZoom ?
                (<>

                  <li style={{
                    marginRight: '5px',
                    display: 'grid',
                    gridTemplateColumns: '100%',
                    fontSize: '14px',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <label style={{
                      fontSize: '14px',
                      fontWeight: '800',
                    }} >Physician</label>
                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Office</b>
                  </li>
                  <li style={{
                    marginRight: '5px',
                    display: 'grid',
                    gridTemplateColumns: '100%',
                    fontSize: '14px',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <label style={{
                      fontSize: '14px',
                      fontWeight: '800',
                    }} >Patient</label>
                    <b className="flexDiv"><img src={Icons[0].locationIcon} style={{ width: '20px' }} />Home</b>
                  </li>
                  <li style={{
                    marginRight: '5px',
                    display: 'grid',
                    gridTemplateColumns: '100%',
                    fontSize: '14px',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <label style={{
                      fontSize: '14px',
                      fontWeight: '800',
                    }} >Communication</label>
                    <b>Audio & Video</b>
                  </li>

                  <li style={{
                    marginRight: '5px',
                    display: 'grid',
                    gridTemplateColumns: '100%',
                    fontSize: '14px',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <label style={{
                      fontSize: '14px',
                      fontWeight: '800',
                    }} >Duration</label>{" "}
                    <b>{calculateDuration(selectedZoomMeet.start_ts, selectedZoomMeet.end_ts)}  </b>
                  </li>
                  <li style={{
                    marginRight: '5px',
                    display: 'grid',
                    gridTemplateColumns: '100%',
                    fontSize: '14px',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <label style={{
                      fontSize: '14px',
                      fontWeight: '800',
                    }} >Verbal consent </label>{" "}
                    <b>Obtained</b>
                  </li>
                </>
                ) : null}




            </ul>
            {EmergencyQuest ? (<><p className="innerDivBox urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p></>) :
              (followSummaryEditAIChatbot || RecordData.chatbot_summary) ? (<>
                <h2 style={{ fontSize: '22px' }}>Summary

                  {!isGeneratingPdf && ( // Hide the "Copy All" button while PDF is generating
                    <button
                      className="copyclipBtn"
                      onClick={() => copyToClipboard(followSummaryEditAIChatbot || RecordData.chatbot_summary)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                    </button>
                  )}

                </h2>
                <div className="innerDivBox">{renderAISummary(followSummaryEditAIChatbot || RecordData.chatbot_summary)}</div> </>) : <p className="innerDivBox"> - </p>}
            <hr></hr>
            <h2 style={{ fontSize: '22px' }}>Differential Diagnosis
              {!isGeneratingPdf && ( // Hide the "Copy All" button while PDF is generating
                <button
                  className="copyclipBtn"
                  onClick={() => copyToClipboard(ConditionalDiagnosis)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                </button>
              )}


            </h2>

            {!showMainPointCD ? (
              <>
                {EmergencyQuest ?
                  <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p>
                  :
                  ConditionalDiagnosis ? <pre className="innerDivBoxPC">{ConditionalDiagnosis}</pre> : 'No Differential Diagnosis'}
              </>
            ) : (<></>)}
            <hr></hr>
            <h2 style={{ fontSize: '22px' }}>Plan of Care
              {!isGeneratingPdf && ( // Hide the "Copy All" button while PDF is generating
                <button
                  className="copyclipBtn"
                  onClick={() => copyToClipboard(PlanOnCareData)}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={Icons[0].copyclip} style={{ width: '18px' }} />
                </button>
              )}

            </h2>
            {!showMainPoint ? (
              <>
                {EmergencyQuest ? <p className="innerDivBoxPC urgentTxt"><img src={Icons[0].admin_icon911} /> Urgent: Patient has called for emergency assistance.</p> : PlanOnCareData ? <pre className="innerDivBoxPC">{PlanOnCareData}</pre> : 'No Plan On Care'}
              </>
            ) : (<></>)}

            {reportData && <>
              <hr></hr>
            </>}
            <div ref={hiddenDivRef}>
              {reportData && <>

                <h2 style={{ fontSize: '22px' }}>Reports

                  {/* <button className="copyclipBtn" 
                           onClick={handleCopy} 
                           style={{ cursor: 'pointer' }}> 
                                   <img src={Icons[0].copyclip} style={{width:'18px'}} />
                                </button> */}

                </h2>
              </>
              }



              <ol className="reportListOptLink" style={{ fontSize: '16px' }}>
                {sortedGroupedDocuments.length > 0 ? (
                  sortedGroupedDocuments
                    .filter(({ documents }) => documents && documents.length > 0) // Filter out empty or null documents
                    .map(({ doc_type, documents, Name }) => (
                      <li key={doc_type}>

                        {documents.map((doc, index) => (
                          <div key={doc.doc_id} style={{ marginBottom: "0px" }}>
                            <b
                              style={{
                                textTransform: "capitalize", textDecoration: "none", weight: '600', fontSize: '16px',
                                marginBottom: doc_type !== "other_report" ? "0px" : "10px",
                                display: doc_type !== "other_report" ? null : "inline-block"
                              }}
                              className={doc_type === "other_report" && index !== 0 && 'd-none'}>
                              {Name}
                              {/* {doc_type.replace('_', ' ')} */}
                            </b>
                            {/* Document URL with conditional button */}
                            {doc.doc_url && (
                              <span
                                className={
                                  "pdfButtonModal" + (doc_type === "other_report" ? " d-none" : "")
                                }
                              >
                                <button
                                  className="pdfButton pdfViewBtn"
                                  onClick={() => openModal(doc?.doc_url)}
                                >
                                  View{" "}
                                  <img
                                    src={Icons[0].viewPDF}
                                    alt="PDF Icon"
                                    style={{ width: "24px", marginLeft: "10px" }}
                                  />
                                </button>
                              </span>
                            )}

                            {/* Document Text */}
                            {doc.doc_text && (
                              <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_text}</p>
                            )}
                            {/* PCP / Pharmacy — show doc_summary directly */}
                            {(doc_type === "pcp" || doc_type === "pharmacy") && doc.doc_summary && (
                              <p style={{ fontSize: '16px', marginBottom: "0" }}>{doc.doc_summary}</p>
                            )}

                            {doc_type === "other_report" && doc.doc_summary && doc.doc_summary !== "None" && (
                              <>
                                <h3 style={{ fontSize: "16px", marginTop: "14px", fontWeight: "600" }} className="my-0">
                                  {index + 1}. Other Report Summary
                                </h3>
                                <pre style={{ margin: "5px 0", textTransform: "capitalize" }}>
                                  {doc.doc_summary}
                                </pre>
                              </>
                            )}

                            {/* Conditional Divider */}
                            {doc.doc_url && (
                              <hr className={doc_type !== "other_report" ? " d-none" : ""} />
                            )}
                          </div>
                        ))}
                      </li>
                    ))
                ) : (
                  <p style={{ textAlign: "center" }}>No reports found</p>
                )}
              </ol>
            </div>



            {/* Provider Signature Block */}
            <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '2px solid #dee2e6' }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '30px',
                alignItems: 'end'
              }}>
                {/* Provider Name */}
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '4px' }}>Provider Name</div>
                  <div style={{ fontSize: '14px', fontWeight: '700', borderBottom: '1px solid #333', paddingBottom: '6px', minHeight: '28px' }}>
                    {reportProviderName}
                  </div>
                </div>
                {/* Date */}
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '4px' }}>Date</div>
                  <div style={{ fontSize: '14px', fontWeight: '700', borderBottom: '1px solid #333', paddingBottom: '6px', minHeight: '28px' }}>
                    {moment().format('MMM DD, YYYY')}
                  </div>
                </div>
                {/* Signature */}
                <div>
                  <div style={{ fontSize: '11px', color: '#6c757d', fontWeight: '600', textTransform: 'uppercase', marginBottom: '4px' }}>Signature</div>
                  <div style={{ borderBottom: '1px solid #333', paddingBottom: '6px', minHeight: '52px', display: 'flex', alignItems: 'flex-end' }}>
                    {reportProviderSignature
                      ? <img src={reportProviderSignature} alt="Signature" style={{ maxHeight: '48px', maxWidth: '180px', objectFit: 'contain', display: 'block' }} />
                      : null}
                  </div>
                </div>
              </div>
            </div>

            {/* Render PDF or Image based on file type */}
          </div>
          <div className="p-3 d-none11">
            <h2 style={{ fontSize: '22px' }}>Select Assessment and Plan</h2>
            <ul className="standardPerecautionList">
              {/* {fileArray.map((file) => (
                  <li key={file.id}>
                    <input
                      type="checkbox"
                      id={`file-${file.id}`}
                      onChange={() => handleCheckboxChange(file.id)}
                    />
                    <label htmlFor={`file-${file.id}`}>{file.fileName}</label>
                  </li>
                ))} */}
              {fileArray.map((file) => (
                <li key={file.id}>
                  <input
                    type="checkbox"
                    id={`file-${file.id}`}
                    onChange={() => handleCheckboxChange(file)}
                    checked={!!selectedFiles.find((f) => f.id === file.id)}
                  />
                  <label htmlFor={`file-${file.id}`}>{file.fileName}</label>
                </li>
              ))}

            </ul>
          </div>
          <div className="buttonDivBox">
            <button className="copyAllclipBtn" onClick={() => handleCopyAll()} style={{ cursor: 'pointer' }}>
              <img src={Icons[0].copyclip} style={{ width: '18px' }} /> Copy All
            </button>
            <button className="copyAllclipBtn shareBtn" onClick={(event) => handleSharetoPatient(event, fullName, selectedFiles, email)} style={{ cursor: 'pointer' }}>
              <img src={Icons[0].shareBtn} style={{ width: '18px' }} />
              {isLoadingEmailP ? "Sending..." : "Email to Patient"}
            </button>
            <button className="copyAllclipBtn" onClick={() => downloadPdfNew(fullName, selectedFiles)} style={{ cursor: 'pointer' }}>
              {/* <img src={Icons[0].downloadBtn} style={{ width: '18px' }} /> */}
              Download
            </button>
          </div>
          {/* <button
                                       onClick={() => handleShareBtn(fullName, selectedFiles)}
                                      
                                       className="shareBtn  "
                                      >  <img src={Icons[0].shareBtn } /> Share
                                    </button>  */}
          <div className="shareReportDiv">
            <h2>Send report others via email
              {/* Share Patient Report */}
            </h2>
            <form className="d-grid justify-content-center align-items-start ">
              <span className="d-grid">
                <span className=" shareReportInputDiv">
                  <input
                    type="text"
                    value={emailList}
                    //value={[...shareEmail, emailList].join(", ")}
                    onChange={handleEmailChange}
                    onFocus={handleInputFocus}
                    onPaste={handlePaste}
                    autoComplete="off"
                    placeholder="Enter email addresses"
                    style={{ borderColor: errorShare ? "red" : "initial" }}
                  />
                  <button style={{ width: "80px" }} onClick={addEmailsToList}>Add</button>
                </span>

                {/* Display the emails in the list */}
                {shareEmail.length > 0 && (
                  <div className="d-grid w-100">
                    <strong>Email send to:</strong>
                    <p className="d-grid" style={{ width: '400px', margin: 'auto' }}>{shareEmail.join(", ")}</p> {/* Show the list of emails */}
                  </div>
                )}

                {errorShare.email && <span className="errorTxt" >{errorShare.email}</span>}
              </span>
              <button
                //  onClick={() => handleShareBtn(fullName, selectedFiles)}    
                onClick={(event) => handleShareBtn(event, fullName, selectedFiles)}
                className="shareBtn "
              >  <img src={Icons[0].shareBtn} style={{ width: "24px" }} />
                {isLoadingEmail ? "Sending..." : "Send Email"}
              </button>
            </form>

          </div>
        </div>
      </Modal>

      {/* Final Note File Picker Modal */}
      <Modal
        isOpen={showFinalNoteFileModal}
        onRequestClose={() => { setShowFinalNoteFileModal(false); setPreviewFileUrl(null); }}
        style={{
          content: {
            maxWidth: previewFileUrl ? '900px' : '500px',
            maxHeight: '80vh',
            margin: 'auto',
            borderRadius: '12px',
            padding: '24px',
          },
          overlay: { backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999 },
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '18px', margin: 0 }}>Select Assessment & Plan Files</h2>
          <button onClick={() => { setShowFinalNoteFileModal(false); setPreviewFileUrl(null); }}
            style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#999' }}>&times;</button>
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          <div style={{ flex: previewFileUrl ? '0 0 300px' : '1', maxHeight: '55vh', overflowY: 'auto' }}>
            {fileCategories.map((cat) => (
              <div key={cat.category} style={{ marginBottom: '12px' }}>
                <div style={{ fontSize: '13px', fontWeight: '700', color: '#024C9C', padding: '6px 0', borderBottom: '2px solid #024C9C', marginBottom: '6px' }}>
                  {cat.category}
                </div>
                {cat.files.map((file) => {
                  const isSelected = !!selectedFinalNoteFiles.find((f) => f.id === file.id);
                  return (
                    <div key={file.id} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '6px 10px', marginBottom: '3px', borderRadius: '5px',
                      background: isSelected ? '#e8f0fe' : '#f8f9fa',
                      border: isSelected ? '1px solid #024C9C' : '1px solid #eee',
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => handleFinalNoteFileToggle(file)}
                          style={{ cursor: 'pointer' }}
                        />
                        <span style={{ fontSize: '12px', fontWeight: isSelected ? '600' : '400' }}>{file.fileName}</span>
                      </div>
                      <button
                        type="button"
                        onClick={() => setPreviewFileUrl(previewFileUrl === file.url ? null : file.url)}
                        style={{
                          background: 'none', border: 'none', color: '#024C9C',
                          fontSize: '11px', cursor: 'pointer', textDecoration: 'underline',
                        }}
                      >
                        {previewFileUrl === file.url ? 'Close' : 'Preview'}
                      </button>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          {previewFileUrl && (
            <div style={{ flex: 1, borderLeft: '1px solid #eee', paddingLeft: '16px' }}>
              <iframe
                src={previewFileUrl}
                title="File Preview"
                style={{ width: '100%', height: '55vh', border: '1px solid #ddd', borderRadius: '6px' }}
              />
            </div>
          )}
        </div>
        <div style={{ marginTop: '16px', textAlign: 'right' }}>
          <button
            type="button"
            onClick={() => { saveFinalNoteFiles(selectedFinalNoteFiles); setShowFinalNoteFileModal(false); setPreviewFileUrl(null); }}
            style={{
              padding: '8px 20px', background: '#024C9C', color: '#fff',
              border: 'none', borderRadius: '8px', fontSize: '14px',
              fontWeight: '600', cursor: 'pointer',
            }}
          >
            Save & Done
          </button>
        </div>
      </Modal>

    </div>
  );
}

export default ViewPatientProfile;